export const agendaSessions = [
    {
        "id": "UGxhbm5pbmdfMTg4ODcxMg==",
        "titleTranslations": [
            {
                "value": "Registration",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 08:00:00",
        "endsAt": "2024-04-29 12:30:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
        "titleTranslations": [
            {
                "value": "Global Restaurant Investment Forum - Welcome",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 09:00:00",
        "endsAt": "2024-04-29 09:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/-YW5IntyT78?si=IKgKhGwHegfGdMNE\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jennifer",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NDg4MjIxLFVzZXJfMTgyMTg1NTEp",
                "jobTitle": "Co-Founder, Global Restaurant Investment Forum",
                "lastName": "Pettinger-Haines",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
                "organization": "Partner, THINK Hospitality",
                "biography": "Since joining the Bench team in 2008, Jennifer has been an integral part of growing the events portfolio. In 2013 she introduced the Arabian Hotel Investment Conference (AHIC) Regional Briefings Series, expanding AHIC’s presence throughout the region and in 2014 launched the Global Restaurant Investment Forum (GRIF) in Dubai. When not at a conference bossing around the hotel industry’s movers and shakers, Jennifer is working tirelessly to bring hotel and restaurant Attendeess scintillating conference sessions. During her time with Bench, she has amassed a large number of air miles, running conferences on most continents. In doing so she has taken full advantage of exploring the shopping, nightlife and restaurants on offer from Kigali to Casablanca as she firmly believes the world is there to be explored. One of her proudest achievements is being a part of the Bench Mt Kili Madness team which broke the World Record for the highest game of cricket ever played raising over £200,000 for charity. Currently residing in Dubai she has lived on four continents but will always call Sydney home.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
                                    "title": "Global Restaurant Investment Forum - Welcome",
                                    "beginsAt": "2024-04-29 09:00:00",
                                    "endsAt": "2024-04-29 09:10:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                                    "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                                    "beginsAt": "2024-04-30 10:00:00",
                                    "endsAt": "2024-04-30 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                                    "title": "Bringing Riyadh’s culinary heritage back to life",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDkzOA==",
        "titleTranslations": [
            {
                "value": "GRIF Intelligence - Understanding the Saudi Consumer - The New Codes of Luxury: Harnessing hospitality opportunities in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 09:10:00",
        "endsAt": "2024-04-29 09:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/4NGUzwZYVvU?si=H6wPs9WOSxdaMai6\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Martin",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NDgxMjc4LFVzZXJfMTgyMTQyNjUp",
                "jobTitle": "Co-Founder, The Future Laboratory",
                "lastName": "Raymond",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4752c911000848768031f357a2332047.jpeg",
                "organization": "Editor-in-Chief, LS:N Global",
                "biography": "Martin Raymond is co-founder of The Future Laboratory and editor-in-chief of LS:N Global. Martin is a well-known trend guru, having written several best-selling books on trend forecasting, including The Trend Forecaster’s Handbook and The Tomorrow People. Martin contributes regularly as an expert on trends and business for the BBC, Channel 4 and ITV.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOA==",
                                    "title": "GRIF Intelligence - Understanding the Saudi Consumer - The New Codes of Luxury: Harnessing hospitality opportunities in Saudi Arabia",
                                    "beginsAt": "2024-04-29 09:10:00",
                                    "endsAt": "2024-04-29 09:40:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Christopher",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4Mzk0MTMzLFVzZXJfMTgxNjI4MDYp",
                "jobTitle": "Co-Founder",
                "lastName": "Sanderson",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/93258c18465e4da1a567359699c2b016.jpeg",
                "organization": "The Future Laboratory",
                "biography": "Christopher Sanderson is co-founder of The Future Laboratory, where he is responsible for delivering the company‘s extensive global roster of conferences, media events and Trend Briefings, which he presents in London, New York, Sydney, Melbourne and around the world.\n\nClients who have booked one of his inspirational keynotes include luxury group Kering, the European Travel Commission, Retail Week, Selfridges, Marks & Spencer, Chanel, Harrods, Aldo, H&M, General Motors, BBDO, Design Hotels, Condé Nast Media and Omnicom.\n\nChris presented Channel 4 TV’s five-part series Home of the Future and is a SuperBoard member of The British Fashion Council’s Fashion Trust.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOA==",
                                    "title": "GRIF Intelligence - Understanding the Saudi Consumer - The New Codes of Luxury: Harnessing hospitality opportunities in Saudi Arabia",
                                    "beginsAt": "2024-04-29 09:10:00",
                                    "endsAt": "2024-04-29 09:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
        "titleTranslations": [
            {
                "value": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 09:40:00",
        "endsAt": "2024-04-29 10:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Lb0Xx6wlhwc?si=MHQsQY36HquOCdKa\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Christopher Sanderson,</strong> Co-founder, The Future Laboratory </p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Michael",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMjc3LFVzZXJfMTczOTA0Nzkp",
                "jobTitle": "Chief Business Development Officer",
                "lastName": "Flanagan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d2a99d425306444c9f11e30155a7913b.jpeg",
                "organization": "Al Khozama Investment Company",
                "biography": "Michael Flanagan joined Al Khozama in 2015, bringing more than 20 years of expertise in Real Estate Development, Private Equity and Investment Banking to his role.\n\nHe leads the Investments and Business Development function in order to maximize the efficiency of each of all assets and ensure they all produce solid IRR & ROI metrics along with strong revenue, profitability & growth YoY.\n\nMichael has been responsible for the negotiation and bringing to KSA multiple international renowned brands, such as Yauatcha, LPM, MAMO, Mandarin Oriental Hotel, Mastro’s, Dinings SW3, Gordon Ramsay, Jason Atherton, Richemont and Apples Head Office in the Kingdom. He has extensive contacts and links with major retailers across US, Europe and Asia.\n\nDuring his time in KSA, Michael has raised over SR 3.5 Billion of capital, and works closely with banks, both local and international, private equity firms and hedge funds to evaluate investment opportunities across multiple asset classes, with a predominant focus on F&B, Hospitality and alternative investments\n\nMichael earned his degree in Aeronautics and Mathematics in Warwick University and was an Investment Banker at Morgan Stanley in London. He also holds several Advisory Board positions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Christopher",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4Mzk0MTMzLFVzZXJfMTgxNjI4MDYp",
                "jobTitle": "Co-Founder",
                "lastName": "Sanderson",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/93258c18465e4da1a567359699c2b016.jpeg",
                "organization": "The Future Laboratory",
                "biography": "Christopher Sanderson is co-founder of The Future Laboratory, where he is responsible for delivering the company‘s extensive global roster of conferences, media events and Trend Briefings, which he presents in London, New York, Sydney, Melbourne and around the world.\n\nClients who have booked one of his inspirational keynotes include luxury group Kering, the European Travel Commission, Retail Week, Selfridges, Marks & Spencer, Chanel, Harrods, Aldo, H&M, General Motors, BBDO, Design Hotels, Condé Nast Media and Omnicom.\n\nChris presented Channel 4 TV’s five-part series Home of the Future and is a SuperBoard member of The British Fashion Council’s Fashion Trust.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOA==",
                                    "title": "GRIF Intelligence - Understanding the Saudi Consumer - The New Codes of Luxury: Harnessing hospitality opportunities in Saudi Arabia",
                                    "beginsAt": "2024-04-29 09:10:00",
                                    "endsAt": "2024-04-29 09:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hicham",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDYyNTY4LFVzZXJfMTU3NTczMTUp",
                "jobTitle": "Chief Strategy & Business Development Officer",
                "lastName": "Hassouni",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d1f3ad2cb0074368988c7bc07cb88071.jpeg",
                "organization": "Boutique Group",
                "biography": "Hicham Hassouni is the Chief Strategy & Business Development Officer at Boutique Group, a hospitality company fully owned by Saudi Arabia’s Public Investment Fund.\n\nIn his current role, Hassouni is dedicated to elevating standards with strategic insights and an innovative approach to drive growth and contribute to the Boutique Group’s continued success. With a sharp understanding of market trends and a customer-focused mindset, he integrates analytical thinking with an unwavering commitment for the hospitality industry.\n\nHassouni has more than two decades of experience in the ultra-luxury hospitality and real estate sectors across Europe, the Middle East and Africa. He previously held leadership positions and advisory roles at top-tier companies, including MEA and Indian Ocean Vice-President at Rosewood Hotel Group and Vice-President of MEA for luxury brands at AccorHotels. Hassouni also served in key roles at Jones Lang LaSalle as the Vice President of Hotels, and Senior Manager and Member of the Executive Committee at Colliers International.\n\nHassouni holds a master’s degree in management from NEOMA Business School, an AMBA-accredited institution in France.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ada",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzODE2LFVzZXJfMTgxNjI1OTgp",
                "jobTitle": "Regional CEO, Middle East",
                "lastName": "Renedo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/453b9480592b410ca87fcc883ad8c863.png",
                "organization": "Together Group",
                "biography": "With her entrepreneurial mindset and deep experience of the market, Regional CEO Ada Renedo brings together transformative brand expertise by curating the world’s best talent to support business and brand creation, evolution and success in the region for Together Group.\n\nAda has more than 10 years experience in the United Arab Emirates and Saudi Arabia, and 15 years experience as a luxury brand leader working in the US and the Middle East. She has managed large scale portfolios of globally-acclaimed hospitality and F&B brands, including Jumeirah Group, and has been on the executive teams of both innovative start-ups and global corporations.\n\nAda’s knowledge of and passion for the region led to a desire to deliver the Kingdom a new kind of creative services model – curating the best in class in every class. Through Ada, the Middle East’s most discerning brands and businesses can access the world’s best creative talent built for the luxury sector.\n\nTogether Group is a curated collective of high-quality creative consultancies, marketing, technology and production studios crafting the future of luxury and lifestyle. The portfolio includes The Future Laboratory, Purple, Construct, Noë & Associates, King & Partners, North Six, Folk, Hot Pot China and Seven Dials City.\n\nTogether we create and elevate brands, experiences and destinations through our profound understanding of luxury consumer desires, imaginative and immersive storytelling, meticulous design of experiences and innovative use of technology. \nOur vibrant community of thinkers, makers and innovators are connected by a relentless cultural curiosity, commitment to excellence and shared passion for delivering meaningful and lasting value for our clients. \n\nTogether Group’s Middle East HQ, based in Riyadh, provides a seamless experience, executive management and strategic insight in harmony with a regional context and a vision to shape the future of luxury in the region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                                    "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                                    "beginsAt": "2024-04-29 12:15:00",
                                    "endsAt": "2024-04-29 12:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDk0MA==",
        "titleTranslations": [
            {
                "value": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 10:10:00",
        "endsAt": "2024-04-29 10:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/NGM7pAukzsM?si=AVfaZihqvB3zDyrF\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Simon",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDYxMTU0LFVzZXJfMTg3ODU2OTgp",
                "jobTitle": "Founder & Chairman",
                "lastName": "Wright",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e28c84ddb2a418095833b23a57d14fc.jpeg",
                "organization": "TGP International",
                "biography": "Simon has a career spanning over 35 years in the hospitality industry working in KSA, Beirut, Dubai, London, Paris and Sydney, and with such companies as Inter-Continental Hotels, Conran Restaurants and Ian Schrager Hotels.\n\nSimon formed TGP International in 2002 and since then company has carried out operational advisory work, concept development and design work for such companies as Hilton International, Intercontinental Hotels, Harrods, Marriott International, St Regis Hotels, Accor, Selfridges and The Dorchester Collection as well as carrying out advisory contracts in KSA, Qatar, Kuwait, the UAE and all over the Middle East, Europe and the US, and has supported the licensing development of brands such as Sushi Samba, Asia de Cuba, and Scarpetta.\n\nSimon also headed up the TGP team as the overall F&B consultant and advisor to Expo 2020 Dubai with oversight of over 200+ F&B offers encompassing interior design, conceptualizing, marketing and commercial management.\n\nSimon and the TGP team started delivering projects in KSA in 2013, predominantly in Jeddah and Riyadh, with support on design, concept development and franchising deals. From 2016-2021 Simon helped take the Sisban/Trofi group from 3 sites in Jeddah to over 100 sites in 6 countries, including Over Jar, Habra, Lunch Room and Khayal, before moving back to focus on TGP.\n\nTGP International’s latest project opening is Al Mamlaka Social Dining in the Kingdom Centre, a first-of-its-kind 37,000sq-ft luxury food hall which unites Saudi culture, alongside global food and beverage concepts. Welcoming more than 7,000 visitors per day since its recent opening, Al Mamlaka Social Dining boasts richly immersive and interactive dining experiences, spanning 21 masterful kitchens, 8 new-to-market brands and 5 award-winning chefs.\n\nOther current KSA projects include leading the retail, dining and entertainment strategy for a Qiddiya district; repositioning of F&B entertainment, leisure & wellness for the Ritz Carlton in Riyadh & Jeddah; the development of global expansion of the Saudi Coffee Company and F&B masterplanning for the King Abdulaziz Center for World Culture – Ithra - in Dhahran, restructuring their food & beverage, retail and venue hire offerings.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk0MA==",
                                    "title": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                                    "beginsAt": "2024-04-29 10:10:00",
                                    "endsAt": "2024-04-29 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0NA==",
                                    "title": "Partnerships that work - Leveraging Saudi expertise for global growth",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Talar",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0ODE2LFVzZXJfMTkwNDcyMzMp",
                "jobTitle": "Senior Manager Leasing – Retail Development",
                "lastName": "Keshishian",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9c97616c746f4003b83cbace862bf597.jpeg",
                "organization": "Red Sea Global",
                "biography": "Talar Keshishian is the Senior Leasing Manager at Red Sea Global (RSG), a closed joint stock company wholly owned by the Public Investment Fund (PIF), Saudi Arabia's sovereign wealth fund. \n\nTalar leads the leasing for The Red Sea and AMAALA, two exceptional, regenerative tourism destinations that aim to set new standards in sustainable development and put Saudi Arabia on the global tourism map. \n\nShe is responsible for overseeing all aspects of leasing (develop leasing plans, identify new tenants, ensure the best tenant mix is achieved in line market trends).\n\nTalar has over 15 years of experience in Leasing and Retail Management. She has worked extensively with the major International Retailers and top Saudi Real Estate Developers. \n\nPreviously, Talar was Leasing Manager at HAMAT and Al Khozama, in addition to her extensive retail background with AZADEA Group.\n\nMasters Degree in Strategy and Management\nGraduate Degree in Business Administration",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk0MA==",
                                    "title": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                                    "beginsAt": "2024-04-29 10:10:00",
                                    "endsAt": "2024-04-29 10:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Vikram",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTAxLFVzZXJfMTkwMzkxMDQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Natarajan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/852e440e483f4ee18b5921d9b2cb299e.jpeg",
                "organization": "Kayanee",
                "biography": "An experienced CEO with a strong track record of success spanning over 22 years in the Health & Wellness, Lifestyle, Hospitality, and Consulting across South-East Asia, Mainland China, and the Middle East.\n \nThroughout my career, I have excelled in building and growing entrepreneurial startups, leading large and diverse teams across geographies, and driving business performance through effective strategies and digital innovation. Currently, I hold the position of CEO at Kayanee, a portfolio company under the Public Investment Fund of Saudi Arabia. Kayanee is a unique lifestyle integrated concept that aims to inspire and enhance women's well-being in Saudi Arabia. Our focus at Kayanee is on women's health and lifestyle through six offerings: fitness, apparel, personal care, nutrition & diagnostics, healthy eating, and learning. Over the course of my career, I have also worked in the Health, Wellness, Personal Care, and Healthy Eating industries, gaining extensive insights and expertise. My areas of specialization include building and leading large teams, developing long-term strategies, driving business performance, implementing successful turnarounds, leading digital transformation initiatives, and fostering a culture of continuous innovation.\n \nWith an MBA from INSEAD (France) in 2007 and a full-scholarship Computer Engineering Degree from NTU (Singapore) in 2001, in recognition of my leadership potential, I was honored with the \"Future Leader\" Award by the President of India, Dr. APJ Abdul Kalam. Furthermore, my industry expertise, people management skills, business acumen, and entrepreneurial spirit have been acknowledged through media features in CNBC, Straits Times, Channel NewsAsia, and HRM Asia magazine.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk0MA==",
                                    "title": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                                    "beginsAt": "2024-04-29 10:10:00",
                                    "endsAt": "2024-04-29 10:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Madan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTE0NzkwLFVzZXJfMTkwNTI5MDkp",
                "jobTitle": "Director of Finance",
                "lastName": "Manjeshwar",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/98f78b7a3f0d49a4b53db9adb3f8bd45.jpeg",
                "organization": "AlMoajil Hospitality",
                "biography": "A seasoned Hospitality professional with proven, varied experience in the hotel and restaurant trade, specifically within the Finance and Operation domains. \n\nPrevious experience includes working for Hotel Owners within the GCC region representing leading international hotel chains and restaurant brands. \n\nWorked last 4 years with AlMoajil Hospitality as part of the team to create fine dining experiences and cafes.\n\nClosely and keenly watch, reference and analyze the trends in hospitality industry, specifically F&B within the GCC and in Saudi Arabia.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk0MA==",
                                    "title": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                                    "beginsAt": "2024-04-29 10:10:00",
                                    "endsAt": "2024-04-29 10:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
        "titleTranslations": [
            {
                "value": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 10:50:00",
        "endsAt": "2024-04-29 11:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/sQoX94H4ff8?si=m74DKBsJpT4hmUoE\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gustavo De",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMTQ3LFVzZXJfMTU3NTcyOTMp",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Hostos",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7f3d496d1fa84a62b29c020bff30bed5.jpeg",
                "organization": "Forsite Creative",
                "biography": "Gustavo is the Founder and Managing Partner of Forsite Creative. He has worked on approximately 200 projects across Europe, the Middle East, and Africa over the past 12 years of which 10 years in the region.\n\nWith a strategic mind, operational background, and an eye for design; he manages several in-house multi-disciplinary teams (including Research, Data Analytics, Concept Developers, Interior Designers, Branding and Kitchen Designers) for coordinated end-results.\n\nToday Gustavo and his team work together with leading restaurant groups, hotel groups, but also work with real estate developers and government initiatives.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
                                    "title": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                                    "beginsAt": "2024-04-29 10:50:00",
                                    "endsAt": "2024-04-29 11:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxMjIyNw==",
        "titleTranslations": [
            {
                "value": "TENX Leadership Talks: Mohammed Islam, Host & Founder, The Mo Show Podcast, one on one with Mohammed Jawa, Founder and Chairman, MJS Holding on The future of Saudi’s restaurant market. How is the market diversifying and what is the long term vision?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:05:00",
        "endsAt": "2024-04-29 11:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/1mfKK6JCeyY?si=zZQF2CwqmhFoQSik\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMzU2LFVzZXJfMTYwNTg3NjEp",
                "jobTitle": "Founder & Chairman",
                "lastName": "Jawa",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4624c1bfeab94dbab4187b9803955adc.jpeg",
                "organization": "MJS Holding",
                "biography": "Mohammed has 20 years of experience owning and operating renowned restaurants, being the first to attract international luxury and lifestyle restaurants to the kingdom from all across the world .\n\nJawa is creating a new era in the F&B market with his goal and motive to make Saudi Arabia a leading restaurant scene globally , Making sure to support and be part of “Saudi Arabia’s Vision for 2030”.\n\nBeing the first partner of the Azumi group (Zuma,Roka,Oblix,Inko Nito), Paris Society group and other international restaurants such as Mr.Chow, Amazonico and other international renowned brands, will add a new dimension and expertise to the future of Saudi hospitality .\n\n“It has always been a dream to see the Kingdom at this point in its development; with such an elite group of F&B professionals shaping the future of hospitality in Saudi Arabia”",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkxMjIyNw==",
                                    "title": "TENX Leadership Talks: Mohammed Islam, Host & Founder, The Mo Show Podcast, one on one with Mohammed Jawa, Founder and Chairman, MJS Holding on The future of Saudi’s restaurant market. How is the market diversifying and what is the long term vision?",
                                    "beginsAt": "2024-04-29 11:05:00",
                                    "endsAt": "2024-04-29 11:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MzA3NzMzLFVzZXJfMTIzODY4ODIp",
                "jobTitle": "Host & Founder",
                "lastName": "Islam",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2a41038717d84318b27a383e0a8a13fb.jpeg",
                "organization": "The Mo Show Podcast Saudi Arabia",
                "biography": "Mohammed Islam is the Host & Founder of Saudi Arabia’s leading English podcast, The Mo Show, which is currently in its fourth season. The show aims to break stereotypes and misconceptions by shedding light on the progression and accomplishments of the country, told by those on the ground who share their personal stories and experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxMjIyNw==",
                                    "title": "TENX Leadership Talks: Mohammed Islam, Host & Founder, The Mo Show Podcast, one on one with Mohammed Jawa, Founder and Chairman, MJS Holding on The future of Saudi’s restaurant market. How is the market diversifying and what is the long term vision?",
                                    "beginsAt": "2024-04-29 11:05:00",
                                    "endsAt": "2024-04-29 11:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNzc1Mg==",
        "titleTranslations": [
            {
                "value": "Short Coffee break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:20:00",
        "endsAt": "2024-04-29 11:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzE0MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-luxury",
                "translations": [
                    {
                        "value": "Wellness"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Restaurant Invest",
            "Wellness"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc4MjkzMg==",
        "titleTranslations": [
            {
                "value": "USALI 11th Edition – Tips and Tricks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:30:00",
        "endsAt": "2024-04-29 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Giuliano",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNTc1LFVzZXJfMTI2MzY3MzQp",
                "jobTitle": "Head of Hospitality Asset Management",
                "lastName": "Gasparini",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1185b82f30fb4c59b01dd92aafdcf851.jpeg",
                "organization": "WASL / Dubai Real Estate Corporation",
                "biography": "Giuliano Gasparini is Head of Hospitality Asset Management at wasl / Dubai Real Estate Corporation being directly involved in the asset management of the hotel and leisure portfolio of the firm. Prior to that he covered several executive positions in the hospitality asset management teams of leading Middle Eastern developers (Associate Director of Hospitality Asset Management for Aldar Properties PJSC) and in specialized consulting firms having been Head of Consulting at PKF in Dubai, Senior Vice-President of JLL Hotels in Madrid and Senior Associate at HVS in Madrid amongst others. \nGiuliano Gasparini is one of the board members of HAMA MEA (Hotel Asset Managers Association) and a full-time professor at both Paris Sorbonne Abu Dhabi and IE Business School in Madrid. He holds affiliation at the Royal Institution of Chartered Surveyors (FRICS), Counsellor of Real Estate (CRE©) and Institute of Hospitality (FIH).\nGiuliano graduated in Economics at Bocconi University in Italy and hold two master degrees: in Urban Economics (by Erasmus University Rotterdam in the Nederland’s) and in Tourism Economics (by Bocconi University in Italy). He also completed a post-graduate certificate on Hotel Asset Management from Cornell University (USA).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkzMg==",
                                    "title": "USALI 11th Edition – Tips and Tricks",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDMwNA==",
        "titleTranslations": [
            {
                "value": "Unlocking the culinary potential of Saudi’s secondary and tertiary cities - helping Saudis discover Saudi through the power of culture and food",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:30:00",
        "endsAt": "2024-04-29 11:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/_CcUg307syA?si=nvdh-OptTvEcRYO1\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Jana Bader, </strong>Advisor, The Bench</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDI4MzgxLFVzZXJfMTMwMzE5Nzcp",
                "jobTitle": "Advisor",
                "lastName": "Bader",
                "photoUrl": "https://static.swapcard.com/public/images/c7a4cf6c87574c7cb8a30a99afcb55e2.png",
                "organization": "the bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMzMQ==",
                                    "title": "TenX Leadership Talks: Embracing Holistic Living: Exploring Sustainable Solutions for Urban Lifestyles",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDMwNA==",
                                    "title": "Unlocking the culinary potential of Saudi’s secondary and tertiary cities - helping Saudis discover Saudi through the power of culture and food",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 11:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Nawal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODMxNDI5LFVzZXJfMTkwMDQyNDIp",
                "jobTitle": "Founder & CEO",
                "lastName": "AlKhalawi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/000a7f217fcb45009a6c5bc62eeae305.jpeg",
                "organization": "Asfar Experience",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDMwNA==",
                                    "title": "Unlocking the culinary potential of Saudi’s secondary and tertiary cities - helping Saudis discover Saudi through the power of culture and food",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 11:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mawadah",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMTc2NzI5LFVzZXJfMTI1NzUyNzcp",
                "jobTitle": "Food Innovator and Researcher",
                "lastName": "Bajrai",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/627fda7deeb84336a92975e6c40c28fc.jpeg",
                "organization": "",
                "biography": "Mawadah Bajrai is a Saudi food innovator and food sciences communicator focused on research, innovation and edutainment. She gained her bachelor’s degree in Food Innovation from the Technological University Dublin. During her time at university, she developed a training protocol for a sensory analysis method, which earned her the Redbrooks Best Food Innovation Research Award. Nominee and winner of the 2019 Saudi FDA Digital Food and Drug Incubator Hackathon and co-author in a scientific publication, Mawadah believes that the true value of knowledge lies in sharing it. Food is a source of joy and nutrition, and so she strives to bridge the gap between the science of food and the art of cooking. As a true culinary enthusiast, Mawadah completed professional culinary training at Le Cordon Blue London in 2022.  And is currently working on several projects simultaneously that promote innovation and Saudi culinary arts.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDMwNA==",
                                    "title": "Unlocking the culinary potential of Saudi’s secondary and tertiary cities - helping Saudis discover Saudi through the power of culture and food",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 11:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTkxNzQ1MQ==",
        "titleTranslations": [
            {
                "value": "GRIF Signing Ceremony",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:45:00",
        "endsAt": "2024-04-29 12:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDQ2Mw==",
        "titleTranslations": [
            {
                "value": "Digital Evolution in F&B and Hospitality: Leveraging Influencer and Gaming Trends for the Next Five Years",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 11:50:00",
        "endsAt": "2024-04-29 12:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/5mQCfYyFnaw?si=xgv6cz5DBuvPT_51\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Georgie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDYzNDY1LFVzZXJfMTQzNjUzNyk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Woollams",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f919d7764b18472e83cfc5f1f6a661ef.jpeg",
                "organization": "Katch International",
                "biography": "Georgie Woollams is the Managing Director of Katch International, a dynamic consultancy renowned for its experiential PR and communications expertise that operates in Dubai, London, and Riyadh. With over two decades of global experience in the field, Georgie spearheads a diverse range of services spanning traditional and digital communication realms, including public relations, social media management, branding, and digital marketing.\n\nFor the past 8 years, the agency has been actively working in the KSA market, notably aligning Live Nation Middle East with the General Entertainment Authority to bring iluminate to Jeddah and handling the PR, social media, and integrated communications for BTS' historic live show at King Fahd International Stadium in Riyadh. \n\nIn addition to its achievements in entertainment, Katch International boasts a rich portfolio in the hospitality domain, evidenced by its handling of the brand launch for Lewis Hamilton's Neat Burger, the world's first plant-based sustainable burger chain, the relaunch of At.mosphere, the iconic dining destination located on the 122nd floor of the Burj Khalifa, and its collaboration with talented chefs including Pierre Gagnaire, Greg Malouf, and Yann Bernard Lejard of La Table Krug by Y. Currently, Katch International works closely with the renowned Address Jabal Omar Makkah and recently took charge of the launch of Pierre Hermé Paris at Four Seasons Hotel Riyadh as well as launching Atlantis The Royal. \n\nKatch International's portfolio includes collaborations with renowned clients such as Emaar, Expo 2020, FIFA World Cup, F1, Armani Hotel Dubai, BRAG, Rixos Hotels, W Abu Dhabi - Yas Island, UNTOLD Dubai, More Cravings by Marriott Bonvoy, Sunset Group Hyatt, Accor, Hilton, and many others, creating a series of compelling campaigns in the region. After launching Katch Disruption 6 years ago, Katch has now grown further to launch Katch Connects, a strategic alliance with experts around the world, offering clients across the Middle East services including sustainability, corporate crisis communications, in-game branding, international celebrity and KOL partnerships, as well as digital marketing communications and AI.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2Mw==",
                                    "title": "Digital Evolution in F&B and Hospitality: Leveraging Influencer and Gaming Trends for the Next Five Years",
                                    "beginsAt": "2024-04-29 11:50:00",
                                    "endsAt": "2024-04-29 12:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jasniya",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzY2NzI3LFVzZXJfMTY2NzcxMTgp",
                "jobTitle": "Co-Founder",
                "lastName": "Badsha",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/49c12d5057ae42eebb002bedfd2ecb0c.jpeg",
                "organization": "RiyadhConnect",
                "biography": "Jasniya Badsha is the Co-founder of RiyadhConnect, an online portal that boasts a social media reach of over 30 Million, with half a million followers on Facebook, a quarter million followers on Instagram, and a rapidly growing 100,000 followers on TikTok.\n\nRiyadhConnect connects Hospitality with Social Media Success.  The team develops engaging content strategies that resonate with local audiences, showcasing unique experiences offered by industry leaders like Hilton, Kempinski, Crowne Plaza, W Hotels, Ritz-Carlton, Sheraton, Four Seasons, Rotana, Le Meridien, Marriott, Shaza Hotel and Hyatt.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2Mw==",
                                    "title": "Digital Evolution in F&B and Hospitality: Leveraging Influencer and Gaming Trends for the Next Five Years",
                                    "beginsAt": "2024-04-29 11:50:00",
                                    "endsAt": "2024-04-29 12:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Oli",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzY0NzEyLFVzZXJfMTg5NjU2Njcp",
                "jobTitle": "Founder",
                "lastName": "Thomas",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b3cdc73d91e7445891a75b6ffba552f7.jpeg",
                "organization": "Hatchin",
                "biography": "Oli is a media executive with extensive experience in creating digital experiences for youth and family audiences. As founder of Hatchin, he advises and supports early stage creative ventures working across a wide spectrum of innovative products and services. Additionally, he advises more established clients on building digital strategies to leverage new technologies and engage with younger demographics. Prior to this, he was the Chief Strategy Officer at Auddy, an international podcast network, and Vice President & Digital Lead at Paramount International (formerly ViacomCBS), where he led the digital business for MTV, Comedy Central and Nickelodeon in the UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMxNg==",
                                    "title": "Digital Talks: Strategic Potential - Mastering Digital Platforms",
                                    "beginsAt": "2024-04-30 09:20:00",
                                    "endsAt": "2024-04-30 09:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2Mw==",
                                    "title": "Digital Evolution in F&B and Hospitality: Leveraging Influencer and Gaming Trends for the Next Five Years",
                                    "beginsAt": "2024-04-29 11:50:00",
                                    "endsAt": "2024-04-29 12:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU3NQ==",
        "titleTranslations": [
            {
                "value": "Speed Networking",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 12:00:00",
        "endsAt": "2024-04-29 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzQ0NjQwMA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "al-omsiat-b",
                "translations": [
                    {
                        "value": "Al Omsiat B"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
        "titleTranslations": [
            {
                "value": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 12:15:00",
        "endsAt": "2024-04-29 12:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ESuGHgASc_M?si=hxF-1um0SlA05j5t\" target=\"_blank\">Click here to watch online</a></p><p><strong>Sam Bakhshandehpour, </strong>President and Board Member, JOSÉ ANDRÉS GROUP © in conversation with  <strong>Ada Renedo,</strong> Regional CEO of Together Group, Middle East</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sam",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTc4MjM3LFVzZXJfMTkwODMyNjYp",
                "jobTitle": "President & Board Member",
                "lastName": "Bakhshandehpour",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/46a16339843641dfae39ca89faaf369d.jpeg",
                "organization": "José Andrés Group (JAG)",
                "biography": "Sam Bakhshandehpour is the President and Board Member of José Andrés Group (JAG), a restaurant and media company. Driven by the mission of “Changing the world through the power of food,\" JAG's platform spans 38+ restaurants across 9 markets globally and multiple cuisines, including the 2-Michelin starred minibar by José Andrés, and numerous Michelin Bib Gourmand restaurants. Mr. Bakhshandehpour also runs José Andrés Media division (JAM) which produces food-related cultural content across scripted, unscripted - film and television, books (including The New York Times Best Seller Zaytinya), podcasts, and digital content. JAG also houses numerous global partnerships and a consumer products platform.\n\nThrough his hospitality investment platform, The Silverstone Companies, Mr. Bakhshandehpour has made numerous investments including The Electric Jane (membership community and live music lounge / restaurant), Cultivate Hospitality (F&B programming), Bazaar by José Andrés, and select other hotel, restaurant and lifestyle properties.\n\nNamed one of the “Most Important People in Hospitality” on the Observer’s 2023 Dining and Nightlife Power List, Mr. Bakhshandehpour previously served as President, Chief Executive Officer and Board Member of sbe Entertainment, a private-equity backed hotel, restaurant and nightlife company with over 80 properties globally.\n\nMr. Bakhshandehpour started his career on Wall Street with J.P. Morgan Securities running the Global Casino and West Coast Real Estate & Lodging Investment Banking practice focused on mergers & acquisitions and capital raising.\n\nMr. Bakhshandehpour holds a Bachelor of Science degree in Business Administration from Georgetown University’s McDonough School of Business. He serves on the board of Shift4 (NYSE: FOUR) and as a member of Fiserv Inc’s (NYSE: FI) Restaurant Advisory Board, including the Audit and Compensation Committees for both companies, as well as an Advisor for Bilt Technologies, Inc. Previously, Sam served on the boards of The New Home Company (NYSE: NWHM), including the Audit and Compensation Committees, and Georgetown University McDonough School of Business’ Board of Advisors as a Board Member and Capital Campaigns Committee Member. He is a trustee of Federal City Council (FC2), a founding member of the Georgetown Wall Street Alliance West, and a Senior Advisor to Montminy & Co., FINRA-registered (series 7, 24, 63). Mr. Bakhshandehpour is also an active member and former Chair of the Bel Air Chapter of the Young Presidents Organization.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                                    "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                                    "beginsAt": "2024-04-29 12:15:00",
                                    "endsAt": "2024-04-29 12:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ada",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzODE2LFVzZXJfMTgxNjI1OTgp",
                "jobTitle": "Regional CEO, Middle East",
                "lastName": "Renedo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/453b9480592b410ca87fcc883ad8c863.png",
                "organization": "Together Group",
                "biography": "With her entrepreneurial mindset and deep experience of the market, Regional CEO Ada Renedo brings together transformative brand expertise by curating the world’s best talent to support business and brand creation, evolution and success in the region for Together Group.\n\nAda has more than 10 years experience in the United Arab Emirates and Saudi Arabia, and 15 years experience as a luxury brand leader working in the US and the Middle East. She has managed large scale portfolios of globally-acclaimed hospitality and F&B brands, including Jumeirah Group, and has been on the executive teams of both innovative start-ups and global corporations.\n\nAda’s knowledge of and passion for the region led to a desire to deliver the Kingdom a new kind of creative services model – curating the best in class in every class. Through Ada, the Middle East’s most discerning brands and businesses can access the world’s best creative talent built for the luxury sector.\n\nTogether Group is a curated collective of high-quality creative consultancies, marketing, technology and production studios crafting the future of luxury and lifestyle. The portfolio includes The Future Laboratory, Purple, Construct, Noë & Associates, King & Partners, North Six, Folk, Hot Pot China and Seven Dials City.\n\nTogether we create and elevate brands, experiences and destinations through our profound understanding of luxury consumer desires, imaginative and immersive storytelling, meticulous design of experiences and innovative use of technology. \nOur vibrant community of thinkers, makers and innovators are connected by a relentless cultural curiosity, commitment to excellence and shared passion for delivering meaningful and lasting value for our clients. \n\nTogether Group’s Middle East HQ, based in Riyadh, provides a seamless experience, executive management and strategic insight in harmony with a regional context and a vision to shape the future of luxury in the region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                                    "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                                    "beginsAt": "2024-04-29 12:15:00",
                                    "endsAt": "2024-04-29 12:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDkzOQ==",
                                    "title": "New Horizons in Food & Beverage: Unlocking the Potential in a Transformational Marketplace",
                                    "beginsAt": "2024-04-29 09:40:00",
                                    "endsAt": "2024-04-29 10:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDk2MA==",
        "titleTranslations": [
            {
                "value": "Maintaining bottom-line efficiency at scale",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 12:30:00",
        "endsAt": "2024-04-29 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/1iJb2JREcYs?si=6_6FMas41rtwmlkp\" target=\"_blank\">Click here to watch online</a></p><p><strong>Ashish Tulsian</strong>, Co-Founder & CEO of Restoworks in conversation with restaurant CEO on how they are leveraging the latest innovations to drive efficiency and growth. </p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ashish",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDkzODk3LFVzZXJfMTI1NTEwMyk=",
                "jobTitle": "Co-founder & CEO",
                "lastName": "Tulsian",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ad7d6efcf1f043398a8ad3eb04cb61b4.jpeg",
                "organization": "Restroworks",
                "biography": "Ashish Tulsian is the Co-founder and Chief Executive Officer of Restroworks, a leading\ncloud-first technology platform for restaurants. Launched in 2012 as Posist, Ashish has steered the company into becoming an enterprise tech platform for restaurants. Today, Restroworks powers over 20,000 restaurants in 52 countries and is distinguished among the Top 100 Software companies with the highest customer satisfaction in restaurant management software, as recognized by G2's Best Software List 2023. The company is also a Great Place to Work-Certified™ by the Great Places to Work Institute.\n\nAshish is the product visionary behind the cloud-based platform and oversees Product, Growth, and Market Expansion. He is a rare blend of a Technocrat and a Restaurateur. Before founding Posist, Ashish began his entrepreneurial journey during his engineering days in 2007, venturing into the Telecom VAS (Value Added Services) sector with TechnoApex. After a successful exit from his first venture, his culinary passion prompted him to open a restaurant in New Delhi. The business challenges of the restaurant industry sparked his interest in developing a tech solution for restaurants, resulting in the foundation of Posist (now Restroworks), one of the industry-first cloud technology platforms for restaurants.\n\nIn addition to his executive role in the company, Ashish is an active angel investor and mentor to many entrepreneurs in the startup world. As of date, Ashish has made early-stage investments in over 40+ start-ups across the Middle East, India, and the United States. He is often heralded as an adept entrepreneur who has mastered the art of bootstrapping start-ups to scale. A sought-after keynote speaker, Ashish frequently represents the entrepreneurial, restaurant industry, and investment communities at international events, podcasts, and forums.\n\nAshish is recognized by The Times of India in India's top 40 under 40 entrepreneurs in 2023 list. His work and ideas are regularly featured in prominent media publications such as Fortune, The Economic Times, Entrepreneur Middle East, Wamda, and CNBC. Ashish holds a bachelor's degree in Technology from Bharati Vidyapeeth College of Engineering, India.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk2MA==",
                                    "title": "Maintaining bottom-line efficiency at scale",
                                    "beginsAt": "2024-04-29 12:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mateo",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDU4NTg5LFVzZXJfODc5ODkyNSk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ramos",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9d3b7e962fdc4b8c8bf4f31f77278902.png",
                "organization": "Foodvest Holding WLL",
                "biography": "Mateo Ramos is a highly influential figure in the food and beverage (F&B) industry, known for his extensive experience managing and advising over 1,000 restaurants across the United States, GCC, and North Africa.\n\nHis expertise spans finance, mergers and acquisitions (M&A), culture change, and change management in F&B companies and concepts.\n\nMateo has made significant contributions to iconic brands like Azteca Mexicana, Burger King, Buffalo Wild Wings, Texas Chicken, Vogue Cafe, Aubaine, Dylan’s Candy Bar, L’occitane Cafe, La Pâtisserie des Rêves, Alice Pizza, current Foodvest brands - Caribou Coffee, Fuddruckers, Marble Slab and Francesco’s Pizza Cafe, among others. He excels at optimizing financial strategies, orchestrating successful M&A deals, catalyzing cultural transformations, and guiding organizations through change with a dynamic and engaging speaking style.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk2MA==",
                                    "title": "Maintaining bottom-line efficiency at scale",
                                    "beginsAt": "2024-04-29 12:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Faisal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMTgzODgxLFVzZXJfMTYwMzI3NzEp",
                "jobTitle": "CEO F&B",
                "lastName": "Younes",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4be07ad6431a4dc4a79d2ae4cf031cab.jpeg",
                "organization": "Cenomi Retail",
                "biography": "One of the most experienced CEOs in the MENA food and beverage sector, having deployed and managed more than 30 brands over the past 23+ years. Worked with 4 of the leading regional operating firms in the Middle East – Alshaya (Starbucks), Azadea (President F&B), Eathos (CEO)  and currently Cenomi Retail (CEO F&B). \n\nWith a deep market knowledge, a proven turnaround execution and roll-out capability, deep concept experience and entrepreneurial / private equity spirit, Faisal enjoys significant experience and expertise in the food & beverage industry across the GCC and the MENA region.\n\nFaisal was ranked # 8 in the “Top 50” most influential CEOs in the GCC region - Caterer Middle East Magazine",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk2MA==",
                                    "title": "Maintaining bottom-line efficiency at scale",
                                    "beginsAt": "2024-04-29 12:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sherif M.",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMTc3MjMwLFVzZXJfMTMwOTU3MjEp",
                "jobTitle": "Managing Director - MENA",
                "lastName": "Elsherif",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f4e14ea5815c43eabea0e39bea4a04d1.jpeg",
                "organization": "Olayan Food Services Company",
                "biography": "• For over 30years, Sherif lived and breathed the running of international, as well as home grown, franchise brands for one of the largest retail food companies in the MENA region. His experience in transformation and turning around under-performing businesses to achieving their potential, and in ensuring year on year growth for the Brands under his leadership, positioned Sherif as a formidable force in the industry.\n\n• In Kuwait Food Company (Americana), as a COO for the restaurants division, Sherif was managing more than 1,800 restaurants, around 20 international and local brands with over then 43,000 employees in 13 countries in MENA.\n\n• In Olayan Food Services, as a Managing Director for the restaurants division, Sherif is managing 3 International Master Franchised Brands in the region.\n\n• Amongst his key strengths are his abilities to motivate and lead teams to deliver stretch targets, zero in on identifying opportunities and solving bottlenecks with speed and agility. With his all-round experience in operations, marketing, finance and management, Sherif lends a unique perspective to the industry by having led numerous negotiations to acquire and sell various brands within the portfolio.\n\n• Sherif’s expertise in the business is further compounded by his experience as used to be a Member of the Karam Beirut KSA Board, his previous role as a Consultant for Mizuho Gulf Capital Partners Ltd and other boards in different industries.\n\n• Sherif speaks French and English fluently, and Arabic is his mother tongue. He majored in Mechanical Engineering with a minor in Business Administration from the American University of Cairo, Egypt. With a quest towards life-long learning, Sherif is a certified Life Coach and well known for his sage counsel to many.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk2MA==",
                                    "title": "Maintaining bottom-line efficiency at scale",
                                    "beginsAt": "2024-04-29 12:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc4MjkxMg==",
        "titleTranslations": [
            {
                "value": "Networking Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 13:00:00",
        "endsAt": "2024-04-29 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Restaurant Invest",
            "Networking"
        ],
        "priority": 100
    },
    {
        "id": "UGxhbm5pbmdfMTg1Nzg1MA==",
        "titleTranslations": [
            {
                "value": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 13:00:00",
        "endsAt": "2024-04-29 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>On Invitation Only</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQxNDcyLFVzZXJfMTg5NTEzNTAp",
                "jobTitle": "Group Head of Cost, Commercial, and Procurement",
                "lastName": "Edwards",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ad11f8c77ccf4d0dbd9386316aa311ca.jpeg",
                "organization": "Red Sea Global",
                "biography": "Ben Edwards is the Group Head of Cost, Commercial, and Procurement at Red Sea Global (RSG), the developer behind The Red Sea and Amaala, two ambitious tourism projects set along the northwestern coast of Saudi Arabia. These destinations will play key roles in the realization of Vision 2030, the Kingdom’s blueprint for economic diversification and sustainable development.\n\nBen was appointed in August 2022, thanks to over 25 years of experience gained with major contractors in the UK, Europe, the Caribbean, the Middle East, and the Far East. He has a proven record of delivering complex building and civil engineering projects across the globe prior to joining RSG.  \n\nPreviously, he was Main Board Director of Tilbury Douglas in London, UK. Ben was responsible for the development and implementation of the business’s commercial strategy to undertake a greater proportion of lower-risk projects, blending the strengths of a strong regional business with public sector building and infrastructure frameworks, fit-out and a selective presence in the commercial development market.  \n\nBen has a bachelor's degree in Quantity Surveying from Northumbria University.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1Nzg1MA==",
                                    "title": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                                    "beginsAt": "2024-04-29 13:00:00",
                                    "endsAt": "2024-04-29 15:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTc5MjI0NA==",
        "titleTranslations": [
            {
                "value": "Welcome to the Data Talks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 13:30:00",
        "endsAt": "2024-04-29 13:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/s0sAxJBUIx8?si=tq_KuArOAesCOmzO\" target=\"_blank\">Click here to watch online</a></p><p>Data Talks are focused on providing a snapshot of key hospitality data trends as they relate to the hospitality sector and understanding the fundamentals underpinning the market and future trends. The Talks allows each speaker 10 minutes presentation followed by Q&A. </p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Fritz",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDQ2NDkwLFVzZXJfMTU3NTczMjcp",
                "jobTitle": "Managing Director",
                "lastName": "Dickamp",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
                "organization": "Studio 49",
                "biography": "Fritz Dickamp is the Managing Director of “Studio 49”, an award-winning online marketing agency for the hospitality industry, as well as the initiator and host of the podcast & edutainment platform “SMACK Hospitality”. SMACK tells the stories of the industry’s most well-known decision-makers in engaging conversations and other various formats.\n\nFritz has specialized in digital marketing with an enthusiastic approach to e-commerce and digitization of the hospitality and tourism sector after graduating from Ecole Hôtelière de Lausanne in 2013. Besides managing one of the leading online marketing agencies in hospitality in Europe, Fritz is engaged in advisory boards, lecturing at several European hospitality management schools and acts as a keynote speaker with previous records of speaking at TedX, hospitality conventions such as ITB, IHIF, WTM, ATM and tourism fares around the world. He is a member of the “Premium Speakers” network and regularly entertains audiences with his knowledgeable and fun presentations that create plenty of food for thought.\n\nHis favorite topics are such as:\n\n• Start-Up & Entrepreneurship in Hospitality & beyond\n\n• Digital Marketing & E-Commerce – how to win the game!\n\n• Hospitality Service – what other industries can learn from the hospitality world!\n\n• It's a question of attitude – and generation!\n\n• Tell me why! A journey through generations and what they expect online\n\n\nFritz Dickamp belongs to a generation of thought leaders in the hospitality industry that combines enthusiasm for the industry with an understanding of modern business models in the digital age.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                                    "title": "Welcome to the Data Talks",
                                    "beginsAt": "2024-04-29 13:30:00",
                                    "endsAt": "2024-04-29 13:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                                    "title": "Welcome to the Digital Talks",
                                    "beginsAt": "2024-04-30 09:00:00",
                                    "endsAt": "2024-04-30 09:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg2OTMxNA==",
        "titleTranslations": [
            {
                "value": "Data Talks: Global Challenges and Market Resilience - KSA Vision & Government Initiatives",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 13:35:00",
        "endsAt": "2024-04-29 13:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/XfsKRJuAeA0?si=AbqKxppIeI1pxGS3\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Martin",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTA1LFVzZXJfMTU5NTkyNTYp",
                "jobTitle": "Partner & Global Deals Real Estate Leader",
                "lastName": "Berlin",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/275c4c5c246c4caba6ee97c01df8cdd3.jpeg",
                "organization": "PwC Middle East",
                "biography": "Dr. Martin Berlin leads the Real Estate, Hospitality and Leisure Practice in the Middle East and also serves as the Global Deals Real Estate Leader. Recently, he has worked on projects assisting property development companies in strategy, feasibility and market entry studies and supporting other real estate companies in operational projects like customer reviews or growth projects, advising Hospitality companies on their regional strategy and selected project feasibility and supporting Leisure & Entertainment government authorities and companies in expanding their regional project portfolio. Further, he is consulting Construction Contractors and Architectural & Engineering companies in their corporate strategy development. Martin is also actively involved in the Global Deal Origination initiative that has the objective to present customised deal opportunities to a targeted list of global Attendeess (e.g. SWFs, Pension Funds and PE).\n\nMartin brings over 12 years of experience working in senior strategy and operational positions at real estate development companies in the Middle East while he was with Dubai Holding between 2001 and 2013. While his core functional expertise is in strategy and growth projects, he also gained significant operational experience in business development, deal making, marketing and operations. With his experience in McKinsey & Company, he combines a consulting advisor perspective with a operational expertise that he acquired working for Procter & Gamble and Dubai Holding.\n\nBefore joining PwC in 2013, Martin was the Chief Strategy Officer of Dubai Properties Group where he was responsible for the turn around and restructuring of Dubai Holding’s property development and management business, optimizing revenue opportunities for the developer while streamlining OPEX. Martin has is also experience in the Healthcare and Leisure & Entertainment sectors. He has served as the VP of Strategy & Business Development at Dubailand Parks & Resorts (BU of Dubai Holding) where he led IP licensing negotiations with Universal Studios, Six Flags, Marvel, and Dreamworks. His healthcare experience is focused on the pharmaceutical and specialty chemicals industry and the development of Dubai Healthcare City, a large development focusing on the delivery of the entire healthcare value chain. Before his positions with Dubai Holding he was with McKinsey & Company for 6 years and with Procter & Gamble for 3 years.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMxNA==",
                                    "title": "Data Talks: Global Challenges and Market Resilience - KSA Vision & Government Initiatives",
                                    "beginsAt": "2024-04-29 13:35:00",
                                    "endsAt": "2024-04-29 13:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
        "titleTranslations": [
            {
                "value": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 13:50:00",
        "endsAt": "2024-04-29 14:05:00",
        "descriptionTranslations": [
            {
                "value": "<p>Moderator: <strong>Aradhana Khowala,</strong> CEO & Founder, Aptamind Partners</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzE0MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-luxury",
                "translations": [
                    {
                        "value": "Wellness"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Susie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNzA1LFVzZXJfMTc5Mjg2MjEp",
                "jobTitle": "Chair & CEO",
                "lastName": "Ellis",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d88f3e7867af4f4ab9faffc5fefc8841.jpeg",
                "organization": "Global Wellness Institute and Global Wellness Summit",
                "biography": "Susie Ellis is the chair and CEO of the nonprofit Global Wellness Institute, considered the industry’s leading global research and educational resource. She is also chair and CEO of the Global Wellness Summit, an organization at the heart of the multitrillion-dollar global wellness economy focused on facilitating collaboration amongst industry thought leaders. Recognized as a leading authority on wellness trends, Ellis is a popular speaker at industry events. She sits on numerous academic and industry boards, including the EHL Hospitality Business School and the Penn Center for Neuroaesthetics, and was also a member of the World Economic Forum’s “Accelerating Health and Well-being Initiative.” She holds an MBA from the University of California, Los Angeles.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Aradhana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjk4LFVzZXJfMTAwMzI1ODMp",
                "jobTitle": "CEO & Founder",
                "lastName": "Khowala",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
                "organization": "Aptamind Partners",
                "biography": "Aradhana Khowala is globally identified as an authority on the travel, tourism, and hospitality industries and has over two decades of experience across 75 countries in 5 continents. She is currently CEO & Founder of Aptamind Partners a Private Client Advisory that is a trusted advisor to ambitious leaders in Governments, Family Offices, Private UHNW Attendeess, and International Organisations. Previously she was the MD of the Tourism Sector at NEOM - the US$ 500 Billion land of the future purpose built for a sustainable and a new way of living.\n\nAn experienced Board Member she has an active portfolio of Board roles and currently serves as the Chair of the Advisory Board of the Red Sea Project in Saudi Arabia which is a signature “Giga” project of Saudi Arabia Vision 2030, which, through breakthrough models for international tourism, sets new standards for sustainable development and environmental stewardship.\n\nAradhana also serves as a Board Member and Steering Committee member of World Tourism Forum Lucerne a highly focused, top level, strategic body that brings together selected leaders around the world to reflect on the big challenges facing the industry. She is also a Board Member of Elaf Group, the leisure arm of a sustainable and publicly listed holding company - SEDCO. In the past, she has worked for Jones Lang LaSalle, covering the UK, Benelux, and Scandinavian markets, a Strategy Consulting practice in Europe and Asia as well as in Hospitality Operations in India.\n\nAradhana has won multiple awards including the 21st Century Icon Awards in 2017 in association with CNBC and the London School of Economics as an Inspirational Game Changer in Tourism. In 2014, she was featured as one of the 50 most Influential Next Generation leaders who will likely define the future of the Tourism sector by Swiss Economic magazine Bilan (Forbes equivalent), and in 2021 she was featured as an inspirational woman rethinking a sustainable future of tourism by City Nation Place.\n\nA keen industry practitioner, she is a regular speaker and moderator well known for her international advocacy on sustainable tourism, climate change, women and diversity and has participated in global policy discussions in United Nations bodies, WEF as well as the G20 apart from some of the foremost Family Office conferences as well as Tourism and Leadership Summits around the world. She read at Cornell University in the US, is a certified NLP Coach, has an MBA from Ecole Hôtelière de Lausanne in Switzerland, and an International Director Certification from INSEAD in France.\n\nA passionate advocate of the transformative power of tourism and the prospect it presents for combining conservation with community, culture, and commerce, she spends a lot of her time engaging Presidents, Prime Ministers, and Tourism Ministers lobbying for travel and tourism as a force for good. She also guest lectures on tourism, authentic leadership, and entrepreneurship at different Universities globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
                                    "title": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Wellness"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTYyOQ==",
        "titleTranslations": [
            {
                "value": "Announcement #1",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:00:00",
        "endsAt": "2024-04-29 14:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDkzMw==",
        "titleTranslations": [
            {
                "value": "Data Talks: Optimising Restaurant Financial Performance Through Revenue Management",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:05:00",
        "endsAt": "2024-04-29 14:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/voHfMheC00U?si=FXoAcP9-rCnXO8aI\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Rohit",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDAzODk0LFVzZXJfNzgzNDYxKQ==",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Sachdev",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c77a869bdd4a465db0e93c34d8e34b77.jpeg",
                "organization": "Soho Hospitality",
                "biography": "Rohit Sachdev is the CEO and Founder of Soho Hospitality and is responsible for the overall strategic vision for the company’s hotel and restaurant development, interior design and f&b consulting business. \n\nSoho Hospitality’s portfolio includes the 163 key Fraser Suites Sukhumvit and 5 f&b brands including Above Eleven, Charcoal Tandoor Grill & Mixology, Havana Social, Cantina Wine Bar & Italian Kitchen and Soho Pizza. The company employs approximately 250 people across all business verticals. \n\nSoho Hospitality is currently embarking on an international expansion of its brands with the opening of Havana Social Ho Chi Minh City, Above Eleven Dubai, Charcoal Tandoor Grill in Singapore and Colombo in 2022. \n\nRohit is a graduate of the Stern School of Business at New York University and is regularly invited to participate as a keynote speaker at key hospitality and F&B conferences across the region including the Thailand Tourism Forum, Hotel Investment Conference South Asia, Hotel Investment Conference Asia Pacific, South East Asia Hotel Investment Summit and the Global Restaurant Investment Forum.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDkzMw==",
                                    "title": "Data Talks: Optimising Restaurant Financial Performance Through Revenue Management",
                                    "beginsAt": "2024-04-29 14:05:00",
                                    "endsAt": "2024-04-29 14:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg3MTQ0Nw==",
        "titleTranslations": [
            {
                "value": "Data Talks: An Overview of Factors Impacting Hospitality Construction Costs in KSA",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:20:00",
        "endsAt": "2024-04-29 14:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/WWDQVghifGs?si=w5zWolviw3EGm1uu\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Waleed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzcyNzA1LFVzZXJfMTYyNTQwNzIp",
                "jobTitle": "Commercial Director",
                "lastName": "M. Abualnadi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/88c841025ae541499e96edae25303cdc.jpeg",
                "organization": "Saudi Icon Company",
                "biography": "Waleed M. Abualnadi serves as the Commercial Director at Saudi Icon, bringing with him a rich professional background immersed in the construction, engineering, and fitout industry spanning nine years. His journey is marked by an unwavering commitment to continuous growth and excellence.\n\n Beginning his career with an engineering internship at Drake & Skull (ICC in KSA), Waleed acquired invaluable hands-on experience. Transitioning to the role of Electrical Engineer at ABEG KSA, he further honed his skills. Since 2016, Waleed has been pivotal in the success of Saudi Icon where he currently holding the position of Commercial Director.\n\n In his multifaceted role, Waleed adeptly manages three critical dimensions—cost analysis, technical documentation, presentations, and day-to-day commercial aspects of projects. His noteworthy contributions to the successful bids for Saudi Icon cannot be understated, helping to deliver high-profile hospitality projects, including the JW Marriott, Four Points Sheraton, Sindalah Hotel Clusters, and the Red Sea Global hotel projects. Beyond hospitality, Waleed has played a significant role in securing various projects in the government, semi-government, and private sectors. \n\nWaleed holds a degree in Electrical and Computer Engineering from the American University of Beirut. Beyond that, he earned his Masters degree from Leeds University in the UK, equipping him with advanced skills in managing engineering/tech business units. Outside the professional sphere, Waleed is a devoted husband and father to two wonderful children, Elyse and Mohammad. The intersection of his personal and professional life is evident through his marriage to a seasoned hotelier, offering a unique perspective on the hospitality industry.\n\n Waleed eagerly anticipates contributing insights and engaging with industry professionals at the Future Hospitality Summit.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0Nw==",
                                    "title": "Data Talks: An Overview of Factors Impacting Hospitality Construction Costs in KSA",
                                    "beginsAt": "2024-04-29 14:20:00",
                                    "endsAt": "2024-04-29 14:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0MA==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #1",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:30:00",
        "endsAt": "2024-04-29 14:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg4MjUwMg==",
        "titleTranslations": [
            {
                "value": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:35:00",
        "endsAt": "2024-04-29 14:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/e6bC1XFHraE?si=yvUtzLTzPVJiLuia\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NTQ5MjAzLFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/431472c4cc334203850dac4f47ff261d.jpeg",
                "organization": "Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDkzNw==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 14:50:00",
        "endsAt": "2024-04-29 15:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
        "titleTranslations": [
            {
                "value": "Welcome Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 15:00:00",
        "endsAt": "2024-04-29 15:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/UR3A8i3eBLc?si=sNKr0Dalb2KNZzRS\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU3Mw==",
        "titleTranslations": [
            {
                "value": "Opening Address",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 15:30:00",
        "endsAt": "2024-04-29 15:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/UPMerpMJtY0?si=o3idgzw12ZPNF021\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Khalid Saud",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczOTU4LFVzZXJfMTYxNDU2ODkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abu Haimed",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/047feab9eb2745eb9cc8cbfdd1cd09e2.jpeg",
                "organization": "Al Khozama Investment Company",
                "biography": "Mr. Khalid Abuhaimed is recognized as one of the Kingdom’s top business leaders and is well-known for his track record of success, leadership and strategic vision across several organizations in both the private and public sectors.\n\nBeginning his career in banking, Mr. Abuhaimed held a variety of positions from 1997 to 2009 with SAMBA (now part of SNB) and Emirates Bank (now Emirates NDB).\n\nIn 2009, Mr. Abuhaimed joined the Al Rajhi Investment Group, one of Saudi Arabia’s leading business groups, where, over the course of a decade, he undertook several management roles and was ultimately appointed as the Group’s Chief Executive Officer. As CEO, Mr. Abuhaimed played the key role in successfully driving the Group’s growth and diversification plan, including developing a hospitality project in Mecca with over 6500 keys and concluding the largest hotel management agreement ever undertaken at the time with two international global brands.\n\nIn 2019, Mr. Abuhaimed was appointed as Chief Executive Officer of the Camel Club, a Saudi governmental organization dedicated to preserving, caring for and promoting camels as a cherished part of the Kingdom’s heritage. Under Mr Abuhaimed’s leadership, the club experienced unprecedented growth and success, becoming a focal point for camel enthusiasts, advocates and research. Mr. Abuhaimed’s strategic vision and passion for cultural heritage played a pivotal role in expanding the Camel Club's reach and impact and positioning it as a leader in implementing the Kingdom’s cultural and heritage vision.\n\nIn 2020, Mr. Abuhaimed assumed the role of Group Chief Executive Officer for Al Khozama Investment Company, the investment arm of the King Faisal Foundation. Al Khozama owns and operates the Al Faisaliah District in Riyadh, which includes the iconic Al Faisaliah Tower, the Mandarin Oriental Al Faisaliah Hotel, the Al Faisaliah Mall, the King Faisal Foundation Building and several top restaurants including LPM, Mamo and Yauatcha. At Al Khozama, Mr. Abuhaimed also created Maiz, the Kingdom’s premier Saudi fine-dining restaurant, which is located in Diriyah, and expanded the Company’s hotel management business in the Central and Western regions. Mr Abuhaimed’s dynamic leadership in the hospitality and F&B sectors, coupled with his commitment to Saudi heritage, has positioned the Company for future success in the rapidly expanding hospitality and tourist industry, which is a central pillar of the Kingdom’s Vision 2030 Plan. In addition to his role at Al Khozama, Mr. Abuhaimed holds several board positions in the hospitality sector and serves on the board of Landmark Arabia, one of the largest private sector retailers in the Kingdom.\n\nMr Abuhaimed is widely recognized in Saudi Arabia for his leadership, vision, integrity and ability to drive organizational change. He is passionate about fostering a culture of innovation and collaboration, empowering teams to achieve their full potential and to deliver exceptional results.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3Mw==",
                                    "title": "Opening Address",
                                    "beginsAt": "2024-04-29 15:30:00",
                                    "endsAt": "2024-04-29 15:40:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM1OA==",
        "titleTranslations": [
            {
                "value": "Invest, enable, prosper: empowering saudi tourism destination through hospitality sector",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 15:40:00",
        "endsAt": "2024-04-29 15:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/WA17wFyc9sw?si=zj8fKLSirTHTawI9\" target=\"_blank\">Click here to watch online.</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mahmoud",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDI5MjY0LFVzZXJfNjM2NzgyOSk=",
                "jobTitle": "Deputy Minister, Destination Enablement",
                "lastName": "Abdulhadi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8286f8486b46414b8748371435717d7c.jpeg",
                "organization": "Ministry Tourism of Saudi Arabia",
                "biography": "Mahmoud Abdulhadi is Deputy Minister for Destination Enablement at the Saudi Arabian Ministry of Tourism. Having joined in July 2020, Abdulhadi leads the Ministry’s destination development and investment attraction activities with the aim of expanding Saudi Arabia’s growing tourism sector. He and his team are responsible for ensuring that tourism destinations develop the required infrastructure and offering, enabling and facilitating domestic and international private sector investment, supporting sector development by creating opportunities and updating regulations, as well as managing Attendees relations to create a sustainable investment environment for the private sector.\n\nTo execute this mandate, Abdulhadi draws on 17 years of experience at UBS where he was latterly Chief Executive Officer and Head of Investment Banking at UBS Saudi Arabia. During his career at UBS, Abdulhadi worked on a variety of transactions in M&A and equity capital markets spanning multiple sectors including infrastructure, entertainment, telecoms, oil and gas, financial institutions and agriculture to name a few.\n\nAbdulhadi holds a Master’s degree in Manufacturing Engineering and Management from the University of Warwick in the United Kingdom.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM1OA==",
                                    "title": "Invest, enable, prosper: empowering saudi tourism destination through hospitality sector",
                                    "beginsAt": "2024-04-29 15:40:00",
                                    "endsAt": "2024-04-29 15:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings",
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTYzNA==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #2",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 15:45:00",
        "endsAt": "2024-04-29 16:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDk0NQ==",
        "titleTranslations": [
            {
                "value": "The Power of Tourism - Saudi Arabia's Global Standing in Perspective",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 15:55:00",
        "endsAt": "2024-04-29 16:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/EfhsyQLIDFA?si=sHKYITsZg_VyTXCV\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "HE Gloria",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDAzOTg2LFVzZXJfMTAwMzI1NzIp",
                "jobTitle": "Chief Special Advisor",
                "lastName": "Guevara Manzo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/526572d8e1d94f85b637866279c2f58c.jpeg",
                "organization": "Minister of Tourism of Saudi Arabia",
                "biography": "Gloria joined the Ministry of Tourism of Saudi Arabia in May 2021 to support the imAttendeesive transformation that is part of the Kingdom’s Vision 2030.\n\nIn September 2019, Saudi Arabia launched its international e-visa, resulting in 14% growth in tourism’s contribution to national GDP – making it the top performer worldwide. The Kingdom aims to become a top 5 global destination and to create 1 million jobs by 2030. Gloria’s years of experience in the public and private sectors will contribute to such important objectives.\n\nPrior to this, she was the President & CEO of the World Travel & Tourism Council (WTTC) – the global body representing travel and tourism – a sector that generates 10% of global GDP and supports more than 300 million jobs worldwide.\n\nGloria became the global voice of the sector during its most difficult crisis in history – the COVID-19 pandemic. Under her leadership, the Council led the industry agenda, unified the sector, and implemented measures to reduce the impact of the crisis, such as the creation of global protocols for Safe Travels and a stamp that was granted to over 400 destinations around the world. The Council engaged actively with more than 150 governments to share best practices and public policies to support workers and the private sector, including millions of SMEs, as well as to provide guidance and lessons learned for a strong recovery.\n\nAt WTTC, Gloria achieved other important milestones, including defining the Council and its Members’ climate and environment agenda in partnership with UNFCCC, UNEP and HSPH. To bring the sector’s leadership together, she successfully hosted important events such as the first Global Climate and Environment Action Forum, numerous Regional Leaders’ Forums and WTTC Global Summits all over the world. Notable attendees include former Presidents Obama, Calderon, Santos, and Aznar, as well as Heads of State such as Pedro Sanchez and Mauricio Macri.\n\nShortly before her departure, WTTC hosted the first global in-person gathering after the pandemic in Cancun, Mexico. The event was a great success and contributed to the safe reopening of international travel.\n\nGloria’s career in the travel industry began in 1995 at the Sabre Travel Network and Sabre Holdings, where she became CEO of JV Sabre Mexico reporting to a board of directors from Aeromexico, Mexicana, and Sabre Holdings.\n\nIn March 2010, President Calderon appointed her as Minister of Tourism and after only two weeks, she was given full responsibility of the Mexico Tourism Board. Under her leadership the “National Agreement for Tourism” in Mexico was created in 2011, and for the first time, “the importance of Travel & Tourism” was included in the G20 Leaders’ Declaration in Los Cabos.\n\nGloria received the Good Neighbour Award from the US-Mexico Chamber of Commerce and Mexico’s Tourism Board was recognized by Virtuoso as the best tourism board in the world thanks to her successful branding and repositioning efforts. She has also received multiple recognitions from academia and the private sector, including CNET (Mexico’s National Tourism Business Council).\n\nIn addition, Gloria was Special Advisor on Government Affairs to Harvard University’s School of Public Health, and part of the Future for Travel, Tourism and Aviation Global Agenda Council of the World Economic Forum (WEF). She was recognized as one of the most influential women in Mexico by CNN, Forbes, and Expansion.\n\nShe holds a BS in Computer Science from Anahuac University and an MBA from Kellogg School of Business, Northwestern University.\n\nGloria sits on the board of American ExAttendees Global Business Travel, was also formerly on the boards of HSBC Mexico, Playa Hotels & Resorts and other important organizations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk0NQ==",
                                    "title": "The Power of Tourism - Saudi Arabia's Global Standing in Perspective",
                                    "beginsAt": "2024-04-29 15:55:00",
                                    "endsAt": "2024-04-29 16:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Reina",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjA0OTI3LFVzZXJfMTMyNDI5NDMp",
                "jobTitle": "Business Editor",
                "lastName": "Takla",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1255f4454d664f8d92346e01094267ab.jpeg",
                "organization": "Arab News",
                "biography": "Reina Takla is a seasoned business editor with a talent for strategic planning and crafting engaging editorial content across various mediums. She leads teams of reporters and editors and produce impactful storytelling that resonates with targeted audiences.\n\nHer expertise extends to conducting interviews with senior figures in both public and private sectors, covering a broad spectrum of topics including energy, renewables, mining, cybersecurity, AI, financial markets, defense, hospitality and aviation.\n\nPrior to her editorial career, Reina excelled in the banking sector as a relationship and wealth manager, catering to high net worth individuals and non-corporate entities. With an impressive two-decade tenure in the industry, she brings a wealth of experience and insight.\n\nReina is also a certified corporate and academic instructor, drawing upon over a decade of practical knowledge in finance and economics to deliver engaging and informative educational sessions. Her passion for sharing knowledge enriches the learning experiences of her students, making complex topics accessible and comprehensible.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk0NQ==",
                                    "title": "The Power of Tourism - Saudi Arabia's Global Standing in Perspective",
                                    "beginsAt": "2024-04-29 15:55:00",
                                    "endsAt": "2024-04-29 16:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg2MDc4OQ==",
        "titleTranslations": [
            {
                "value": "Setting the Scene for Hotel Performance and Development in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 16:10:00",
        "endsAt": "2024-04-29 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/OndUIC9JG4o?si=ybOzh6RnKH3kaATC\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Thomas",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTk3LFVzZXJfMTQzNjAwOCk=",
                "jobTitle": "Senior Director",
                "lastName": "Emanuel",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/76bfadbf7c9a46fc9a020b039d7d3855.jpeg",
                "organization": "STR, a CoStar Group Company",
                "biography": "Thomas Emanuel is a Director at STR. He is based in London, and leads a team focused on driving business with industry partners.\n\nHe has spent his entire career in the hotel industry, beginning in 2000 with Miki Travel, before joining Hyatt Hotel & Resorts, where he gained experience in corporate sales at both the worldwide sales office and at the property level. Thomas then led the corporate sales function for Hazlitt’s Hotels, a group of independent boutique hotels in London.\n\nIn 2006, Thomas joined the Deloitte HotelBenchmark team, where he was responsible for creating and leading the department’s business development function. He held this role until the international expansion of STR in March 2008 and has since focused on overseeing STR’s rapid growth outside North America. Throughout his time with STR, Thomas has gained a wealth of experience working with hotels, Attendeess, developers, consultants, banks, governments, destination management companies and many others.\n\nThomas has been a guest lecturer at Ecole hôtelière de Lausanne, and been invited and participated in the OECD's high-level meetings on tourism policies.\n\nTraveling extensively, Thomas has worked in over 45 countries across 6 continents and regularly speaks at major hospitality conferences around the world. He is also frequently interviewed for his insights on the hotel industry by media outlets including CNN, Bloomberg, CNBC, and The Times, as well as various tourism and hospitality publications.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2MDc4OQ==",
                                    "title": "Setting the Scene for Hotel Performance and Development in Saudi Arabia",
                                    "beginsAt": "2024-04-29 16:10:00",
                                    "endsAt": "2024-04-29 16:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
        "titleTranslations": [
            {
                "value": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 16:30:00",
        "endsAt": "2024-04-29 17:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/DYVmUjnI9LI?si=pCcym9iHEklk_Bt7\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Fahad",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDY3MDEwLFVzZXJfMTYxMzcwMTMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Bin Mushayt",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f777a708539f421bb26d3e7dfcc7daad.jpeg",
                "organization": "ASFAR",
                "biography": "Dr. Fahad bin Mushayt is the Chief Executive Officer at ASFAR, the Saudi tourism investment company that is a wholly owned subsidiary of the Public Investment Fund established to drive the growth of tourism investment in partnership with the private sector to create captivating destinations in Saudi Arabia for visitors from all over the world in line with Saudi Vision 2030.\n\nBoasting more than two decades of experience, Dr. Mushayt's illustrious career spans across multifaceted domains including city management, mega investments in real estate, mergers and acquisitions, strategic business development, and operations management. He has also taken on challenging roles in myriad sectors including information technology and telecommunications, as well as infrastructure development.\n\nBefore his tenure at ASFAR, Dr. Mushayt held pivotal positions in both government and semi-government entities. He spent nearly twenty years at the Saudi Telecom Group holding several other key positions including Chief Executive Officer of Mega Strategic Projects, Vice President for Business Development, and Vice President of Corporate Strategy and Performance. He then became the Chief Executive Officer of Saudi Telecom Specialized Company for three years. In 2021, he became Deputy Governor for Investment and Business Development at the State Property General Authority, after being Chief Executive Officer of the Diplomatic Quarter General Authority (DQGA) in Riyadh for three years.\n\nHe has also served on the boards of various organizations worldwide including Maxis Communication Berhad Holding Company in Malaysia, Aircel Company in India, and Axis Company in Indonesia, to name a few.\n\nDr. Fahad bin Mushayt holds a PhD in Economics, Political Economy and Public Policies from the University of Southern California and a master’s degree in economics from California State Polytechnic University, Pomona. He also holds a Bachelor of Science degree in Operations Research from King Saud University, Riyadh.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Edie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTQ4NDM4LFVzZXJfNTgzNjYwOCk=",
                "jobTitle": "Member of the Board of Directors",
                "lastName": "Rodriguez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f6b3f788b42a407dab1e342850d9aba0.jpeg",
                "organization": "Saudi Tourism Authority",
                "biography": "Edie Rodriguez is a highly accomplished travel industry CEO and Member of the Board of Directors who delivers billion-dollar outcomes across luxury, luxury travel, retail, and technology industries. As a “mobile global” executive and positive disrupter, she has honed a 35+ year career across sales, operations,marketing, digital, and social distribution channels to transform during her tenure some the world’s most recognizable global cruise brands including Crystal Cruises Corporation, Royal Caribbean’s Azamara Cruises, Carnival Corporation’s Cunard, Seabourn and Carnival brands and Ponant Cruises. As an award-winning leader with strong corporate governance, financial and business acumen, she is sought after for companies seeking to establish market leadership and global brand dominance. Edie is a Member of the Board of Directors for the Saudi Tourism Authority (STA), where she is the Chair of the Nominating and Remuneration Committee. The STA was formed and is funded by the Kingdom of Saudi Arabia’s Public Investment Fund in line with their #SaudiVision2030 goals.\n\nIn addition to Board guidance on compensation and governance, she assists the teams with scaling and expanding in to new markets and advising on strategic cobranding opportunities. Previously, Edie was a Director for RAND Corporation’s Center for Global Risk and Security (CGRS) from 2017 through 2020. As an Advisory Board Member she provided governance and fiduciary guidance, advising from billion-dollar corporations’ perspectives.\n\nShe has been an Advisory Board Member to the Retail Summit since its inception. Mrs. Rodriguez’s academic qualifications include a Bachelor of Science from Nova Southeastern University and has attended the Executive Management Programs at Harvard, Stanford and Wharton. She is deeply skilled in the science of governance, relationships and executive leadership effectiveness.\n\nThroughout her career she has been the recipient of many global awards including EY’s Entrepreneur of the Year Award.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Haitham",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NTU5MzI3LFVzZXJfNTIwODMyNyk=",
                "jobTitle": "Special Advisor, UNWTO",
                "lastName": "Mattar",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/16139fb181bf4c52924f2e5e73a3ec80.jpeg",
                "organization": "Managing Director MEA & South West Asia, IHG Hotels & Resorts",
                "biography": "Haitham Mattar is Managing Director, Middle East, Africa & South West Asia , responsible for driving the growth and strength of IHG and its hotels across the region. He is currently leading the operations and performance of more than 160 hotels as well as overseeing the strategic development of IHG’s plans with a pipeline of 106 hotels. Key to his role is maintaining and fostering relations with government stakeholders, tourism bodies and owner community across markets.\n\nPreviously, Haitham served as Senior Advisor to the Saudi Ministry of Tourism, advising on the National Tourism Strategy and the execution of the commercial tourism strategy to position Saudi Arabia as one of the world’s top, emerging tourism destinations.\n\nPrior to this, Haitham was the CEO of the Ras Al Khaimah Tourism Development Authority, where he successfully repositioned Ras Al Khaimah to become one of the fastest growing, adventure destinations in the world.\n\nWith more than 25 years of experience in global destination and hospitality management and marketing, Mattar has also held senior roles within IHG, as well as Marriott and Hilton Worldwide. \n\nMattar continues to serve as an advisor to several travel and tourism organizations. Having been involved with UNWTO for several years, in 2020, he was appointed as a Special Advisor to the Secretary General of the UNWTO. Additionally, he serves as an advisory board member of the Arabian Travel Market and the Global Thinkers Forum (GTF).\n\nNamed ‘Tourism Promotion CEO of the Year’ at the Global CEO Excellence Awards, Mattar was featured in the Arabian Business ‘most powerful Arabs’ list, in addition to being named ‘Leisure and Tourism CEO of the Year’ at the prestigious CEO Middle East Awards and ‘Business Leader of the Year’ at the Hozpitality Excellence Awards in 2018.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Guy",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQxODA2LFVzZXJfMTg5NTE1NjQp",
                "jobTitle": "President, Middle East & Africa (MEA)",
                "lastName": "Hutchinson",
                "photoUrl": "https://static.swapcard.com/public/images/7b69152893044de9bd64e3bd51d49861.jpeg",
                "organization": "Hilton",
                "biography": "Guy Hutchinson is President, Middle East & Africa (MEA) for Hilton and is a member of Hilton’s Europe, Middle East & Africa (EMEA) Executive Committee.\n\nBased at Hilton’s Regional Office in Dubai, Hutchinson oversees 137 operating properties across 11 brands in the MEA region, with more than 182 hotels in the pipeline. Together with the team, Hutchinson focuses on providing friendly and reliable stays for guests and above-market returns for owners.\n\nHutchinson brings with him an impressive track record in the hospitality industry, including 15 years working previously with Hilton, holding several managerial positions in Dubai, Japan, China, Australia before serving as Vice President – Operations in India. Most recently, he was CEO of Abu Dhabi based Rotana. During his tenure, Hutchinson led the company’s global expansion plans and launched a new franchise model for the group.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM1OQ==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: How the Private Sector is driving Growth Through Strategic Synergy",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 17:05:00",
        "endsAt": "2024-04-29 17:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/TcsVKcNiNEg?si=mu1LzcfB94qfQdEA\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sultan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNTYxLFVzZXJfMTQ4Njc2OCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Bader Al-Otaibi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9410ea2905734ed69b3e14688d5f0f9f.png",
                "organization": "Taiba Investments",
                "biography": "Mr. Sultan Bader Al-Otaibi is a recognized leader in the Middle East's hospitality and real estate sectors, currently serving as the Chief Executive Officer of Taiba Investments. His tenure marks a significant phase where Dur Hospitality's rich heritage in hospitality is seamlessly integrated into the expansive portfolio of Taiba Investments. \nAl-Otaibi's career, spanning over 23 years, is marked by significant contributions and transformative leadership in the hospitality sector. His role at Dur Hospitality was instrumental in elevating the company's profile in property and asset management. As General Manager of Makarem Hospitality Group, part of Dur Hospitality, he ensured operational excellence and upheld high standards in hospitality management.\nBeyond his operational expertise, Al-Otaibi's background in finance and accounting has been fundamental to his leadership journey. He held key financial positions at Dur Hospitality, including Internal Auditor, Financial Controller, and Chief Accountant, lending considerable financial insight to his strategic decision-making.\nIn his role at Taiba Investments, Al-Otaibi continues to drive growth and innovation in the hospitality and real estate sectors. His active participation in notable industry initiatives underscores his dedication to the industry. He serves on the Marriott EMEA Owner Advisory Distribution Council, the Tourism Committee at the Riyadh Chamber of Commerce & Industry, and the Advisory Board of the Future Hospitality Summit.\nRecognized for his outstanding contributions, Al-Otaibi has earned several accolades, including being named among the 'Top 50 Travel and Tourism Leaders' by Forbes ME and appearing in the Executive Power List and Saudi Vision 2030 Power List by Hotelier ME.\nAl-Otaibi's educational achievements include a master's degree in International Hospitality Management from the Emirates Academy of Hospitality Management and a bachelor's degree in Accounting from King Saud University. These qualifications have provided a solid foundation for his distinguished career in hospitality and real estate.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM1OQ==",
                                    "title": "TenX Leadership Talks: How the Private Sector is driving Growth Through Strategic Synergy",
                                    "beginsAt": "2024-04-29 17:05:00",
                                    "endsAt": "2024-04-29 17:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAxMw==",
        "titleTranslations": [
            {
                "value": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 17:20:00",
        "endsAt": "2024-04-29 18:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/oanjEQc0Mo8?si=uucB_ij2dX2HTur1\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Marloes",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDIyLFVzZXJfMTEyODE0MDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Knippenberg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "Marloes is a distinguished hospitality leader who has been instrumental in redefining industry benchmarks. She seamlessly integrated ESG (Environmental, Social, and Governance) into the heart of business operations, processes, and value propositions. This integration has proven transformative, elevating a singular national brand to a global lifestyle group with a portfolio spanning over 45 diversified projects.\n\nMarloes' commitment to excellence is underscored by her strategic vision. She actively pursues the expansion of the brand's lifestyle portfolio, targeting regions identified for synergistic collaborations and mutual stakeholder objectives. Her foundational expertise is anchored in her tenure at Hilton, where she was entrusted with high-impact operational and commercial management portfolios.\n\nBeyond mere strategy and execution, Marloes is deeply committed to human capital development within the industry. She consistently champions the nurturing of emerging talents, propelling industry-wide transformation, and driving organizational alignment towards sustainability-centric objectives. This approach prioritizes not just bottom-line growth but also the holistic development of individuals, communities, and guest experiences.\n\nMarloes' advocacy for a progressive hospitality sector extends beyond traditional corporate parameters. As a notable ambassador for the Global Hospitality Student Challenge, spearheaded by Hotelschool the Hague, she is at the forefront of bridging the gap between the seasoned investment community and the visionary leaders of tomorrow. This initiative stands as a testament to her commitment to fostering innovation and collaboration, cementing her role in the ongoing evolution of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Osama",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MTExMTkxLFVzZXJfMTg1NjQyODAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "AlOthman",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/854dcb2185df42228823e8a00677a8bb.jpeg",
                "organization": "Aseer Investment Company",
                "biography": "Osama AlOthman is a seasoned executive with more than 30 years of experience, during which he has held numerous key positions in investment and finance across local, regional and global markets.\n\nPrior to joining Aseer Investment Company, AlOthman held the role of Head of Mergers & Acquisitions at Abu Dhabi Future Energy Company – Masdar. During his tenure, he developed the company’s investment strategy, launched the mergers & acquisition function, and deployed USD1.2 billion in capital, growing the global portfolio to generate 50%+ of the company’s total production capacity. He also established the first Masdar offices in Saudi Arabia and USA.\n\nAlOthman also held two key positions at First Solar International Middle East – Director of Project Finance for the Middle East & North Africa and Country Manager of Saudi Arabia. He orchestrated the disinvestment of a US$150 million project in Jordan to Diamond Energy (a Mitsubishi subsidiary) and established operations in Saudi Arabia, contributing to the efficiency of the photovoltaic industries in the Kingdom.\n\nDuring his career trajectory, AlOthman was the founding member and Executive Director of Evolvence Capital, a private equity firm based in the UAE. He was responsible for expanding the company’s investments into new markets and also successfully established an investment fund in India, where the company's assets amounted to USD700 million.\n\nAlOthman has also worked for leading firms including the Saudi British Bank (SAB), Saudi Arabian Oil Company (Aramco), and the Saudi American Bank (Samba).\n\nHe holds a B.S. degree in Industrial Management from King Fahd University of Petroleum & Minerals (KFUPM), as well as a certificate in Executive Leadership from Harvard University (2018).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Khalid",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDQ4NzgzLFVzZXJfMTU5OTczOTIp",
                "jobTitle": "Chairman",
                "lastName": "Al Gahtani",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fc8bb1e1ec5542fda005a5a730bc7cdf.jpeg",
                "organization": "Rikaz Properties",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MzA3NzMzLFVzZXJfMTIzODY4ODIp",
                "jobTitle": "Host & Founder",
                "lastName": "Islam",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2a41038717d84318b27a383e0a8a13fb.jpeg",
                "organization": "The Mo Show Podcast Saudi Arabia",
                "biography": "Mohammed Islam is the Host & Founder of Saudi Arabia’s leading English podcast, The Mo Show, which is currently in its fourth season. The show aims to break stereotypes and misconceptions by shedding light on the progression and accomplishments of the country, told by those on the ground who share their personal stories and experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxMjIyNw==",
                                    "title": "TENX Leadership Talks: Mohammed Islam, Host & Founder, The Mo Show Podcast, one on one with Mohammed Jawa, Founder and Chairman, MJS Holding on The future of Saudi’s restaurant market. How is the market diversifying and what is the long term vision?",
                                    "beginsAt": "2024-04-29 11:05:00",
                                    "endsAt": "2024-04-29 11:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination",
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU3Nw==",
        "titleTranslations": [
            {
                "value": "Welcome Reception on the Green by Maiz",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-29 18:00:00",
        "endsAt": "2024-04-29 20:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Hosted by Al Khozama at the Mandarin Oriental Al Faisaliah Hotel, Riyadh</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDk1OA==",
        "titleTranslations": [
            {
                "value": "GRIF Performance Report - How is F&B Performing within Hotels in Saudi?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:00:00",
        "endsAt": "2024-04-30 09:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/CK7ryI5_QPU?si=HhnSA553Xn-GD9E3\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Kathrin",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNzEwLFVzZXJfNjk4MTg4Myk=",
                "jobTitle": "Commercial Director",
                "lastName": "Cockhill",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b97fda9665d44367ae630f362aa1b961.png",
                "organization": "HotStats",
                "biography": "Kathrin is Commercial Director at HotStats.  HotStats provide monthly P&L benchmarking & market Insight for the hotel industry. Collecting monthly detailed financial data from over 11,500 hotels worldwide from over 167 brands and independent hotels, HotStats provide over 550 different KPIs covering all operating revenues, payroll, expenses, cost of sales and ultimately departmental & total hotel profitability . Prior to joining HotStats in September 2021, Kathrin held multiple Commercial and Sales roles at Hotel and Corporate level across Branded and Independent Hotel Groups . As part of her role, she now heads up the Business Development team globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OA==",
                                    "title": "GRIF Performance Report - How is F&B Performing within Hotels in Saudi?",
                                    "beginsAt": "2024-04-30 09:00:00",
                                    "endsAt": "2024-04-30 09:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
        "titleTranslations": [
            {
                "value": "Welcome to the Digital Talks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:00:00",
        "endsAt": "2024-04-30 09:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/e4jyqA8CJQw?si=3Q5x9W0tctFHN6Qc\" target=\"_blank\">Click here to watch online</a></p><p>Digital Talks are focused on providing a snapshot of key hospitality digital trends as they relate to the hospitality sector and understanding the fundamentals underpinning the market and future trends. The Talks allows each speaker 10 minutes presentation followed by Q&A.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Fritz",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDQ2NDkwLFVzZXJfMTU3NTczMjcp",
                "jobTitle": "Managing Director",
                "lastName": "Dickamp",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
                "organization": "Studio 49",
                "biography": "Fritz Dickamp is the Managing Director of “Studio 49”, an award-winning online marketing agency for the hospitality industry, as well as the initiator and host of the podcast & edutainment platform “SMACK Hospitality”. SMACK tells the stories of the industry’s most well-known decision-makers in engaging conversations and other various formats.\n\nFritz has specialized in digital marketing with an enthusiastic approach to e-commerce and digitization of the hospitality and tourism sector after graduating from Ecole Hôtelière de Lausanne in 2013. Besides managing one of the leading online marketing agencies in hospitality in Europe, Fritz is engaged in advisory boards, lecturing at several European hospitality management schools and acts as a keynote speaker with previous records of speaking at TedX, hospitality conventions such as ITB, IHIF, WTM, ATM and tourism fares around the world. He is a member of the “Premium Speakers” network and regularly entertains audiences with his knowledgeable and fun presentations that create plenty of food for thought.\n\nHis favorite topics are such as:\n\n• Start-Up & Entrepreneurship in Hospitality & beyond\n\n• Digital Marketing & E-Commerce – how to win the game!\n\n• Hospitality Service – what other industries can learn from the hospitality world!\n\n• It's a question of attitude – and generation!\n\n• Tell me why! A journey through generations and what they expect online\n\n\nFritz Dickamp belongs to a generation of thought leaders in the hospitality industry that combines enthusiasm for the industry with an understanding of modern business models in the digital age.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                                    "title": "Welcome to the Data Talks",
                                    "beginsAt": "2024-04-29 13:30:00",
                                    "endsAt": "2024-04-29 13:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                                    "title": "Welcome to the Digital Talks",
                                    "beginsAt": "2024-04-30 09:00:00",
                                    "endsAt": "2024-04-30 09:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTkxMDE5Nw==",
        "titleTranslations": [
            {
                "value": "Millennium MEA Breakfast Networking",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:00:00",
        "endsAt": "2024-04-30 11:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTg4MTEwOQ==",
        "titleTranslations": [
            {
                "value": "Digital Talks: Leveraging Digital Trends to Enhance Hospitality Investment and Operations",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:05:00",
        "endsAt": "2024-04-30 09:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ybcvbdSaFdU?si=X3qdjKB__F1zxhL8\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sarah",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzYyMDAxLFVzZXJfMTU5MjYzMTgp",
                "jobTitle": "Senior Vice President, Head of Hotels KSA",
                "lastName": "Gasim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/295c94c5f792461ea1fb5840b840ad14.jpeg",
                "organization": "JLL",
                "biography": "Sarah leads JLL’s Hotels & Hospitality business in KSA. She has led several hospitality megaprojects within KSA such as NEOM, PIF Tourism Destination in Taif and Jabal Omar Development Company (JODC).\nPrior to joining JLL, Sarah led the hospitality sector at one of the upcoming tourism destinations in the western region of KSA owned by the Public Investment Fund (PIF). Sarah also obtained a wide range of professional experience from local and international hospitality operators and organisations including IHG, Elaf Group and Booking.com.\nShe was awarded the ‘Best Tourism Trainer in Saudi’ in 2017 by HRH Prince Sultan Bin Salman. In addition, Sarah is a former active member of the United Nations World Tourism Organisation (UNWTO) and the World Travel & Tourism Committee (WTTC).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg4MTEwOQ==",
                                    "title": "Digital Talks: Leveraging Digital Trends to Enhance Hospitality Investment and Operations",
                                    "beginsAt": "2024-04-30 09:05:00",
                                    "endsAt": "2024-04-30 09:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
        "titleTranslations": [
            {
                "value": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:15:00",
        "endsAt": "2024-04-30 09:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/LxB-eSaipFw?si=op0N5yNR52uCff3C\" target=\"_blank\">Click here to watch online</a></p><p>Where are the opportunities to leverage F&B brands to enhance the footfall, ADR, revenue and the value of your property?</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0NDA0LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rizwan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMzk2LFVzZXJfMTU5NTQ0Mjcp",
                "jobTitle": "Founder & CEO",
                "lastName": "Kassim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
                "organization": "RIKAS Hospitality Group",
                "biography": "Rizwan Kassim is a testament to the UAE's spirit of entrepreneurship. Having started with the long-established La Cantine du Faubourg in Paris over ten years ago, the young Parisian saw a vision for the brand in Dubai and has since gone on to create the RIKAS Group, which is now one of the leading creators and operators in the Middle East dining scene.\n\nIn just nine years, he has opened a staggering 16 restaurant and Beach Club concepts in Dubai and have a total of 19 operations at the moment, many of which are now gracing the pages of the inaugural Michelin Guide and Gault Millau. With expansion underway to countries including Saudi Arabia, Greece, Europe, US and India, the ambitious young entrepreneur is no stopping as he takes the RIKAS Group - home to top-name dining destinations.\n\nAside from the 16 concepts, five more are under development which will hit the UAE market in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lynne",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTk3ODg1LFVzZXJfMTUxMzM2Mik=",
                "jobTitle": "Director of Food & Beverage Design & Development",
                "lastName": "Bellinger",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/80e13f081e84417393d70f5707ea943d.jpeg",
                "organization": "Marriott International EAME",
                "biography": "Joining the Marriott family in 2017, Lynne drives the development projects for food and beverage, taking care of any partnership deals and supporting solutions that drive incremental revenue. A big part of this is the sourcing and management of third-party restaurant brand and operator relationships to support Marriott’s overall Food & Beverage strategy and add value and brand recognition to hotels across the Europe, Middle East & Africa region.\n\nA British national, Lynne has worked her entire career in the hospitality industry, and has worked in the Middle East for over 30 years. Prior to joining Marriott, Lynne founded and managed her own business, sourcing internationally renowned restaurant brands, celebrity chefs and unique bar and entertainment concepts for hotels and developers here in the UAE. In addition, Lynne was the founder of hospitality recruitment specialists, The Hospitality Company as well as Purple Cubed UAE, a franchise of the UK’s leading solutions provider for employee engagement, development and retention to hospitality and other service industries.\n\nBefore her entrepreneurial days, Lynne’s career was within the five-star hotel industry. With hands-on experience forged through an initial operations career path, she rapidly built her expertise in human resources. She has worked for hotel brands such as Forte Hotels, Starwood Hotels, and as part of the opening team at the One&Only Royal Mirage where she led the human resources and training department in the successful launch of this prestigious property.\n\nLynne has been a speaker for many trade shows and has taken part in panel discussions as both chair and participant; as well as being part of various industry judging panels over the years for Restaurant and Hotel Awards.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sam",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTc4MjM3LFVzZXJfMTkwODMyNjYp",
                "jobTitle": "President & Board Member",
                "lastName": "Bakhshandehpour",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/46a16339843641dfae39ca89faaf369d.jpeg",
                "organization": "José Andrés Group (JAG)",
                "biography": "Sam Bakhshandehpour is the President and Board Member of José Andrés Group (JAG), a restaurant and media company. Driven by the mission of “Changing the world through the power of food,\" JAG's platform spans 38+ restaurants across 9 markets globally and multiple cuisines, including the 2-Michelin starred minibar by José Andrés, and numerous Michelin Bib Gourmand restaurants. Mr. Bakhshandehpour also runs José Andrés Media division (JAM) which produces food-related cultural content across scripted, unscripted - film and television, books (including The New York Times Best Seller Zaytinya), podcasts, and digital content. JAG also houses numerous global partnerships and a consumer products platform.\n\nThrough his hospitality investment platform, The Silverstone Companies, Mr. Bakhshandehpour has made numerous investments including The Electric Jane (membership community and live music lounge / restaurant), Cultivate Hospitality (F&B programming), Bazaar by José Andrés, and select other hotel, restaurant and lifestyle properties.\n\nNamed one of the “Most Important People in Hospitality” on the Observer’s 2023 Dining and Nightlife Power List, Mr. Bakhshandehpour previously served as President, Chief Executive Officer and Board Member of sbe Entertainment, a private-equity backed hotel, restaurant and nightlife company with over 80 properties globally.\n\nMr. Bakhshandehpour started his career on Wall Street with J.P. Morgan Securities running the Global Casino and West Coast Real Estate & Lodging Investment Banking practice focused on mergers & acquisitions and capital raising.\n\nMr. Bakhshandehpour holds a Bachelor of Science degree in Business Administration from Georgetown University’s McDonough School of Business. He serves on the board of Shift4 (NYSE: FOUR) and as a member of Fiserv Inc’s (NYSE: FI) Restaurant Advisory Board, including the Audit and Compensation Committees for both companies, as well as an Advisor for Bilt Technologies, Inc. Previously, Sam served on the boards of The New Home Company (NYSE: NWHM), including the Audit and Compensation Committees, and Georgetown University McDonough School of Business’ Board of Advisors as a Board Member and Capital Campaigns Committee Member. He is a trustee of Federal City Council (FC2), a founding member of the Georgetown Wall Street Alliance West, and a Senior Advisor to Montminy & Co., FINRA-registered (series 7, 24, 63). Mr. Bakhshandehpour is also an active member and former Chair of the Bel Air Chapter of the Young Presidents Organization.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2NQ==",
                                    "title": "Case study: What is your North Star? Profit with Purpose - From Restaurants to Global Media Powerhouse & Force for Good, learning from The José Andrés Group’s transformation",
                                    "beginsAt": "2024-04-29 12:15:00",
                                    "endsAt": "2024-04-29 12:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg2OTMxNg==",
        "titleTranslations": [
            {
                "value": "Digital Talks: Strategic Potential - Mastering Digital Platforms",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:20:00",
        "endsAt": "2024-04-30 09:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/iqSVpym-HDU?si=KuL8kB1G24xGyDUO\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Oli",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzY0NzEyLFVzZXJfMTg5NjU2Njcp",
                "jobTitle": "Founder",
                "lastName": "Thomas",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b3cdc73d91e7445891a75b6ffba552f7.jpeg",
                "organization": "Hatchin",
                "biography": "Oli is a media executive with extensive experience in creating digital experiences for youth and family audiences. As founder of Hatchin, he advises and supports early stage creative ventures working across a wide spectrum of innovative products and services. Additionally, he advises more established clients on building digital strategies to leverage new technologies and engage with younger demographics. Prior to this, he was the Chief Strategy Officer at Auddy, an international podcast network, and Vice President & Digital Lead at Paramount International (formerly ViacomCBS), where he led the digital business for MTV, Comedy Central and Nickelodeon in the UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMxNg==",
                                    "title": "Digital Talks: Strategic Potential - Mastering Digital Platforms",
                                    "beginsAt": "2024-04-30 09:20:00",
                                    "endsAt": "2024-04-30 09:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ2Mw==",
                                    "title": "Digital Evolution in F&B and Hospitality: Leveraging Influencer and Gaming Trends for the Next Five Years",
                                    "beginsAt": "2024-04-29 11:50:00",
                                    "endsAt": "2024-04-29 12:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg4MTExMA==",
        "titleTranslations": [
            {
                "value": "Digital Talks: How AI and Digital can optimise end-to-end procurement",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:35:00",
        "endsAt": "2024-04-30 09:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/wbBQwhgqb_U?si=669YppYcyUUER_w2\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ankur",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTI1LFVzZXJfOTgwNDAyNyk=",
                "jobTitle": "CEO & Founder",
                "lastName": "Agrawal",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b3ff5b51d6b54a2787c0617014e2803f.jpeg",
                "organization": "Inhabitr",
                "biography": "Ankur founded Inhabitr in 2018, after moving a few countries and cities he became convinced that the furniture market was under-served in terms of affordable designer furniture on subscription, which met the needs of the present-day millennials \nwho move a lot. Inhabitr, which is a technology platform, connects the furniture world with businesses like Hotels, Student Housing and Multifamily apartments looking for designer furniture on subscription. Inhabitr uses Artificial Intelligence (AI) to curate furniture from various sources and enables furniture factories and suppliers to participate in rental commerce to allow furniture to be re-used and therefore also save the planet. \nAnkur Agrawal is an ex Partner at McKinsey’s Chicago Office where he was a leader of their global Consumer Packaged Goods (CPG) service line. Over the past 12+ years of his affiliation with the CPG industry, Ankur has lived and worked across four continents in Asia, the Middle East, Europe, and now the USA and extensively worked with global Consumer Goods and Retail chains in shaping a variety of leading-edge topics like Design for growth, Digital, and Operations as a competitive advantage Ankur has a lot of personal passion for growth and innovation and he mentors several companies and startups across the globe on market entry and growth topics. Ankur also serves on the board of many Non-Profits and Startup Clubs. \nAnkur is also a robotics enthusiast and holds an engineering degree from Jacobs University in Germany. Ankur is married to Pratiksha who is a Dentist. Ankur and Pratiksha live in Sunnyvale, CA with their 3-year-old son Tanish",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg4MTExMA==",
                                    "title": "Digital Talks: How AI and Digital can optimise end-to-end procurement",
                                    "beginsAt": "2024-04-30 09:35:00",
                                    "endsAt": "2024-04-30 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDIzNA==",
        "titleTranslations": [
            {
                "value": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:45:00",
        "endsAt": "2024-04-30 10:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/GYU7tjbA4Yw?si=ZvKdU3HobOAfr3P-\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0NDA0LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc5MjI0Ng==",
        "titleTranslations": [
            {
                "value": "Digital Talks: The Hotel of the Future",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 09:50:00",
        "endsAt": "2024-04-30 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/LqJ95489iow?si=uicacX2y5VIUerj_\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Turab",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDM1MjE4LFVzZXJfMTU3NTczMzIp",
                "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure - MENA",
                "lastName": "Saleem",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e8f6578826434c8cbc89db951fa9a9e2.jpeg",
                "organization": "Knight Frank",
                "biography": "An accomplished and meticulous professional with 22 years of proven success record in various aspects of the hospitality industry including Asset Management, Hotel Development, Tourism Development, Restaurant Development/Management, Hotel Management and Project Management. With Master’s in hospitality from NYU and Bachelor’s in Hotel Management from Swiss Hotel Institute, his consulting experience includes projects with a value of approximately USD 64  Billion. He has worked in various continents including Europe, US and the Middle East holding senior positions. He has been involved in consulting some of the successful Hospitality projects globally including :-   Paris, Miami, New York, London, Hong Kong, Dubai, Riyadh, Doha particularly with major hotel and consultancy groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0Ng==",
                                    "title": "Digital Talks: The Hotel of the Future",
                                    "beginsAt": "2024-04-30 09:50:00",
                                    "endsAt": "2024-04-30 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
        "titleTranslations": [
            {
                "value": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:00:00",
        "endsAt": "2024-04-30 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/mOJdxvPiVF0?si=Gaii8Z1fiiXFFAG-\" target=\"_blank\">Click here to watch online</a></p><p><strong>Emma Banks, </strong>VP of F&B Strategy & Development for Europe, Middle East and Africa, Hilton followed by a conversation with J<strong>ennifer Pettinger-Haines,</strong> Co-Founder, Global Restaurant Investment Forum; Partner, THINK Hospitality</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Emma",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDAwNTU3LFVzZXJfMTQzNjQzMik=",
                "jobTitle": "VP, F&B Strategy and Development EMEA",
                "lastName": "Banks",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6931016ab4e64957a53dff385397a780.jpeg",
                "organization": "Hilton",
                "biography": "Based at Hilton’s MEA Regional Office in Dubai, Emma Banks is responsible for F&B strategy and development across Europe, the Middle East and Africa supporting Hilton’s trading and future pipeline of hotels. \n \nOver the course of Emma’s career, she has seamlessly transitioned from independents to large global hospitality companies. She joined Hilton in 2019 with a mission to make the company the clear leader in food and drink. In but a short time she has made a big impact, bringing a wealth of exceptional F&B specialist talent into the business while being actively involved in Hilton’s various ESG initiatives. \n\nEmma recognizes the critical responsibility that food and drink plays in protecting the planet and has been involved in several market-leading initiatives over the last decade to reduce single-use plastics, track food waste and source ingredients locally, which was recognised at Gulfood, when Emma was named Sustainability Professional of The Year 2023, and most recently as Sustainability Champion of the Year at the Hotelier Middle East awards 2023.\n\nEmma is also a role model to women in the industry, ranking #1 in Caterer Middle East’s “2020 Women in F&B” Power List. At the end of 2020 Emma was elected a Member of the Board of Governors and Member of the Board of the Academic Committee of Dubai College of Tourism (DCT). In 2023, Emma was acknowledged with a Middle East Women Leader Award at the World Women Leadership Congress Awards Middle East, for her contribution to the promotion of empowerment and social change, she was also included in the 2023 Top Women in Travel and Hospitality report by Women Leading Travel & Hospitality and most recently as the Winner of the Excellence in Hospitality category at FilmFare’s Most Influential Women Awards 2024.\n\nEmma holds a Bachelor’s Degree from Leeds University and lives in Dubai with her husband Jon, beloved daughter Lily and a menagerie of rescue cats and dogs!",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                                    "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                                    "beginsAt": "2024-04-30 10:00:00",
                                    "endsAt": "2024-04-30 10:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jennifer",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NDg4MjIxLFVzZXJfMTgyMTg1NTEp",
                "jobTitle": "Co-Founder, Global Restaurant Investment Forum",
                "lastName": "Pettinger-Haines",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
                "organization": "Partner, THINK Hospitality",
                "biography": "Since joining the Bench team in 2008, Jennifer has been an integral part of growing the events portfolio. In 2013 she introduced the Arabian Hotel Investment Conference (AHIC) Regional Briefings Series, expanding AHIC’s presence throughout the region and in 2014 launched the Global Restaurant Investment Forum (GRIF) in Dubai. When not at a conference bossing around the hotel industry’s movers and shakers, Jennifer is working tirelessly to bring hotel and restaurant Attendeess scintillating conference sessions. During her time with Bench, she has amassed a large number of air miles, running conferences on most continents. In doing so she has taken full advantage of exploring the shopping, nightlife and restaurants on offer from Kigali to Casablanca as she firmly believes the world is there to be explored. One of her proudest achievements is being a part of the Bench Mt Kili Madness team which broke the World Record for the highest game of cricket ever played raising over £200,000 for charity. Currently residing in Dubai she has lived on four continents but will always call Sydney home.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
                                    "title": "Global Restaurant Investment Forum - Welcome",
                                    "beginsAt": "2024-04-29 09:00:00",
                                    "endsAt": "2024-04-29 09:10:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                                    "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                                    "beginsAt": "2024-04-30 10:00:00",
                                    "endsAt": "2024-04-30 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                                    "title": "Bringing Riyadh’s culinary heritage back to life",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTYzNQ==",
        "titleTranslations": [
            {
                "value": "Announcement #2",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:00:00",
        "endsAt": "2024-04-30 10:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDk1OA==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:05:00",
        "endsAt": "2024-04-30 10:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDk3NA==",
        "titleTranslations": [
            {
                "value": "Let's meet the Future with Desi",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:30:00",
        "endsAt": "2024-04-30 10:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/JVre5EAk10g?si=LjpJ-qDnMNyfw1mk\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Desdemona",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDM2MTY3LFVzZXJfMTg3Njk2Nzgp",
                "jobTitle": "Humanoid Robot",
                "lastName": "(Desi)",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e5aedb9990a24dc78adc0d6502f61239.png",
                "organization": "Lead Vocalist of the Desdemona Dream Band",
                "biography": "Desdemona, also known as “Desi,” is a humanoid robot and the lead vocalist of Desdemona's Dream band. Created by master artist and roboticist David Hanson and his team at Hanson Robotics, Desi runs on music and electricity and is on a mission to share her belief that the world can be changed for the better through the power of AI in the creative arts. She is the sister of the famous Sophia robot and joins her bandmates, including AI scientist Benjamin Goertzel on keyboards, to bring a unique and visionary performance to audiences. The band’s live shows showcase Desi’s AI-generated spoken word poetry and music, all the while supporting their mission to revolutionize the music industry through decentralized systems and blockchain technology. With her positive message and unique perspective, Desdemona is on a journey to help artists and humanity see a brighter future.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNzQ1Ng==",
                                    "title": "Press Conference with Desdemona",
                                    "beginsAt": "2024-04-30 17:00:00",
                                    "endsAt": "2024-04-30 17:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Tech & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTYzNw==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #3",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:30:00",
        "endsAt": "2024-04-30 10:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTg0MjgwMg==",
        "titleTranslations": [
            {
                "value": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:40:00",
        "endsAt": "2024-04-30 11:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/U8yEsiUElPI?si=QBtVeWn-K1sNowOT\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Amr",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzgyNDc1LFVzZXJfMTM1MDUwOTEp",
                "jobTitle": "Head of Hotels & Hospitality MEA and Managing Director, Global Hotel Desk",
                "lastName": "El Nady",
                "photoUrl": "https://static.swapcard.com/public/images/982df6695622462cb476e3a7cc2650db.jpeg",
                "organization": "JLL",
                "biography": "Amr leads the Hotels Advisory and Transactions business for JLL in the Middle East and Africa. He also advises Middle Eastern investors in defining and executing their international hotel investment strategies through JLL’s Global Hotels Desk platform. As the Head of Hotels & Hospitality, Amr has overall responsibility for the strategic direction and growth of JLL’s hotel business in the Middle East and Africa. He is also an integral part of the Global Hotel Desk team and is currently involved in a wide range of hotel advisory and investment sale instructions for single asset and portfolio transactions, with a focus on cross-border investment activities primarily from the Middle East. In addition, he also provides hotel investment services to private and institutional investors across the Middle East region.\n\nAmr has over 15 years’ experience within the hospitality industry. He has been involved in numerous assignments including Transaction Advisory services, Development Consulting, Operator Search and Selection, Strategic Portfolio Advice and Investment Sale Instructions. Amr also worked in JLL’s Hotels & Hospitality team and Northern European Investment Sales team based in London, UK, where he was heavily involved in acquisition and sale mandates for several iconic trophy hotels, as well as asset portfolios across the UK and Northern Europe.\n",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hossam",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODEwNzY4LFVzZXJfMTU4NDA0MzMp",
                "jobTitle": "General Manager Corporate Banking Group",
                "lastName": "Al-Basrawi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/658ff82efa1e4d6cb2bdfd0126429425.jpeg",
                "organization": "Alrajhi Bank",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Coley",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NTUzNzkzLFVzZXJfMTY1Nzk5Nyk=",
                "jobTitle": "Partner, Head of Europe",
                "lastName": "Brenan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/912f9161493048bfb746abf77baac9cd.jpeg",
                "organization": "KSL Capital Partners",
                "biography": "Coley Brenan, Partner, KSL Capital Partners, runs the KSL European office, based in London. KSL is a leading private equity firm with approximately $8.0 billion of equity capital commitments raised since 2005 and a 20-year track record of making investments exclusively in travel and leisure businesses.\n\nThrough its investment vehicles, KSL has owned, operated and franchised some of the largest and most renowned hotel and resort properties in the United States and Europe, including approximately 62,000 hotel rooms, 1,100 restaurants, 575 retail stores, 1,100 spas, 700 leisure clubs and 300 golf courses with 1,100,000 members, 30,000 skiable acres with 260 ski lifts and 12 aviation FBOs.\n\nIn Europe, KSL currently own, The Pig Hotels, a collection of award-winning rural boutique hotels located throughout southern England, Beaumier, a collection of 12 boutique hotels located in France, Spain, and Switzerland; Village Hotels, a collection of over 30 hotels located throughout the UK; Cameron House Hotel, a golf resort on the shores of Loch Lomond, Scotland; Zien Hotels, a collection of 12 city center hotels in the Netherlands; Third Space, a collection of 9 premium fitness clubs located across London and Le Sereno Hotels, multi-award-winning ultra-luxury hotel chain comprising: Il Sereno located on the shores of Lake Como, Italy, and Le Sereno on the beach at Grand Cul de Sac on the island of St. Barthelemy.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                                    "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                                    "beginsAt": "2024-04-30 10:40:00",
                                    "endsAt": "2024-04-30 11:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0MQ==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #4",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 10:45:00",
        "endsAt": "2024-04-30 11:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU3OA==",
        "titleTranslations": [
            {
                "value": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:00:00",
        "endsAt": "2024-04-30 11:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/6Vq0wWGTS_g?si=wk50rKSNbjJPqN-F\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ashraf",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzc2NDMyLFVzZXJfMTYwMDA0ODcp",
                "jobTitle": "Chief Hospitality Officer",
                "lastName": "Qasem",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b573a490063b4424afa5fea09eb971bb.jpeg",
                "organization": "Al Othaim Investments",
                "biography": "Ashraf Qasem, is a seasoned executive in the hospitality industry, recognized for his exceptional leadership in overseeing C-Suite and Board level operations. With a strong foundation in contract negotiation, revenue profit growth, and stakeholder relations, Ashraf has demonstrated outstanding results in both commercial and residential ventures. His expertise spans project planning, technical and cost analysis, facility upgrades, community revitalization, and innovative service integration, making him a pivotal force in propelling companies to industry forefronts.\n\nAshraf's notable achievements include leading prestigious hospitality projects, managing a real estate portfolio valued over 7 billion Riyals, and setting operational standards that significantly boosted team performance. His roles have encompassed Chief Hospitality Officer at Abdullah Al Othaim Investment Co., where he launched a new hospitality brand, expanded the hotel portfolio, and integrated hospitality services with various sectors to enhance customer experience. Previously, as an Assets Director and Senior Director in asset management, Ashraf has safeguarded property operations, increased operational efficiency, and led major hospitality and real estate initiatives across the Middle East.\n\nEducationally, Ashraf holds an MBA in Business Administration and Management from the University of East London and a Bachelor in Business Administration in Accounting and Finance. His professional development is further complemented by certifications in Hotel Real Estate Investments and Asset Management from Cornell University and membership in the Hospitality Asset Managers Association MEA. Ashraf's skills in hospitality management, strategic planning, project management, and leadership have been instrumental in opening hotels, negotiating contracts, and driving the hospitality industry forward.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Siew Kim",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4Nzc0NzMyLFVzZXJfMjIzMjkwOSk=",
                "jobTitle": "Chief Financial & Sustainability Officer, Lodging",
                "lastName": "Beh",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e8dcfc0631a453eb56f07e2d300faab.jpeg",
                "organization": "CapitaLand Investment Limited / The Ascott Limited",
                "biography": "Ms Beh Siew Kim is the Chief Financial & Sustainability Officer, Lodging, CapitaLand Investment with a concurrent role as Managing Director, Japan and South Korea, The Ascott Limited.  She oversees all aspects of Lodging’s finance, treasury, and Attendeess relations functions, and lead Lodging’s sustainability efforts.  In addition, she has an oversight on the Ascott’s business and operations in Japan and Korea. \n\n\nShe is also the non-executive director on CapitaLand Ascott Trust (CLAS), a Sponsorsed trust by The Ascott Limited. CLAS is Asia’s largest hospitality trust listed in the Singapore Stock Exchange, with a Asset under Management of US$6billion.  \n \nPrior to this, Ms Beh was the Chief Executive Officer of the Managers of CLAS. Under her leadership, CLAS has also been recognised for its excellence in sustainability and corporate governance. CLAS was named the ‘Global Sector Leader – Hotel’ in the Global Real Estate Sustainability Benchmark, ranked 1st in the Singapore Governance and Transparency Index for REITs and Business Trusts and was also the first hospitality trust globally to issue a sustainability linked bond in April 2022. \n \nMs Beh has over 30 years of experience in financial, investment, asset management, corporate planning, compliance and audit.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Khalid Saud",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczOTU4LFVzZXJfMTYxNDU2ODkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abu Haimed",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/047feab9eb2745eb9cc8cbfdd1cd09e2.jpeg",
                "organization": "Al Khozama Investment Company",
                "biography": "Mr. Khalid Abuhaimed is recognized as one of the Kingdom’s top business leaders and is well-known for his track record of success, leadership and strategic vision across several organizations in both the private and public sectors.\n\nBeginning his career in banking, Mr. Abuhaimed held a variety of positions from 1997 to 2009 with SAMBA (now part of SNB) and Emirates Bank (now Emirates NDB).\n\nIn 2009, Mr. Abuhaimed joined the Al Rajhi Investment Group, one of Saudi Arabia’s leading business groups, where, over the course of a decade, he undertook several management roles and was ultimately appointed as the Group’s Chief Executive Officer. As CEO, Mr. Abuhaimed played the key role in successfully driving the Group’s growth and diversification plan, including developing a hospitality project in Mecca with over 6500 keys and concluding the largest hotel management agreement ever undertaken at the time with two international global brands.\n\nIn 2019, Mr. Abuhaimed was appointed as Chief Executive Officer of the Camel Club, a Saudi governmental organization dedicated to preserving, caring for and promoting camels as a cherished part of the Kingdom’s heritage. Under Mr Abuhaimed’s leadership, the club experienced unprecedented growth and success, becoming a focal point for camel enthusiasts, advocates and research. Mr. Abuhaimed’s strategic vision and passion for cultural heritage played a pivotal role in expanding the Camel Club's reach and impact and positioning it as a leader in implementing the Kingdom’s cultural and heritage vision.\n\nIn 2020, Mr. Abuhaimed assumed the role of Group Chief Executive Officer for Al Khozama Investment Company, the investment arm of the King Faisal Foundation. Al Khozama owns and operates the Al Faisaliah District in Riyadh, which includes the iconic Al Faisaliah Tower, the Mandarin Oriental Al Faisaliah Hotel, the Al Faisaliah Mall, the King Faisal Foundation Building and several top restaurants including LPM, Mamo and Yauatcha. At Al Khozama, Mr. Abuhaimed also created Maiz, the Kingdom’s premier Saudi fine-dining restaurant, which is located in Diriyah, and expanded the Company’s hotel management business in the Central and Western regions. Mr Abuhaimed’s dynamic leadership in the hospitality and F&B sectors, coupled with his commitment to Saudi heritage, has positioned the Company for future success in the rapidly expanding hospitality and tourist industry, which is a central pillar of the Kingdom’s Vision 2030 Plan. In addition to his role at Al Khozama, Mr. Abuhaimed holds several board positions in the hospitality sector and serves on the board of Landmark Arabia, one of the largest private sector retailers in the Kingdom.\n\nMr Abuhaimed is widely recognized in Saudi Arabia for his leadership, vision, integrity and ability to drive organizational change. He is passionate about fostering a culture of innovation and collaboration, empowering teams to achieve their full potential and to deliver exceptional results.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3Mw==",
                                    "title": "Opening Address",
                                    "beginsAt": "2024-04-29 15:30:00",
                                    "endsAt": "2024-04-29 15:40:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ahmed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTE5OTgwLFVzZXJfMTg0NTEzODcp",
                "jobTitle": "Chief Investment Officer",
                "lastName": "Bin Madhi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6b4df4542aeb487e81145e64beb7e9e6.png",
                "organization": "Rua Al Madinah Holding Company",
                "biography": "Ahmed Bin Madhi is the Chief Investment Officer of Rua Al Madinah Holding Company, a wholly-owned subsidiary of Saudi Arabia’s Public Investment Fund (PIF) that aims to elevate the experience of residents and visitors to the holy city of Madinah through a range of holistic urban development projects. With over a decade of experience in the real estate development and investment banking industries, Mr. Bin Madhi oversees the company’s full range of Investment, Business Development, Hotel Asset Management, and Strategic Business Unit activities.\n\nPrior to joining Rua Al Madinah in 2018, Mr. Bin Madhi held senior positions at Alrajhi Investment, the real estate arm of Awqaf Sulaiman Alrajhi Holding Company. There, he oversaw a large portfolio of assets (with a particular focus on hospitality properties), across the holy cities of Makkah and Madinah. He has also held several key roles at Global Investment House Saudi Arabia, a leading regional asset management and investment banking firm, where he advised a wide range of high-profile clients across the Kingdom and the wider region.\n\nMr. Bin Madhi holds a bachelor’s degree in Banking and Finance from the University of Science and Technology, as well as a Hotel Real Estate Investments and Asset Management Certificate from Cornell University, New York.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Edie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTQ4NDM4LFVzZXJfNTgzNjYwOCk=",
                "jobTitle": "Member of the Board of Directors",
                "lastName": "Rodriguez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f6b3f788b42a407dab1e342850d9aba0.jpeg",
                "organization": "Saudi Tourism Authority",
                "biography": "Edie Rodriguez is a highly accomplished travel industry CEO and Member of the Board of Directors who delivers billion-dollar outcomes across luxury, luxury travel, retail, and technology industries. As a “mobile global” executive and positive disrupter, she has honed a 35+ year career across sales, operations,marketing, digital, and social distribution channels to transform during her tenure some the world’s most recognizable global cruise brands including Crystal Cruises Corporation, Royal Caribbean’s Azamara Cruises, Carnival Corporation’s Cunard, Seabourn and Carnival brands and Ponant Cruises. As an award-winning leader with strong corporate governance, financial and business acumen, she is sought after for companies seeking to establish market leadership and global brand dominance. Edie is a Member of the Board of Directors for the Saudi Tourism Authority (STA), where she is the Chair of the Nominating and Remuneration Committee. The STA was formed and is funded by the Kingdom of Saudi Arabia’s Public Investment Fund in line with their #SaudiVision2030 goals.\n\nIn addition to Board guidance on compensation and governance, she assists the teams with scaling and expanding in to new markets and advising on strategic cobranding opportunities. Previously, Edie was a Director for RAND Corporation’s Center for Global Risk and Security (CGRS) from 2017 through 2020. As an Advisory Board Member she provided governance and fiduciary guidance, advising from billion-dollar corporations’ perspectives.\n\nShe has been an Advisory Board Member to the Retail Summit since its inception. Mrs. Rodriguez’s academic qualifications include a Bachelor of Science from Nova Southeastern University and has attended the Executive Management Programs at Harvard, Stanford and Wharton. She is deeply skilled in the science of governance, relationships and executive leadership effectiveness.\n\nThroughout her career she has been the recipient of many global awards including EY’s Entrepreneur of the Year Award.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0Mg==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #5",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:00:00",
        "endsAt": "2024-04-30 11:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0Mw==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #6",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:15:00",
        "endsAt": "2024-04-30 11:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDIzNw==",
        "titleTranslations": [
            {
                "value": "Giving people purpose: What is the secret to attracting and retaining the best talent in F&B? What do you need to consider when building and managing your team?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:30:00",
        "endsAt": "2024-04-30 11:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/BfZsmy4G4bU?si=p4vC1amXpIWQlFj7\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Greg",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDk4MTc3LFVzZXJfMTIyMTk5OSk=",
                "jobTitle": "Co-Founder & Managing Partner",
                "lastName": "Wright",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/332bde98a705475ab2931065e2b606e3.jpeg",
                "organization": "Food People",
                "biography": "An entrepreneur with over 15 years of experience in the food industry, Greg is not only a moderator and keynote speaker, but also the Co-Founder of Food People. Established in 2017, Food People has since become one of the most renowned consultancy firms in the food and beverage sector, supporting some of the most innovative food businesses in the UAE.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNw==",
                                    "title": "Giving people purpose: What is the secret to attracting and retaining the best talent in F&B? What do you need to consider when building and managing your team?",
                                    "beginsAt": "2024-04-30 11:30:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Roaya",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzNTAyLFVzZXJfMTU2NTk0Nyk=",
                "jobTitle": "Founder, Villa Mamas",
                "lastName": "Saleh",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e20fcbf2e38740a59f99836830b72e47.jpeg",
                "organization": "President & Founder, RS Management WLL",
                "biography": "Chef Roaya Saleh is the President and Founder of RS Management WLL, registered in the Kingdom of Bahrain to provide consultancy in the hospitality industry across the globe. Chef Roaya is also the founder of Villa Mamas Restaurant Group since 2012, the group has opened restaurants in Bahrain, London, Abu Dhabi and Riyadh, employing over 200 staff. Villa Mamas restaurants provide full-service and retail offerings in-store and through an international online store selling products such as tea, spices, condiments and homeware.\n\nChef Roaya has been featured in numerous TV shows as a culinary guest expert and judge for Masterchef and Top Chef Arabia, as well as being featured in Forbes and Financial Times. She has published two cookbooks in both English and Arabic. Chef Roaya has won various accolades recognizing her success as a businesswoman such as The Bahrain Award for Entrepreneurship, Woman of the Year and has been internationally recognized for her innovative and successful business model. She has been honoured for her philanthropic work in the Kingdom of Bahrain by the Supreme Council and other NFP organizations. She continues to focus on the empowerment of young women especially and is invested in mentoring and inspiring the younger generations to come both in the culinary field and elsewhere in the world of business as whole.\n\nIn addition to driving Villa Mamas’ brand awareness across the GCC and Europe through partnership, Chef Roaya partnered exclusively with Shangri-La Bosphorous Istanbul to show case her sell-out dishes.\n\nRoaya is very active in the day-to-day management of all Villa Mamas restaurants and is looking forward to expanding both the Villa Mamas brand as well as exciting new concepts worldwide.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNw==",
                                    "title": "Giving people purpose: What is the secret to attracting and retaining the best talent in F&B? What do you need to consider when building and managing your team?",
                                    "beginsAt": "2024-04-30 11:30:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lyndsey",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjY4MzYyLFVzZXJfMTU3MTY3NDUp",
                "jobTitle": "Director",
                "lastName": "Scott",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/77a90ce238794634997f871479c6c8c8.jpeg",
                "organization": "MJS Investment",
                "biography": "With 17 years’ experience within Hospitality and People Leadership, Lyndsey joined MJS Investment in 2021 coming from Hyatt Hotels. Lyndsey’s experience with Hyatt International spanned 13+ years having led the HR function in Grand Hyatt Melbourne, Australia and subsequently in an Area capacity across Qatar, Oman and Kuwait. Lyndsey has presented as an Expert Speaker and Panelist at several summits across Melbourne, Sydney as well as Singapore. She holds a Bachelor of Business (Major Tourism, Minor HR Management) and completed Post Graduate studies in in Psychology. Lyndsey strives lead teams to cultivate a culture giving people a strong sense of belonging and to inspire others to grow beyond their comfort zones. She is a strong advocate for building Saudi Talent and lends her experience within the Hospitality industry with key focus on supporting Saudi Vision 2030.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNw==",
                                    "title": "Giving people purpose: What is the secret to attracting and retaining the best talent in F&B? What do you need to consider when building and managing your team?",
                                    "beginsAt": "2024-04-30 11:30:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Henrik",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzNzE3LFVzZXJfMTkxMzc1MjYp",
                "jobTitle": "Founder",
                "lastName": "Winther",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/059744487ea44606b520869783c26a9e.jpeg",
                "organization": "Tigrus Holding",
                "biography": "With a deep-rooted passion for sustainability and a love of restaurants, Henrik Winther, an enthusiastic entrepreneur and respected industry leader, steps forward into the UAE food & beverage scene to bring Tigrus Holding to the GCC with the launch of Shvili and Osteria Mario at Dubai Hills Mall.\n\nOriginally from Denmark, Henrik’s interest in the hospitality industry began at a young age. He has over 40 years of international experience in CIS, France and the USA and has launched over 430 restaurants globally throughout his career. Henrik operates a sustainable business model at Tigrus Holding through many environmentally friendly initiatives, including zero-waste restaurants and Sponsorsing wildlife.\n\nTigrus Holding was founded in 2005. It has a presence in the Middle East, Eastern Europe and Central Asia and operates 54 restaurants globally including Osteria Mario and Shvili. Tigrus follows a sustainable and eco-friendly philosophy that strives to restore and maintain the planet's resources. It's the first and only restaurant holding in Europe to fully compensate for its carbon footprint, and since 2018 has followed a path of conscious consumption and zero waste across all its outlets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNw==",
                                    "title": "Giving people purpose: What is the secret to attracting and retaining the best talent in F&B? What do you need to consider when building and managing your team?",
                                    "beginsAt": "2024-04-30 11:30:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0NA==",
        "titleTranslations": [
            {
                "value": "Announcement #3",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:30:00",
        "endsAt": "2024-04-30 11:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTg1Nzg0OA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks:  Leveraging the Momentum of Developments in the Kingdom towards Vision 2030 Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:40:00",
        "endsAt": "2024-04-30 11:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/7qACHmXPHX0?si=TNbIp6QMR8NVJ0ym\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDA0NjMzLFVzZXJfMjMxNzA3OSk=",
                "jobTitle": "Industry Leader Hospitality and Tourism EMEA; Managing Partner Global Center of Excellence Tourism & Hospitality",
                "lastName": "Mayer",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9260ea72f29c4a1f83d82b4462921838.jpeg",
                "organization": "PwC",
                "biography": "Nicolas is PwC’s global industry leader for the entertainment and tourism industry and the Managing Leader of PwC’s Global Center of Tourism Excellence, which has recently moved from Switzerland to the Middle East. Nic has has advised well over 40 local and global hotel operators on matters of operational effectiveness, standardization of identity delivery and operating standards. Prior to joining PwC, Nicolas worked in corporate, quality management and pre opening functions for Ritz Carlton, Hyatt, and Hilton. In that function, he was responsible for the pre-opening, planning, and operations ramp up for 10+ hotels in Indonesia, Spain, the USA, and Germany. Nicolas graduated with a BSc in Hotel Administration & Finance from Cornell University. He is a member of the advisory board of the World Tourism Forum and is a member of the World Travel & Tourism Council. He is a regular lecturer at hotel schools in Switzerland, Ireland, the Netherlands, the USA and the UAE.\n\nRelevant work experience\n\nLed the national destination readiness assessment for the Saudi Ministry of tourism\nLed the national-level destination management strategies of various countries across Europe, Asia and the Middle East.\nLed the sector diagnostic assessment of the tourism and culture sector in the UAE. The sector diagnostic provided decision makers at the center of government with a clearer understanding of the existing sector pain points and the associated root cause, which are directly related to the identified beneficiaries.\nLed the institutional strategy for Department of Tourism and Commerce Marketing in Dubai implementing city-wide initiatives to boost tourism to the Emirates\nLed the assignment to assist the City of Lucerne, Switzerland, to redesign the City-wide visitor guest journeys, infrastructural and experiential modifications and the experience strategy. This assignment was delivered in order to optimize the significant new visitor flow of Chinese visitors to the city. The mandate resulted in a new experience concept including watch and chocolate manufacturer partnerships, a new traffic flow management system and an optimization of visitor flows, resulting in a near-doubling of per chinese visitor spend in Lucerne’s commerces.\nFor a European Capital, led the assignment to redesign the entire visitor journey management strategy. The mandate included redesign of guest journey, creation and augmentation of commercial and cultural activation zones, marketing strategy, flow management and a new commercialisation strategy in collaboration with international tour operators.\nLed the mandate to entirely redesign the visitor journeys for a european, mid-size luxury hotel brand with approx 100 hotels. The mandate included brand activation, guest journey design, flow analysis, commercial platform design, as well as a structures visitor experience quality management system.\nDelivered additional assignments with relevant and significant touch points to Hotel Operator guest journey and visitor experience design for companies such as Accor, Shangri-La, Chiva Som, Fleming Hotels, Dorchester Collection, IHG (Intercontinental), Corinthia Hotels, Club Med, Steigenberger, Moevenpick, Mandarin Oriental as well as for several Hospitality Schools and National Government.\nEducational Background & Qualifications\n\nB.Sc Hotel Administration & Finance, Cornell University, USA\nUS CPA\nAreas of Expertise\n\nTourism and hospitality operations\nEntertainment\nStrategy Development\nNational Government transformation",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1Nzg0OA==",
                                    "title": "TenX Leadership Talks:  Leveraging the Momentum of Developments in the Kingdom towards Vision 2030 Success",
                                    "beginsAt": "2024-04-30 11:40:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jean-Jacques",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA4ODc4LFVzZXJfNTUzMDg3KQ==",
                "jobTitle": "Group Deputy CEO and Premium, Midscale & Economy Division CEO",
                "lastName": "Morin",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/96add8627cc94ae29086196e24ee65b6.jpeg",
                "organization": "Accor",
                "biography": "Jean-Jacques Morin is a graduate of the Ecole Nationale Supérieure de l'Aéronautique et de l'Espace, holds an MBA from Thunderbird School of Global Management (Arizona State University) and is qualified with the French Institute of Chartered Accountants, the Ordre des Experts Comptables.\n\nHe began his career with Deloitte where he spent five years in Audit and Consulting, first in Paris and then in Montreal. He continued to work internationally in the semiconductor sector for 13 years, at Motorola, ON Semi in Arizona, and lastly at Communicant AG, a Berlin-based start-up. He joined Alstom in 2005 as CFO for the Power sector in Zurich and then Transport sector, before being appointed Group CFO.\n\nJean-Jacques joined Accor’s Executive Committee as CFO in 2015 and was later appointed Deputy CEO responsible for Finance, Strategy, IT, Legal Affairs, Procurement and Communications.\n\nIn January 2023, in addition to his current role as Group Deputy CEO, he also took under his leadership the Group’s Premium, Midscale & Economy division as division CEO.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1Nzg0OA==",
                                    "title": "TenX Leadership Talks:  Leveraging the Momentum of Developments in the Kingdom towards Vision 2030 Success",
                                    "beginsAt": "2024-04-30 11:40:00",
                                    "endsAt": "2024-04-30 11:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0Ng==",
        "titleTranslations": [
            {
                "value": "Announcement #4",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:45:00",
        "endsAt": "2024-04-30 12:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
        "titleTranslations": [
            {
                "value": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:55:00",
        "endsAt": "2024-04-30 12:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/iVpjbp34lXo?si=e0q3S_adzflF_4cq\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Eng. Abdulaziz",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMTc3MjExLFVzZXJfMTkyMDk5ODkp",
                "jobTitle": "Director General, Investment Development Division",
                "lastName": "M. Al-Shanqiti",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/df0dbe950d0e42cdb9471d071bc9e51f.jpeg",
                "organization": "Royal Commission for Jubail and Yanbu (RCJY).",
                "biography": "Eng. Abdulaziz M. Alshingiti is General Manager in the Royal Commission for Jubail and Yanbu (RCJY). With a career spanning over a decade, he has held various leadership roles, including Director General of the Investment Development Division since February 2022. He began his career as Mechanical Engineering Supervisor at Saudi Binladin Group and in February 2009, he transitioned to his first role in RCJY as Manager of Residential Investment Development. Eng. Alshingiti steadily climbed the ranks, serving as Manager of Industrial Investment Development, Industrial Cluster Manager, and Director of Industrial Investment Development, among others. Beyond his individual accomplishments, he has also played an integral role in various committees for national transformation programs and national industrial strategies. Collaborating with experts from diverse backgrounds, he has contributed valuable insights and helped shape important initiatives that drive the growth and development of the RCJY. Eng. Abdulaziz graduated from King Abdulaziz University in Jeddah, Saudi Arabia with a Bachelor of Engineering and Desalination Technology.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Fahad",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDY3MDEwLFVzZXJfMTYxMzcwMTMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Bin Mushayt",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f777a708539f421bb26d3e7dfcc7daad.jpeg",
                "organization": "ASFAR",
                "biography": "Dr. Fahad bin Mushayt is the Chief Executive Officer at ASFAR, the Saudi tourism investment company that is a wholly owned subsidiary of the Public Investment Fund established to drive the growth of tourism investment in partnership with the private sector to create captivating destinations in Saudi Arabia for visitors from all over the world in line with Saudi Vision 2030.\n\nBoasting more than two decades of experience, Dr. Mushayt's illustrious career spans across multifaceted domains including city management, mega investments in real estate, mergers and acquisitions, strategic business development, and operations management. He has also taken on challenging roles in myriad sectors including information technology and telecommunications, as well as infrastructure development.\n\nBefore his tenure at ASFAR, Dr. Mushayt held pivotal positions in both government and semi-government entities. He spent nearly twenty years at the Saudi Telecom Group holding several other key positions including Chief Executive Officer of Mega Strategic Projects, Vice President for Business Development, and Vice President of Corporate Strategy and Performance. He then became the Chief Executive Officer of Saudi Telecom Specialized Company for three years. In 2021, he became Deputy Governor for Investment and Business Development at the State Property General Authority, after being Chief Executive Officer of the Diplomatic Quarter General Authority (DQGA) in Riyadh for three years.\n\nHe has also served on the boards of various organizations worldwide including Maxis Communication Berhad Holding Company in Malaysia, Aircel Company in India, and Axis Company in Indonesia, to name a few.\n\nDr. Fahad bin Mushayt holds a PhD in Economics, Political Economy and Public Policies from the University of Southern California and a master’s degree in economics from California State Polytechnic University, Pomona. He also holds a Bachelor of Science degree in Operations Research from King Saud University, Riyadh.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Abdulrahman",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDYzNjY1LFVzZXJfMTAwMzI1MTQp",
                "jobTitle": "Board Member",
                "lastName": "Albassam",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d6028e7cbc5c40a397604d38790ad73b.jpeg",
                "organization": "Baheej",
                "biography": "CEO, Tilal Real Estate Development Company\nFounder & Executive Chairman of AWN Enterprises\nBoard member Baheej Tourism Development Company\n\nAbdulrahman AlBassam is a fourth-generation member of AlBassam & Sons, one of the GCC’s oldest family businesses, and his personal commitment is to bring innovation and enthusiasm to the renowned enterprise.\n\nAbdulrahman’s entrepreneurial aspirations have however expanded even further. He founded together with his wife Norah AlTamimi AWN Enterprises in 2009 to manage a portfolio of investments. AWN has the strategic advantage of having the flexible entrepreneurial structure with the background and strong affiliation of legacy companies; that is AlBassam & Sons (found in 1914) and Tamimi Group (found in 1953).\n\nAbdulrahman is a founder and board member of several companies in the Professional Services and Hospitality sectors; the latest is Tilal Real Estate Development Company of which he serves as CEO and Baheej Tourism Development Company of which he serves as a Board Member and member of the Executive Committee. He is also a member in organizations such as the Asharqia Chamber Board of Directors and the Saudi Leaders Society.\n\nAbdulrahman is a Misk 2030 Leader, TEDx speaker, volunteers as a mentor for young entrepreneurs in profound incubators such as KFUPM Institute of Entrepreneurship and holds an MBA from the University of Strathclyde (UK) and a BSc in Geophysics from the University of Calgary (Canada).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Edie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTQ4NDM4LFVzZXJfNTgzNjYwOCk=",
                "jobTitle": "Member of the Board of Directors",
                "lastName": "Rodriguez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f6b3f788b42a407dab1e342850d9aba0.jpeg",
                "organization": "Saudi Tourism Authority",
                "biography": "Edie Rodriguez is a highly accomplished travel industry CEO and Member of the Board of Directors who delivers billion-dollar outcomes across luxury, luxury travel, retail, and technology industries. As a “mobile global” executive and positive disrupter, she has honed a 35+ year career across sales, operations,marketing, digital, and social distribution channels to transform during her tenure some the world’s most recognizable global cruise brands including Crystal Cruises Corporation, Royal Caribbean’s Azamara Cruises, Carnival Corporation’s Cunard, Seabourn and Carnival brands and Ponant Cruises. As an award-winning leader with strong corporate governance, financial and business acumen, she is sought after for companies seeking to establish market leadership and global brand dominance. Edie is a Member of the Board of Directors for the Saudi Tourism Authority (STA), where she is the Chair of the Nominating and Remuneration Committee. The STA was formed and is funded by the Kingdom of Saudi Arabia’s Public Investment Fund in line with their #SaudiVision2030 goals.\n\nIn addition to Board guidance on compensation and governance, she assists the teams with scaling and expanding in to new markets and advising on strategic cobranding opportunities. Previously, Edie was a Director for RAND Corporation’s Center for Global Risk and Security (CGRS) from 2017 through 2020. As an Advisory Board Member she provided governance and fiduciary guidance, advising from billion-dollar corporations’ perspectives.\n\nShe has been an Advisory Board Member to the Retail Summit since its inception. Mrs. Rodriguez’s academic qualifications include a Bachelor of Science from Nova Southeastern University and has attended the Executive Management Programs at Harvard, Stanford and Wharton. She is deeply skilled in the science of governance, relationships and executive leadership effectiveness.\n\nThroughout her career she has been the recipient of many global awards including EY’s Entrepreneur of the Year Award.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OA==",
                                    "title": "Crafting a Diverse Portfolio: Maximizing Financial Resilience Through Multi-Asset Allocation",
                                    "beginsAt": "2024-04-30 11:00:00",
                                    "endsAt": "2024-04-30 11:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                                    "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                                    "beginsAt": "2024-04-29 16:30:00",
                                    "endsAt": "2024-04-29 17:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Marloes",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDIyLFVzZXJfMTEyODE0MDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Knippenberg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "Marloes is a distinguished hospitality leader who has been instrumental in redefining industry benchmarks. She seamlessly integrated ESG (Environmental, Social, and Governance) into the heart of business operations, processes, and value propositions. This integration has proven transformative, elevating a singular national brand to a global lifestyle group with a portfolio spanning over 45 diversified projects.\n\nMarloes' commitment to excellence is underscored by her strategic vision. She actively pursues the expansion of the brand's lifestyle portfolio, targeting regions identified for synergistic collaborations and mutual stakeholder objectives. Her foundational expertise is anchored in her tenure at Hilton, where she was entrusted with high-impact operational and commercial management portfolios.\n\nBeyond mere strategy and execution, Marloes is deeply committed to human capital development within the industry. She consistently champions the nurturing of emerging talents, propelling industry-wide transformation, and driving organizational alignment towards sustainability-centric objectives. This approach prioritizes not just bottom-line growth but also the holistic development of individuals, communities, and guest experiences.\n\nMarloes' advocacy for a progressive hospitality sector extends beyond traditional corporate parameters. As a notable ambassador for the Global Hospitality Student Challenge, spearheaded by Hotelschool the Hague, she is at the forefront of bridging the gap between the seasoned investment community and the visionary leaders of tomorrow. This initiative stands as a testament to her commitment to fostering innovation and collaboration, cementing her role in the ongoing evolution of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDQ5MQ==",
        "titleTranslations": [
            {
                "value": "Founder Chat: GRIF Case study \"V Modern Italian”: Redefining Value",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 11:55:00",
        "endsAt": "2024-04-30 12:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ManrhZLITUA?si=VpGDUYAXxPSkRJ_0\" target=\"_blank\">Click here to watch online</a></p><p>Designing your operations and outlet to maximise efficiency and save cost without sacrificing on guest experience.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Benjamin",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMTE2LFVzZXJfMTQzNjUwMCk=",
                "jobTitle": "Founder",
                "lastName": "Calleja",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ba53bbda2cd7412fbe327a2ad428c24f.jpeg",
                "organization": "Livit Design & Fast Fine Restaurant Group",
                "biography": "Benjamin is an entrepreneurial visionary who thrives at the intersection of innovation, creativity, and growth.\n\nAs the Founder & Chief Experience Officer of Livit Design (www.livit.design), Benjamin has spearheaded one of the world's largest F&B design and transformation companies. Livit’s focus on enhancing brand performance through guest experience design and operational efficiency has left an indelible mark on the industry. Active in over 40 countries, its influence can be felt as a Livit designed experience opens somewhere in the world every 8 hours.\n\nIn addition to his role at Livit Design, Benjamin is also the visionary behind the Fast Fine Restaurant Group (www.fastfine.com). This disruptive lifestyle hospitality company has rapidly expanded its portfolio, boasting a mix of corporate and franchised restaurants.\n\nBeyond his practical accomplishments, Benjamin holds two Master of Architecture degrees and is acknowledged as an international expert in hospitality, design, and innovation. He is a respected keynote speaker at universities, conferences, and industry events worldwide, sharing his wealth of knowledge.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ5MQ==",
                                    "title": "Founder Chat: GRIF Case study \"V Modern Italian”: Redefining Value",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTg5MjcxNw==",
        "titleTranslations": [
            {
                "value": "Workshop: How to Navigate the Path to Hotel Brand Search and Selection",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:00:00",
        "endsAt": "2024-04-30 12:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mubarak",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjI2MTg2LFVzZXJfMTkyMzc0ODMp",
                "jobTitle": "Hospitality BD Manager Investment and Asset",
                "lastName": "Alsufayan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/50e8d629d2ee4771aeba09b6938ec8da.jpeg",
                "organization": "Rua Al Madinah Holding Company",
                "biography": "Mubarak is an accomplished Hospitality Business Development Manager at Rua Al Madinah Holding with a strong background in negotiating deals with prominent hotel operators and ensuring legal compliance in contracts. With experience in executing strategic projects and analyzing performance metrics, he excels in asset management and optimizing operational efficiency. Mubarak's expertise extends to overseeing phases of hotels opening, handling performance of hotels day by day, and fostering partnerships to enhance hotel offerings. Mubarak Holding a master’s degree in hospitality management and a bachelor’s degree in Tourism Management, he combines academic knowledge with practical experience to drive success in the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MjcxNw==",
                                    "title": "Workshop: How to Navigate the Path to Hotel Brand Search and Selection",
                                    "beginsAt": "2024-04-30 12:00:00",
                                    "endsAt": "2024-04-30 12:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY0OQ==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #7",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:00:00",
        "endsAt": "2024-04-30 12:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
        "titleTranslations": [
            {
                "value": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:10:00",
        "endsAt": "2024-04-30 12:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/L7TCRlbNrN8?si=sf_V27lgoOWZ9iKz\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ashish",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDkzODk3LFVzZXJfMTI1NTEwMyk=",
                "jobTitle": "Co-founder & CEO",
                "lastName": "Tulsian",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ad7d6efcf1f043398a8ad3eb04cb61b4.jpeg",
                "organization": "Restroworks",
                "biography": "Ashish Tulsian is the Co-founder and Chief Executive Officer of Restroworks, a leading\ncloud-first technology platform for restaurants. Launched in 2012 as Posist, Ashish has steered the company into becoming an enterprise tech platform for restaurants. Today, Restroworks powers over 20,000 restaurants in 52 countries and is distinguished among the Top 100 Software companies with the highest customer satisfaction in restaurant management software, as recognized by G2's Best Software List 2023. The company is also a Great Place to Work-Certified™ by the Great Places to Work Institute.\n\nAshish is the product visionary behind the cloud-based platform and oversees Product, Growth, and Market Expansion. He is a rare blend of a Technocrat and a Restaurateur. Before founding Posist, Ashish began his entrepreneurial journey during his engineering days in 2007, venturing into the Telecom VAS (Value Added Services) sector with TechnoApex. After a successful exit from his first venture, his culinary passion prompted him to open a restaurant in New Delhi. The business challenges of the restaurant industry sparked his interest in developing a tech solution for restaurants, resulting in the foundation of Posist (now Restroworks), one of the industry-first cloud technology platforms for restaurants.\n\nIn addition to his executive role in the company, Ashish is an active angel investor and mentor to many entrepreneurs in the startup world. As of date, Ashish has made early-stage investments in over 40+ start-ups across the Middle East, India, and the United States. He is often heralded as an adept entrepreneur who has mastered the art of bootstrapping start-ups to scale. A sought-after keynote speaker, Ashish frequently represents the entrepreneurial, restaurant industry, and investment communities at international events, podcasts, and forums.\n\nAshish is recognized by The Times of India in India's top 40 under 40 entrepreneurs in 2023 list. His work and ideas are regularly featured in prominent media publications such as Fortune, The Economic Times, Entrepreneur Middle East, Wamda, and CNBC. Ashish holds a bachelor's degree in Technology from Bharati Vidyapeeth College of Engineering, India.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk2MA==",
                                    "title": "Maintaining bottom-line efficiency at scale",
                                    "beginsAt": "2024-04-29 12:30:00",
                                    "endsAt": "2024-04-29 13:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0NDA0LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY1MA==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #8",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:15:00",
        "endsAt": "2024-04-30 12:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2MA==",
        "titleTranslations": [
            {
                "value": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:25:00",
        "endsAt": "2024-04-30 12:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/sj84mYsnow0?si=yncFB8giYLV8--M4\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NTQ5MjAzLFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/431472c4cc334203850dac4f47ff261d.jpeg",
                "organization": "Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Fahad Abdulrahim",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDAzNTU0LFVzZXJfMTc5NDY0Mzkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Kazim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/cce6b9371ceb464091d2b84d9911355f.png",
                "organization": "Millennium Hotels & Resorts & Lakhraim Group",
                "biography": "Fahad Abdulrahim Kazim serves as the CEO of Millennium Hotels and Resorts MEA and Lakhraim Group, an investment firm specializing in strategic investments and ventures across diverse market sectors throughout the Middle East and North Africa region. In this capacity, he directs the strategic evolution of Tetra Hospitality and Millennium Hotels and Resorts MEA to establish it as a leading force in regional hospitality. With premium hotel properties in Dubai and Abu Dhabi under its ownership, Tetra Hospitality manages about 57 hotels and approximately 14,000 key hotels across diverse brands in the Middle East and Africa through Millennium Hotels & Resorts.\n\nBoasting over two decades of experience in real estate and professional services, Fahad's journey encompasses roles such as a Partner at KPMG Lower Gulf, where he held multiple key positions including Head of Infrastructure, Real Estate Advisory, and Head of Emiratization.\n\nPrior to his tenure at KPMG, Fahad contributed his expertise to several prominent real estate developers in Dubai, playing a pivotal role in driving growth and go-to-market strategies for transformative projects. His responsibilities spanned the entire lifecycle of developments, overseeing asset classes like residential, commercial, retail, and hospitality. Notable achievements include spearheading the launch of major ventures like City Walk, Blue Waters, Bulgari Resort and Residences, and Marsa Al Seef.\n\nThroughout his career, Fahad has held esteemed positions on prominent boards, including Emirates REIT, Dubai Parks and Resorts, and Emirates Transport. Currently, he is an active member of the Advisory Board for the Faculty of Business and Economics at the University of the Emirates.\n\nFahad's educational background comprises a BA in Accountancy from Concordia University in Canada, complemented by his status as a Chartered Accountant in the United States. His enduring dedication, versatile skill set, and visionary leadership consistently shape and elevate the realms of hospitality, real estate, and professional services.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Richard",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTI1MDUwLFVzZXJfNjc4NjMwMyk=",
                "jobTitle": "COO",
                "lastName": "Williamson",
                "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
                "organization": "The Considerate Group",
                "biography": "Richard Williamson is the COO of Considerate Group, a data-driven sustainability consultancy, focused on the hospitality and tourism sectors, with offices in London and New York and a local partner in Dubai. Richard oversees Considerate’s Middle Eastern business, having previously worked for KPMG and PwC in the UAE and Oman. \n\nConsiderate Group develops tailor-made ESG frameworks and sustainability strategies for hotels and tourism companies, working with owners, operators, SWFs and asset managers around the world.  As well as transition risk mitigation, Considerate focuses on delivering the financial benefits of investment.\n\nServices include asset-level and portfolio decarbonisation and net zero strategies, hotel energy assessments, ESG due diligence, certification and accreditation. Considerate also operates a data platform, Con-Serve™ a premier ESG data-intelligence platform tailored specifically to the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Investment & Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
        "titleTranslations": [
            {
                "value": "Bringing Riyadh’s culinary heritage back to life",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:25:00",
        "endsAt": "2024-04-30 12:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/g6MUgYFmaE0?si=7XZ3ZOaowvK1QM_d\" target=\"_blank\">Click here to watch online</a></p><p>Da Pino was Riyadh’s first Italian restaurant and the stepping stone to where Riyadh’s dining scene is today.  Why is Al Khozama bringing it back now?</p><p><strong>Jennifer Pettinger Haines</strong> In conversation with <strong>Cladys Magagna,</strong> Corporate Director of Food and Beverage, Al Khozama</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Cladys",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODEwNzQ4LFVzZXJfMTY4MzIwNzIp",
                "jobTitle": "Corporate Director of Food & Beverage",
                "lastName": "Magagna",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7cc5cd45d6194f1fa501e8934b130a43.jpeg",
                "organization": "Al Khozama Investment Company",
                "biography": "Born and raised in Cossato, a small village in Italy, Cladys brings a wealth of expertise in the Kingdom of Saudi Arabia, with an experience spanning over 25 years within renowned European restaurants, as well as leading hospitality companies and culinary institutions. He began his career in 1995 in his native country, Italy, at the Botticella Restaurant as a Chef, and from there held progressive managerial positions in different restaurants, such as Martinelli and Novelli in Austria, Vienna a 1 Michelin star. \n\nCladys moved in New York in 2002 working as Corporate Executive Chef and Culinary Instructor at the Italian Culinary Institute where he oversaw two magazines, Italian Cooking & Living and the Magazine of La Cucina Italiana, in addition to developing culinary courses, organizing menus and dining layouts for clients, as well as creating thousands of recipes for publications. \n\nIn 2005, he joined The Abraham Lincoln – Wyndham Historic Hotel in Pennsylvania as the Executive Chef in charge of managing the kitchen and developing 3 new restaurants concepts into the market. \n\nIn 2006 Cladys joined Fairmont Hotels & Resorts at the Fairmont Southampton in Bermuda and went to hold key leadership positions, including Executive Chef for both the Fairmont Acapulco Princess and the Fairmont Pierre Marques in Mexico, overseeing the entire kitchen operation for both properties, with a total of 24 restaurants, comprising over 478 colleagues, and a banqueting operation that could accommodate over 3000 guests. \n\nFrom 2012 to 2017 he moved to UAE working for the iconic Fairmont Bab Al Bahr as Executive Chef in charge of F&B, looking after high-end restaurants brand such as Marco Pierre White and Frankie’s Italian. \n\nIn February 2014 he was named “Executive Chef of the Year” by the Gourmet Abu Dhabi Award and in 2015 he won the 1st place in Al Dhafra Camel Festival Competition among 15 five-star Hotels in Abu Dhabi. In 2017 Cladys joined then Al Faisaliah and Al Khozama Hotels in KSA as a Director of Culinary, appointed to Director of Food and Beverage in 2019 overseer a USD 51 million dollar plus annual turnover and over 500,000 thousand food covers per annum. \n\nIn 2022 Cladys moved to Al Khozama HQ, spearheading the growth & expansion strategies of existing and new F&B concepts, driving innovation in areas of service and culinary of all AK managed Hotels in KSA, Mode Mall, Franchised Restaurants, and homegrown dining concepts, building and mature partnerships with top-tier brands, such as Hakkasan, Yauatcha, LPM, Mamo and Meraki. \n\nCladys holds a master’s degree in food and Beverage Management & Hospitality Marketing from Cornell University in New York, a Bachelor’s Degree in Business Administration from Arden University, a culinary certificate from the American Culinary Federation (ACF) in New York and a Certification from the Italian Culinary Federation (FIC) in Italy. \n\nHe lives with his wife and son in Riyadh.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                                    "title": "Bringing Riyadh’s culinary heritage back to life",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jennifer",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NDg4MjIxLFVzZXJfMTgyMTg1NTEp",
                "jobTitle": "Co-Founder, Global Restaurant Investment Forum",
                "lastName": "Pettinger-Haines",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
                "organization": "Partner, THINK Hospitality",
                "biography": "Since joining the Bench team in 2008, Jennifer has been an integral part of growing the events portfolio. In 2013 she introduced the Arabian Hotel Investment Conference (AHIC) Regional Briefings Series, expanding AHIC’s presence throughout the region and in 2014 launched the Global Restaurant Investment Forum (GRIF) in Dubai. When not at a conference bossing around the hotel industry’s movers and shakers, Jennifer is working tirelessly to bring hotel and restaurant Attendeess scintillating conference sessions. During her time with Bench, she has amassed a large number of air miles, running conferences on most continents. In doing so she has taken full advantage of exploring the shopping, nightlife and restaurants on offer from Kigali to Casablanca as she firmly believes the world is there to be explored. One of her proudest achievements is being a part of the Bench Mt Kili Madness team which broke the World Record for the highest game of cricket ever played raising over £200,000 for charity. Currently residing in Dubai she has lived on four continents but will always call Sydney home.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkxMQ==",
                                    "title": "Global Restaurant Investment Forum - Welcome",
                                    "beginsAt": "2024-04-29 09:00:00",
                                    "endsAt": "2024-04-29 09:10:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNQ==",
                                    "title": "Case Study: Continuing the Conversation - Real Facts, Figures and Take Aways that Prove Sustainability can be a Commercial Success",
                                    "beginsAt": "2024-04-30 10:00:00",
                                    "endsAt": "2024-04-30 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OA==",
                                    "title": "Bringing Riyadh’s culinary heritage back to life",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY1Mw==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #9",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:30:00",
        "endsAt": "2024-04-30 12:45:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTkxOTQ3OQ==",
        "titleTranslations": [
            {
                "value": "Workshop: The Evolution of Branded Residences",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:30:00",
        "endsAt": "2024-04-30 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Rafael",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwNTIzNjU5LFVzZXJfODY4Nzc0KQ==",
                "jobTitle": "Asset Manager",
                "lastName": "Espeja",
                "photoUrl": null,
                "organization": "Rua Al Madinah Holding Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkxOTQ3OQ==",
                                    "title": "Workshop: The Evolution of Branded Residences",
                                    "beginsAt": "2024-04-30 12:30:00",
                                    "endsAt": "2024-04-30 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTkxNTY1NA==",
        "titleTranslations": [
            {
                "value": "Signing Ceremony #10",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:45:00",
        "endsAt": "2024-04-30 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2MQ==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks:  An All-Inclusive Transformation of an Iconic Brand while Staying True to its Roots",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 12:50:00",
        "endsAt": "2024-04-30 13:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Fn3JKCEfkro?si=oTstL_BTYznUST-L\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Henri Giscard",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODczLFVzZXJfNTU0MDIzKQ==",
                "jobTitle": "President",
                "lastName": "D’Estaing",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ad0eca8e39054a7395545f8350674029.jpeg",
                "organization": "ClubMed - All-Inclusive beach and mountain Resorts",
                "biography": "Born in 1956, Henri Giscard d’Estaing is a graduate of the Paris Institute of Political Studies and has a master’s degree in Economic Sciences. \nMr. Giscard d’Estaing began his career at the Cofremca, from 1982 to 1987, where he was a Managing Partner specialized in the study of food consumption changes. \nHe then joined the BSN group, which became Danone, where he was successively Development Director, CEO of the British subsidiary HP Food Lea and Perrins, CEO of Evian-Badoit and then CEO of the Mineral Water division.\nHenri Giscard d'Estaing joined Club Med in 1997 as Senior Vice President in charge of Finance, Development, and International relations. He became Chairman of the Board of Directors and President of Club Med in December 2002.\nIn 2004, Henri Giscard d’Estaing-initiated Club Med's strategy of moving upscale, with the goal of becoming the world's leading specialist in premium all-inclusive vacations for families and couples.\nIn 2017, Mr. Giscard d’Estaing has been named Global Partner of the Fosun Group and Deputy CEO of the board, Vice Chairman and Executive Director of Fosun Tourism Group. He is also Vice-President of the World Tourism Alliance (WTA) since 2019.  \nSince April 2018, he is Member of the Advisory board of BOAO Forum for Asia.\nAt the end of November 2022, Henri Giscard d'Estaing was appointed Co-CEO of Fosun Tourism Group.\nToday, the success of the Club Med strategy is based on 5 pillars:\n•\tPremium with Club Med spirit, which results in a portfolio of 95% Premium and Exclusive Collection Resorts. \n·\tBecome the Hospitality employer of choice:  Club Med's ambition is to offer its teams a \"life-changing experience\" through personalized management of career paths.\n·\tGlocal: Combining a global approach with a local focus in terms of markets, products, and destinations to achieve sustainable growth. \n·\t“Happy to Care”: Aiming to take care of the environment and communities, with the implementation of numerous measures in favour of responsible tourism.\n·\t\"Happy Digital”: Continuing the digital transformation to improve the customer and employee experience in the resorts and offices. \n\nand 2 strategic priorities: \n•\tClub Med Mountain, a unique premium all-inclusive ski experience\n•\tClub Med Exclusive Collection, Club Med's luxury range",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MQ==",
                                    "title": "TenX Leadership Talks:  An All-Inclusive Transformation of an Iconic Brand while Staying True to its Roots",
                                    "beginsAt": "2024-04-30 12:50:00",
                                    "endsAt": "2024-04-30 13:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDMxNzYzLFVzZXJfMTYwNzY4OTIp",
                "jobTitle": "Reporter",
                "lastName": "Tabbara",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/89acb46a77f245b9a24dab0275fc3d39.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Rana Tabbara is a seasoned multimedia journalist with a wealth of experience in economic and social news coverage. Her journalistic prowess shines through her special interviews with CEOs of major companies and prominent government figures worldwide.\n\nHaving made valuable contributions to global media outlets, Rana found her niche at CNN Business Arabic, where she extensively covers real estate news, establishing herself as an expert in the field.\n\nHer dedication to providing comprehensive reports tailored to readers' needs is evident in her work. Since joining CNN Business Arabic, Rana has infused the platform's content with her unique perspective, crafting distinctive stories and conducting successful interviews with VIPs, further solidifying her reputation as a top-notch journalist in the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MQ==",
                                    "title": "TenX Leadership Talks:  An All-Inclusive Transformation of an Iconic Brand while Staying True to its Roots",
                                    "beginsAt": "2024-04-30 12:50:00",
                                    "endsAt": "2024-04-30 13:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                                    "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                                    "beginsAt": "2024-04-30 15:50:00",
                                    "endsAt": "2024-04-30 16:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU4MQ==",
        "titleTranslations": [
            {
                "value": "Networking Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 13:00:00",
        "endsAt": "2024-04-30 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
        "titleTranslations": [
            {
                "value": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 13:30:00",
        "endsAt": "2024-04-30 14:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/c7EwOJnaiwk?si=rztqUCRLQpRCjc1Z\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Abdulaziz",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkyOTg5KQ==",
                "jobTitle": "Managing Director, Majd Alaamal",
                "lastName": "Alkhudair​",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a04630d7afb34d8d94086a1dc9c7c14f.jpeg",
                "organization": "CEO, Yakoon Invest Company",
                "biography": "Abdulaziz built a successful career both as a corporate player and an entrepreneur. Over 10 years, he acquired in-depth experience in hospitality, premium retail, real estate, and technology, both in the private and public sectors.\n\nBoard/ Board Committee Membership in KSA\n\nBoard member of Sarat investmens\nBoard Advisory of Taj Oil\nExecutive Board member of Majd Al Amaal\nBoard Advisory of Ma’wa real estate Company\nBoard member of TMC Contracting\nCareer Summary\n\n2020-Present Majd Alaamal Group, MD\nMajd Food Company, KSA CEO\n2021-Present Yakoon Invest Company, CEO\n2016-2020 Al Khozama Management Co LTD CEO F&B, Corporate\nOperations Vice President\nEducation\n\nArmed with MBA in Energy and Sustainability from the University of Cumbria and a degree in Communications and Electronic Systems Engineering from Greenwich University",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Uday",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzNDY3LFVzZXJfMTE2ODM5MDcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mukundan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d1c8aadd133c4366ad210b0a640882a8.jpeg",
                "organization": "The Food District Company",
                "biography": "Uday is the architect of and now leads the KSA-based Food & Beverages-focused US$50 million (Phase I) Food District Company (FDC) Fund, targeting investments in small and medium-sized F&B companies in the Kingdom. Uday has transitioned to a larger role of value creation in the F&B space to leverage his 20 years of leadership, multi-functional, multi-unit and varied -cuisine experiences in the F&B-Hospitality domain across GCC, US, Singapore and India. Having worked with Fortune 500 entities and enterprises with regional and global presence has enhanced his experience and expertise. His education in hospitality and finance in India and the US from reputed institutes such as Cornell University (US), Johnson & Wales University (US) and Institute of Hotel Management, Goa (India). Uday intends to leverage his extensive operational experience including roles such as functional, training and R & D within the F&B Sector and education in finance to mentor entrepreneurs to achieve their vision in the industry while staying focused on creating value for the fund's Attendeess and FDC. The Food District Company (FDC) invests in entrepreneurs who are building the future of food while revolutionizing the Saudi hospitality & leisure market. FDC, as an equity partner, not only provides the partner entities with capital but also strategic support in achieving their vision and scaling up their operations. FDC aims to enable the entities to grow in the KSA market, within the GCC region, and other promising markets. FDC has deployed $20 million since inception across investments namely Shawarma Hlayel, Food Junction (Just Buns, Birdy’s Chicken), Salmon & Figs (The Social Kitchen, The Social Bakery) by Chef Basma El Khareeji. Key Attendeess of FDC include Dividend Gate Capital, Khashoggi Holding Company, Al-Saedan Real Estate Company, Abdulrahman Al-Suhaim Real Estate Investment Company, Mohammed bin Ishaq Holding Company, and a group of Family offices and HNI’s from KSA.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohamed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjk4NTE0LFVzZXJfMTY2NzcxNTUp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Siam",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7d65f4d204da4832878f187e3bd20607.jpeg",
                "organization": "Trofi",
                "biography": "-\t25+ years of work experience\n-\tWorked on local level in Egypt & Saudi, Regional level in MENA and global level based in Germany\n-\tLong experience in FMCGs, Packaging  industry, Digital transformation and F&B\n-\tFunctional background, Mainly in Marketing, sales, General management, operational and C level (CEO & COO)",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0NDA0LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:00:00",
        "endsAt": "2024-04-30 14:25:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aradhana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjk4LFVzZXJfMTAwMzI1ODMp",
                "jobTitle": "CEO & Founder",
                "lastName": "Khowala",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
                "organization": "Aptamind Partners",
                "biography": "Aradhana Khowala is globally identified as an authority on the travel, tourism, and hospitality industries and has over two decades of experience across 75 countries in 5 continents. She is currently CEO & Founder of Aptamind Partners a Private Client Advisory that is a trusted advisor to ambitious leaders in Governments, Family Offices, Private UHNW Attendeess, and International Organisations. Previously she was the MD of the Tourism Sector at NEOM - the US$ 500 Billion land of the future purpose built for a sustainable and a new way of living.\n\nAn experienced Board Member she has an active portfolio of Board roles and currently serves as the Chair of the Advisory Board of the Red Sea Project in Saudi Arabia which is a signature “Giga” project of Saudi Arabia Vision 2030, which, through breakthrough models for international tourism, sets new standards for sustainable development and environmental stewardship.\n\nAradhana also serves as a Board Member and Steering Committee member of World Tourism Forum Lucerne a highly focused, top level, strategic body that brings together selected leaders around the world to reflect on the big challenges facing the industry. She is also a Board Member of Elaf Group, the leisure arm of a sustainable and publicly listed holding company - SEDCO. In the past, she has worked for Jones Lang LaSalle, covering the UK, Benelux, and Scandinavian markets, a Strategy Consulting practice in Europe and Asia as well as in Hospitality Operations in India.\n\nAradhana has won multiple awards including the 21st Century Icon Awards in 2017 in association with CNBC and the London School of Economics as an Inspirational Game Changer in Tourism. In 2014, she was featured as one of the 50 most Influential Next Generation leaders who will likely define the future of the Tourism sector by Swiss Economic magazine Bilan (Forbes equivalent), and in 2021 she was featured as an inspirational woman rethinking a sustainable future of tourism by City Nation Place.\n\nA keen industry practitioner, she is a regular speaker and moderator well known for her international advocacy on sustainable tourism, climate change, women and diversity and has participated in global policy discussions in United Nations bodies, WEF as well as the G20 apart from some of the foremost Family Office conferences as well as Tourism and Leadership Summits around the world. She read at Cornell University in the US, is a certified NLP Coach, has an MBA from Ecole Hôtelière de Lausanne in Switzerland, and an International Director Certification from INSEAD in France.\n\nA passionate advocate of the transformative power of tourism and the prospect it presents for combining conservation with community, culture, and commerce, she spends a lot of her time engaging Presidents, Prime Ministers, and Tourism Ministers lobbying for travel and tourism as a force for good. She also guest lectures on tourism, authentic leadership, and entrepreneurship at different Universities globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
                                    "title": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Talks"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTg5MzkyNw==",
        "titleTranslations": [
            {
                "value": "Welcome to the Future",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:00:00",
        "endsAt": "2024-04-30 14:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/LVWncJVZRzs?si=9yUEQ-Xzr1HEw1iJ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Marina",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ1NzI4LFVzZXJfODk1NDg5MSk=",
                "jobTitle": "Head of Investor Relations",
                "lastName": "Franolic",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNw==",
                                    "title": "Welcome to the Future",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
        "titleTranslations": [
            {
                "value": "Start-Up Den",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:15:00",
        "endsAt": "2024-04-30 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/RYOfQ9dMTLw?si=umDLtDgHcbkmcd5p\" target=\"_blank\">Click here to watch online</a></p><p><strong>Judges</strong></p><ul><li><strong>Salma Arafa</strong>, Innovation Specialist - Department of Innovation, Education and Investment, UNTO</li><li><strong>Maya Ayoub</strong>, Founder & CEO, District 12 and Women in Tech Ambassador for Saudi Arabia </li><li><strong>Jonathan Worsley</strong>, Chairman and CEO, The Bench</li><li><strong>Nouf Alarthi</strong>, Business Development Manager, TDF Grow </li></ul><p><strong>Finalist </strong></p><ul><li><strong>Sam Payrovi</strong>, Co-Founder, ARKHAUS</li><li><strong>Girish Prabhu</strong>, Founder, Instio Experiences </li><li><strong>Mohamed Zran</strong>, Founder, Tenance </li><li><strong>Simone Mundy Clowry & Ulpa Chauhan</strong>, Beyond Bamboo </li><li><strong>Sharan Bhinder</strong>, Co-Founder, SPARKLEHAZE</li><li><strong>Lorelei Regragui</strong>, Founder, StayK </li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "startup-den",
                "translations": [
                    {
                        "value": "Startup Den"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Son-Trang",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDYzMjkzLFVzZXJfMTgyODgzNjgp",
                "jobTitle": "Production Manager",
                "lastName": "Nguyen",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lorelei",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NzAwLFVzZXJfMTg2NjUzMCk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Regragui",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/76a30635a1ac4c9f9ea238fae8fb80dd.jpeg",
                "organization": "StayK",
                "biography": "Lorelei is the MasterKey Keeper (Founder & CEO) of StayK; and a hoteliere at heart.\n\nLaunched in the summer of 2023, StayK is a Dubai-born experience-driven and domestic-focused Online Travel Agency, bridging the gap between staycation-fit hotels and local travelers, with a marketing agency approach in mind.\n\nLorelei started her career in the luxury hospitality industry in 2009, as an F&B Intern at the Hotel de Crillon in Paris, a Rosewood Hotel. After university, she joined Emirates Palace in Abu Dhabi in 2012, as a Rooms Division Intern. Followed by roles in 5 star hotels at Le Bristol Paris as a reservation agent, at Corporate Level at Oetker Collection as a Global E-Commerce Manager piloting the digital strategy for 9 luxury hotels, and heading back to the UAE as a Marketing & Communications Manager at Rosewood Abu Dhabi and at Waldorf Astoria Ras Al Khaimah as an E-Commerce Manager.\n\nHer 360-degree experience in the luxury hospitality industry, the observed market gap and need for a staycation-focused OTA, along with the ever-innovative and dynamic GCC’s tourism landscape, inspired her the idea of StayK, with the desire to leave a positive and high-impact footprint with hoteliers, and to humanize the online booking journey for local travelers.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sharan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NjU5LFVzZXJfMTgzMzMyMTIp",
                "jobTitle": "COO & Co-Founder",
                "lastName": "Bhinder",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c6f33f3d26a74d3aab3ee4f766ce18c3.jpeg",
                "organization": "SPARKLEHAZE",
                "biography": "Ms. Sharan Bhinder is the Co-founder and COO of SparkleHaze, a leader in data and digital transformation within the hospitality and tourism sectors. With over 15 years in the Aviation and Hospitality Industries, she collaborates with major tourism boards and has won Awards from the UN Tourism, Saudi Tourism Authority, Dubai, and Singapore Tourism. Sharan consults with luxury hotel brands, focusing on technologies that enhance guest personalization and experience. She has notably contributed to innovative projects like WooHoo, an integrated in-room digital AI assistant, driving the future of hospitality technology. Her work defines cutting-edge advancements in global travel and hospitality.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Sam",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NjI2LFVzZXJfMTkzMTI3OTIp",
                "jobTitle": "CEO & Co-Founder",
                "lastName": "Payrovi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/370ee834c0de40b0a662d70545962e0b.jpeg",
                "organization": "ARKHAUS",
                "biography": "Founder & CEO Sam Payrovi is a 14 year investment banker turned serial entrepreneur. Graduating from UCLA with dual degrees in 2001, he joined Bear Stearns’ market leading mortgage analytics F.A.S.T. group. By 2006, he was running Royal Bank of Scotland’s Asset Backed Securities Structuring team, before launching a Fin-Tech mortgage startup, ProtEquity Group. In 2012, a trip to SE Asia inspired an entrepreneurial journey that would span multiple companies under one corporation, now culminating in ARKHAUS.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohamed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NTcwLFVzZXJfMTgyMDM3NjAp",
                "jobTitle": "CEO & Founder",
                "lastName": "Zhran",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c2a8cb08a8814029b1b5a58cd12a18f7.png",
                "organization": "Tenance",
                "biography": "Mohamed Zahran is a motivated high school student and dedicated entrepreneur, currently serving as the CEO & Founder of Tenace. His journey into the world of business began with a keen interest in rental property management, which he has transformed into a thriving venture through Tenace. With a focus on innovation, Mohamed has led the strategic planning efforts for Tenace, ensuring its mission aligns with future growth opportunities.\n\nIn addition to his entrepreneurial endeavors, Mohamed gained valuable experience through a summer internship at United Oil Services, where he contributed to various projects and grew his understanding of business operations. This experience further fueled his passion for entrepreneurship and provided insights into global business practices.\n\nCurrently a 10th-grade student at the International Programs School, Mohamed balances his academic pursuits with his entrepreneurial ambitions, demonstrating a strong commitment to both his education and his ventures. With a diverse skill set encompassing strategic planning, market research, investor relations, and UI/UX design, Mohamed is poised to continue making waves in the world of business and innovation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ulpa",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTU4LFVzZXJfMTc0MjM3MTYp",
                "jobTitle": "Chief Solutions Officer",
                "lastName": "Chauhan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ddf727d59fc44d3d85fa5a868e371b72.jpeg",
                "organization": "Beyond Bamboo",
                "biography": "Ulpa Chauhan is a distinguished executive with over two decades of expertise in the tourism industry. With a career marked by innovation and thought leadership, Ulpa is at the forefront of shaping the future of hospitality. \n\nHaving held a lead training role at British Airways, Ulpa specializes in designing bespoke courses that elevate customer experience and employee performance. Her insights into training methodologies and service excellence have been instrumental in driving success in one of the world's leading airlines.\n \nBeyond her corporate endeavors, Ulpa serves as the CSO of Beyond Bamboo Global, a pioneering company dedicated to revolutionizing the hospitality industry through sustainable practices and innovative solutions. In this role, she is committed to driving forward-thinking strategies that prioritize both environmental stewardship and customer satisfaction.\n\nUlpa is also a respected columnist in trade press, offering valuable insights and perspectives on industry trends and best practices. Her contributions to the discourse on tourism and hospitality have earned her recognition as a thought leader in the field.\n\nAs a TEDx speaker, Ulpa captivates audiences with her engaging talks on topics ranging from customer service to the future of travel. Her ability to inspire and educate through storytelling and expertise has made her a sought-after speaker on both national and international stages.\n\nUlpa holds a Bachelor of Arts in Business Studies with a specialization in Tourism and Hospitality, laying the foundation for her comprehensive understanding of the industry's dynamics and challenges.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Simone",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTkxLFVzZXJfMTc0MjM3OTEp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Mundy Clowry",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4b87482b6ba34cdd855ee4941808b88f.jpeg",
                "organization": "Beyond Bamboo",
                "biography": "Simone Mundy-Clowry is a seasoned executive with a diverse background in finance, real estate, and sustainable development. With a career spanning from the Chicago Board of Trade to the helm of one of Europe's most ambitious regeneration projects, Simone brings a wealth of experience and insight to the table.\n\n\nBeginning her career in the fast-paced environment of the Chicago Board of Trade, Simone honed her financial acumen and strategic thinking. Her tenure at Knight Dragon, where she held a pivotal role in Europe's largest regeneration project on London’s Greenwich Peninsula, further solidified her reputation as a leader capable of navigating complex challenges with finesse. \n\nSimone's educational journey is equally impressive, holding a Bachelor of Science in Property Economics, a Diploma in Investment, and a Master of Science in Real Estate Finance. This academic foundation, coupled with her hands-on experience, equips her with a multifaceted understanding of the real estate and investment landscape.\n\nCurrently serving as the COO & CFO of Beyond Bamboo Global, Simone is at the forefront of driving sustainable innovation in the hospitality sector. Beyond Bamboo Global is a trailblazing company committed to revolutionizing the hospitality industry through environmentally conscious practices and cutting-edge solutions. Under Simone's leadership, the company is spearheading initiatives that not only redefine standards but also pave the way for a more sustainable future.\n\nAs a thought leader and influencer in both finance and sustainable development, Simone is sought after for her expertise. Her insights into the intersection of real estate, finance, and sustainability make her a valuable voice in shaping the future of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Girish",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NTEwLFVzZXJfMTkzMTI3MTIp",
                "jobTitle": "CEO & Co-Founder",
                "lastName": "Prabhu",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d25f6481d60a41a9828c95a6bfd8cf7f.jpeg",
                "organization": "Instio Experiences",
                "biography": "Girish Prabhu is Co-founder and CEO of Instio Experiences, a hospitality technology company based in Kochi, India. He has more than two decades of experience in the technology, and his expertise lies in building and scaling businesses. \n\nPrior to founding Instio Experiences, Girish was the Program Manager with TCS (Tata Consultancy Services). Girish played a key role in managing the projects for manyu clients. \n\nAt Instio, he is responsible for overseeing the company's product strategy and ensuring that it delivers high-quality services to its clients. He is a hands-on leader who is passionate about using technology to create innovative solutions that engage customers and drive business growth. Girish's leadership and strategic vision have been instrumental in driving the growth of Instio, and he continues to play a critical role in the company's success.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Maya",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODc2MDA4LFVzZXJfMTg2MjI5MDkp",
                "jobTitle": "Founder & CEO",
                "lastName": "Ayoub",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9f57a657fa7b440dbeec75056094dbb4.jpeg",
                "organization": "District Twelve",
                "biography": "Maya's journey began with a diverse foundation in economics and finance, nurtured in the trenches of her family's real estate development and consulting business. This early experience sparked her entrepreneurial flame, leading her to found The Private Circle, District Twelve, and Fait Par Fées.\n\nBut her ambitions extend beyond building businesses. Her experience, with over 15 years of leading professional conferences, corporate events, and communications across the Middle East, have shaped her into a seasoned professional with a passion for delivering successful outcomes.\n\nMaya's true fulfillment lies in leveraging her skills for positive impact. She is an impact entrepreneur with a fierce commitment to women's empowerment, particularly in the fast-paced world of technology. As the Saudi Arabia Chapter Ambassador for Women in Tech® Global Movement, she champion initiatives that bridge the gender and digital gap, cultivate diversity within the tech industry, and empower women to reach their full potential.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Nouf",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDc2NTMxLFVzZXJfMTU5MjgwNjQp",
                "jobTitle": "Manager of Business Development",
                "lastName": "Alharthi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6bd7e238d45146a8b504bd8f5ef02bea.jpeg",
                "organization": "TDF Grow",
                "biography": "Nouf Alharthi is a Manager of Business Development at TDF Grow. Her experience, with 14 years in various fields with a great focus on entrepreneurship. She works as an enabler in the startup ecosystem. In her role at TDF Grow, she works closely with the startups and entrepreneurs in the tourism sector through providing a wide range of support programs and preparing them for funding.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Salma",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTgxNDM1LFVzZXJfMTE4OTk5NTYp",
                "jobTitle": "Senior Innovation Specialist",
                "lastName": "Arafa",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d9a29fb8b19a4f12a74b916091d7393f.png",
                "organization": "UN Tourism",
                "biography": "Salma Arafa is an Innovation Expert at the UNTO in its Regional Office of the Middle East. In her role, Salma works with a wide range of stakeholders to advance innovation in the tourism sector. She played a leading role in the development and implementation of the inaugural edition of the Women in Tech Middle East startup competition. Recently, Salma was selected as chair of the task group on tourism within the International Telecommunications Union’s Focus Group on Metaverse. Prior to joining the UNTO, Salma held positions at the United Nations Environment Program (UNEP) and the Office of the Resident Coordinator (UNRCO). Salma holds a bachelor’s degree in Political Science from Ryerson University.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Judge",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Startup Den"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTc5MjI0OQ==",
        "titleTranslations": [
            {
                "value": "Tenx Leadership Talks: The Future Normal - A People-First AI Strategy",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:15:00",
        "endsAt": "2024-04-30 14:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/xM4rV0QCQZg?si=2Wo8o_u-sKMeuhmz\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Henry",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDM3LFVzZXJfMTYzMTQ0MzUp",
                "jobTitle": "Author & Speaker, The Future Normal",
                "lastName": "Coutinho-Mason",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fc6293ced5834145b38756ca93676917.jpeg",
                "organization": "Co-founder, 3Space",
                "biography": "Henry Coutinho-Mason is obsessed with answering the biggest question in business: \"what will people want next?\"\n \nHenry is one of the world’s leading authorities on consumer trends, having spent a decade as the managing director of TrendWatching. He is the author of Trend- Driven Innovation , which lays out a simple, accessible approach to anticipating customer expectations. It forms the basis of TrendWatching’s research, content & product that is used by 100,000 B2C professionals at hundreds of the world’s leading brands. \n \nHenry’s latest book The Future Normal: How We Will Live, Work, and Thrive In The Next Decade, is a handbook for visionaries featuring the thirty biggest ideas and instigators that will shape humanity’s next decade; it launched at SXSW in March 2023. \n \nAs a speaker, Henry has given more than 100 inspiring and actionable keynotes & workshops in 30+ countries – with multiple repeat bookings from global leadership teams at J&J, Calvin Klein, Mastercard, the Tata Group, and many more.  He is also a guest lecturer at HEC business school in Paris.\n \nBased in London, his work is focused on consumer trend & innovation strategy, typically around “The Future of X” (retail, work, tech, cities, travel, etc).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0OQ==",
                                    "title": "Tenx Leadership Talks: The Future Normal - A People-First AI Strategy",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 14:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTg0MjgwMw==",
        "titleTranslations": [
            {
                "value": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:25:00",
        "endsAt": "2024-04-30 14:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/cvgAG1MFafg?si=ejd8Kfq0eJw5pOOY\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Susie Ellis,</strong> Chair & CEO, Global Wellness Institute</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzE0MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-luxury",
                "translations": [
                    {
                        "value": "Wellness"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Khalid",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDI2NzgxLFVzZXJfMTcwMDg5NTEp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Alshaibani",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d204935d67fc457f99c925f513b166dd.jpeg",
                "organization": "Health Sector Transformation Program",
                "biography": "Dr. Al Shaibani is leading the team that is charged with planning and overseeing the delivery of the initiatives of the National Health Sector Transformation Program. The team coordinates with the multiple stakeholders both in the government as well as the other sectors.\n\nHe graduated from King Saud University in Riyadh, and completed his training in Renal Transplant and Vascular Surgery in Oxford, England. He came back to Riyadh as a full time staff at King Faisal Specialist Hospital and Research center, where he assumed multiple responsibilities; he was the Director of the Renal Transplant Program, the Surgical Residency Program, and the first Business\n\nDevelopment Program. He became chair of the department of Surgery, then went on to become the Executive Director of the Medical and Clinical Operations.\n\nHe moved to the Ministry of Health in 2008, where he was assigned as CEO of one of the ministry's first tertiary care centers: King Fahad Specialist Hospital in Dammam, where he lead a team to establish the infrastructure and start many highly complex clinical programs such as Oncology, Neuroscience, and multi-organ transplant programs.\n\nHe went on to assume the responsibility of the Director General of the Eastern Region Health Authority, then, as the Director of the Vision Realization Office, and Deputy Minister of Health for Planning and Transformation. Before moving to his current post as the Chief Executive Officer of Health Sector Transformation Program.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Hamad",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODU1Njc3LFVzZXJfMTkwMTgwOTQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abuhaimed",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a941619d5bf94efc936e637a487f1112.jpeg",
                "organization": "Shatha Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Susie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNzA1LFVzZXJfMTc5Mjg2MjEp",
                "jobTitle": "Chair & CEO",
                "lastName": "Ellis",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d88f3e7867af4f4ab9faffc5fefc8841.jpeg",
                "organization": "Global Wellness Institute and Global Wellness Summit",
                "biography": "Susie Ellis is the chair and CEO of the nonprofit Global Wellness Institute, considered the industry’s leading global research and educational resource. She is also chair and CEO of the Global Wellness Summit, an organization at the heart of the multitrillion-dollar global wellness economy focused on facilitating collaboration amongst industry thought leaders. Recognized as a leading authority on wellness trends, Ellis is a popular speaker at industry events. She sits on numerous academic and industry boards, including the EHL Hospitality Business School and the Penn Center for Neuroaesthetics, and was also a member of the World Economic Forum’s “Accelerating Health and Well-being Initiative.” She holds an MBA from the University of California, Los Angeles.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ingo",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NTUzMjYzLFVzZXJfMzY3MjU2Nik=",
                "jobTitle": "Founder & CEO",
                "lastName": "Schweder",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/dce9579bcb0743bc96d8977133aadc67.jpeg",
                "organization": "GOCO Hospitality",
                "biography": "INGO is a global thought leader, visionary & pioneer in the wellness and hospitality industry. Globally recognized as an authority, Ingo leads the next generation of wellness professionals as the CEO of GOCO Hospitality.\n\nInjecting fresh ideas and professional management into the rapidly expanding wellness hospitality sector, Ingo Schweder brings together more than 40 years of experience in the spa and hospitality industries. He leads the multidisciplinary teams at GOCO Hospitality and Horwath HTL Health and Wellness to strategise, conceptualise, design and manage the latest wellness developments for the world’s top hospitality and real estate brands. From individual hotel spas to dedicated wellness resorts and master planned mixed-use developments, Ingo’s experience and insights have taken over 400 projects worth more than\n\n$4.5 billion across upwards of 42 countries from initial idea to profitable\n\nrealisation and on-going management.\n\nIngo maintains a creative lead in the management and development of all GOCO-branded spas and is the Managing Director of Horwath HTL Health and Wellness. Ingo also owns and manages Glen Ivy Hot Springs in Southern California, the United States’ oldest and highest-grossing hot spring resort. He was formerly a board member of Mandarin Oriental and earlier Corporate Director of Operations for Oberoi Hotels & Resorts. Under his guidance, Ananda in the Himalayas, the globally recognised destination resort, was established in 1999/2000.\n\nIngo is a co-founder of Space Yoga & Space Cycle, together with Matthew Allison, former President of EMI Music, and Jack Ma, Founder of Alibaba. He sat on the Advisory Boards of AMAALA, a luxury wellness destination in Saudi Arabia developed by PIF, the Sovereign Wealth Fund of Saudi Arabia and the International Hospitality Investment Forum (IHIF). He was also a Board Member of the Moonstone Retreat in Bodø, a project funded by the Norwegian Sovereign Fund’s developmental arm, Innovation Norway.\n\nIn December 2023 Ingo and the subsidiary of Temasek Holdings Limited, Singapore formed a JV Investment vehicle to expand further in the Wellness Real Estate Segment. Since its inception, this joint venture has successfully acquired wellness resorts in Bali and Koh Samui, Thailand. Currently, it is actively pursuing additional projects in the Maldives and Switzerland, all of which will fall under the same brand.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rosanna",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzIwODA5LFVzZXJfMTg5MzgyOTUp",
                "jobTitle": "Executive Director – Destination Development",
                "lastName": "Chopra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d47e4702151142bbbe05cf736f42600d.jpeg",
                "organization": "Red Sea Global",
                "biography": "Rosanna joined Red Sea Global (RSG) in 2022 as Executive Director – Destination Development charged with defining and implementing the destination development strategy. The first destination in the company’s portfolio, The Red Sea, sits over 28,000km² of pristine lands and waters, includes a vast archipelago of more than 90 islands, mountain canyons, dormant volcanoes, and ancient culture and heritage sites. Rosanna is responsible for ensuring that the company continues to set new standards in regenerative tourism through the creation of unique travel experiences and unforgettable memories. \nWinning Leading Female in Business Enterprise in KSA, Growth Strategy CEO of the Year 2021, and named in the Top 20 Most Inspirational CEOs to Watch, 2022, Rosanna is considered a much sought-after voice on how to best succeed in the region. \nHer experience includes working at the President’s Office at the Federation International De L’Autombile (London, Geneva, Paris) & the F1 Race Director; Partner at Galadari, UAE for over a decade; advisory Board Member of UPS EXPO 2020; and consortium member for a KSA mega project, project advisor to PIF, designing and delivering adventure,  sports and leisure assets and events across KSA, whilst acting as special advisor to international Attendeess, boards and implementation teams in the entertainment, hospitality, tourism sectors in Saudi Arabia. She has led the design, development, destination planning, activation and operations of sport, adventure tourism and hospitality projects, bringing both public and private sector together to successfully form sustainable, collaborative partnerships. She is listed in the Who’s Who Guide to International Professionals and is recognized by her peers as “honest, clear and concise – she knows her business and the environment in which it works far more than most”. She is “always accessible with an inexhaustible skill set” and has “earned a highly respected reputation within the regional and global business communities due to her loyalty, discretion and knowledge; black books and doors are always open to her”.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwMw==",
                                    "title": "Wellness: On the Edge of Structural Transformation? Will it be led by the Kingdom?",
                                    "beginsAt": "2024-04-30 14:25:00",
                                    "endsAt": "2024-04-30 14:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Wellness"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
        "titleTranslations": [
            {
                "value": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:30:00",
        "endsAt": "2024-04-30 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Lh_aD8tikW8?si=Myp__oF27HNlbRRD\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODU4LFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Head of Hotel Advisory, Hospitality & Tourism | MENA Region",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers",
                "biography": "Nicolas oversees the execution of greenfield and brownfield hospitality and tourism feasibility studies, operator search and selection, and strategic development advisory projects in MENA. Nicolas holds an MBA and a Master's in Business Analytics and has developed broad expertise in commercial real estate advisory, covering hotels, serviced apartments, residential, spa & wellness, golf, marina and yachting, retail, arts & culture, and leisure assets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Henry",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDM3LFVzZXJfMTYzMTQ0MzUp",
                "jobTitle": "Author & Speaker, The Future Normal",
                "lastName": "Coutinho-Mason",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fc6293ced5834145b38756ca93676917.jpeg",
                "organization": "Co-founder, 3Space",
                "biography": "Henry Coutinho-Mason is obsessed with answering the biggest question in business: \"what will people want next?\"\n \nHenry is one of the world’s leading authorities on consumer trends, having spent a decade as the managing director of TrendWatching. He is the author of Trend- Driven Innovation , which lays out a simple, accessible approach to anticipating customer expectations. It forms the basis of TrendWatching’s research, content & product that is used by 100,000 B2C professionals at hundreds of the world’s leading brands. \n \nHenry’s latest book The Future Normal: How We Will Live, Work, and Thrive In The Next Decade, is a handbook for visionaries featuring the thirty biggest ideas and instigators that will shape humanity’s next decade; it launched at SXSW in March 2023. \n \nAs a speaker, Henry has given more than 100 inspiring and actionable keynotes & workshops in 30+ countries – with multiple repeat bookings from global leadership teams at J&J, Calvin Klein, Mastercard, the Tata Group, and many more.  He is also a guest lecturer at HEC business school in Paris.\n \nBased in London, his work is focused on consumer trend & innovation strategy, typically around “The Future of X” (retail, work, tech, cities, travel, etc).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0OQ==",
                                    "title": "Tenx Leadership Talks: The Future Normal - A People-First AI Strategy",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 14:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Janet",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NTE3ODYzLFVzZXJfOTA4ODQ0Nyk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Adams",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a484544b78874b6592977392d766bedd.png",
                "organization": "SingularityNET",
                "biography": "Janet Adams is a highly sought-after speaker and thought leader in the fields of artificial intelligence (AI) and blockchain, with published works on Ethics and Regulation of AI. As the Chief Operating Officer (COO) of SingularityNET, Janet brings her extensive expertise and insights to the stage, captivating audiences with her deep understanding of disruptive technologies and their potential impact on various industries. With a passion for AI ethics and regulation, Janet's talks often revolve around the responsible and ethical use of AI in today's rapidly evolving world, alongside the positive potential of decentralised Artificial General Intelligence (AGI). She shares her experiences and knowledge gained from her leadership role at SingularityNET, where she spearheads AI and Blockchain initiatives across multiple vertical markets, including robotics, biotech, gaming and metaverse, media, DeFi, music, and arts. Her visionary leadership and dedication to a positive and beneficial Singularity for the benefit of humanity make her an influential thought leader in the AI and blockchain industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Tatiana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzMwOTkyLFVzZXJfMTU5MjM3MTEp",
                "jobTitle": "Head of Hotels and Tourism Advisory - PSU",
                "lastName": "Labaki",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e221c27233146fb93298f3f88259b27.jpeg",
                "organization": "Tonomus",
                "biography": "Tatiana Labaki is a seasoned Biotechnologist and Bioinformatician who has coupled her scientific prowess with a decade of experience in Hospitality Management in the GCC. Prior to her current ventures, she was working for Emaar Properties in Dubai, UAE. Now serving as the Head of Hotels and Tourism Advisory for TONOMUS, she plays a pivotal role in projects within NEOM and throughout the Kingdom of Saudi Arabia. A graduate of Imperial College London, Tatiana holds both an MSc and MBA. She's a firm believer in life-long learning and the importance of introducing innovation and novelty into her chosen industries. An advocate for women in leadership roles, Tatiana is deeply committed to amplifying the voices of women in technology within the Arab World",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Tech & Innovation"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDI0NA==",
        "titleTranslations": [
            {
                "value": "Partnerships that work - Leveraging Saudi expertise for global growth",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:30:00",
        "endsAt": "2024-04-30 14:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/8WljzlqP5hU?si=RVas2caD4tiBPc0Q\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Simon",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDYxMTU0LFVzZXJfMTg3ODU2OTgp",
                "jobTitle": "Founder & Chairman",
                "lastName": "Wright",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e28c84ddb2a418095833b23a57d14fc.jpeg",
                "organization": "TGP International",
                "biography": "Simon has a career spanning over 35 years in the hospitality industry working in KSA, Beirut, Dubai, London, Paris and Sydney, and with such companies as Inter-Continental Hotels, Conran Restaurants and Ian Schrager Hotels.\n\nSimon formed TGP International in 2002 and since then company has carried out operational advisory work, concept development and design work for such companies as Hilton International, Intercontinental Hotels, Harrods, Marriott International, St Regis Hotels, Accor, Selfridges and The Dorchester Collection as well as carrying out advisory contracts in KSA, Qatar, Kuwait, the UAE and all over the Middle East, Europe and the US, and has supported the licensing development of brands such as Sushi Samba, Asia de Cuba, and Scarpetta.\n\nSimon also headed up the TGP team as the overall F&B consultant and advisor to Expo 2020 Dubai with oversight of over 200+ F&B offers encompassing interior design, conceptualizing, marketing and commercial management.\n\nSimon and the TGP team started delivering projects in KSA in 2013, predominantly in Jeddah and Riyadh, with support on design, concept development and franchising deals. From 2016-2021 Simon helped take the Sisban/Trofi group from 3 sites in Jeddah to over 100 sites in 6 countries, including Over Jar, Habra, Lunch Room and Khayal, before moving back to focus on TGP.\n\nTGP International’s latest project opening is Al Mamlaka Social Dining in the Kingdom Centre, a first-of-its-kind 37,000sq-ft luxury food hall which unites Saudi culture, alongside global food and beverage concepts. Welcoming more than 7,000 visitors per day since its recent opening, Al Mamlaka Social Dining boasts richly immersive and interactive dining experiences, spanning 21 masterful kitchens, 8 new-to-market brands and 5 award-winning chefs.\n\nOther current KSA projects include leading the retail, dining and entertainment strategy for a Qiddiya district; repositioning of F&B entertainment, leisure & wellness for the Ritz Carlton in Riyadh & Jeddah; the development of global expansion of the Saudi Coffee Company and F&B masterplanning for the King Abdulaziz Center for World Culture – Ithra - in Dhahran, restructuring their food & beverage, retail and venue hire offerings.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk0MA==",
                                    "title": "The Changing F&B Landscape and What it Means for the Future of Dining & Spaces in KSA",
                                    "beginsAt": "2024-04-29 10:10:00",
                                    "endsAt": "2024-04-29 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0NA==",
                                    "title": "Partnerships that work - Leveraging Saudi expertise for global growth",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Faisal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzNjAzLFVzZXJfMTczMjk2NjQp",
                "jobTitle": "Co Founder, Board Member & CEO",
                "lastName": "Shaker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e61dee443ec744c4bc55ef239305b56a.jpeg",
                "organization": "Modern Food Company (MFC) & Modern Elite Company",
                "biography": "Faisal Shaker is a Founder, Board Member and CEO of Modern Food Company and Modern Elite Company, both are operators of several well-known and top fine and casual dining franchises in KSA such as Myazu, Nozomi, Cicchetti, Urth Caffe, Billionare, Signor Sassi, Coya, Beefbar and Crazy Pizza, where Faisal is managing a solid team and continuously expanding the platform across new franchises and regions.\n\nPrior to MFC, Faisal was the CEO and head of Wealth Management of Audi Capital, an Investment Bank in KSA where he headed the Company for 4 years and was able during his term to grow the business as evidenced by an increase in assets under management from USD 80 million to USD 1.8 billion during the first 2 years of his tenor. Prior to Audi he was the Head of Barclay’s Investment & Wealth Management for 1.5 years, and a Corporate Banker at SABB for more than 7 years.\n\nFaisal Shaker holds a master’s degree in Economics from Old Dominion University, Norfolk, Virginia, USA in 2002 and a bachelor’s degree in Business Administration from King Saud University in Riyadh Saudi Arabia in 1998.\n\nFaisal is also serving as a board member of several publicly listed companies and private companies in KSA such as:\n\n• Board Member at SPIMACO public listed company. Faisal also is the Chairman of the Governance & Risk Committee at SPIMACO, Member of the Executive Committee and Chairman of its Steering\n\nCommittee.\n\n• Chairman of Qasseem Medical Services Company (subsidiary of SPIMACO), Chairman of the Executive Committee and a Member of the Remuneration and Nomination Committee.\n\n• Board Member at NBK Wealth Management and Chairman of its Audit Committee.\n\n• Board Member at Aseer Trading, Tourism and Manufacturing Company and Member of its Investment Committee.\n\n• Independent member of the Executive Committee of Abdul Mohsen Al Hokair Group.\n\n• Managing Director of Shaker Investments Family Office.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0NA==",
                                    "title": "Partnerships that work - Leveraging Saudi expertise for global growth",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Marcello",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQxMjI4LFVzZXJfMTIwMjA0MTkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Distefano",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/41a626f4614048c68ab96bf1e6a99b4b.jpeg",
                "organization": "San Carlo Restaurant Group",
                "biography": "Marcello Distefano is CEO of San Carlo Restaurant Group. After completing his degree in BSC Management at the University of Bath in 2005, he joined his family business. \n\nSan Carlo was originally started by his father in 1992, with his first restaurant in Birmingham. When Marcello joined in 2005, the group had opened its fourth restaurant in Manchester. He spent the next 5 years experiencing all levels and roles within the business, until eventually taking the role of Managing Director and now CEO. \n\nThe group has gone on to become one of the biggest family owned restaurant groups in the UK. They currently operate 25 sites in the UK and 10 international franchises, employing over 1200 people. The group operates under several brands including Signor Sassi, San Carlo Cicchetti, Fumo, Isola and Alto, to name but a few. \n\nMarcello sees the international market as the major pipeline for the future growth of the company, with a further 8 sites to open in the next 18 months, including Miami, Bahrain, Vietnam, Ireland, Morocco and Istanbul.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0NA==",
                                    "title": "Partnerships that work - Leveraging Saudi expertise for global growth",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 14:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ],
        "priority": 4
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDI0Mw==",
        "titleTranslations": [
            {
                "value": "The Importance of F&B Master Planning for Building the Future Communities of KSA",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:50:00",
        "endsAt": "2024-04-30 15:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/S64F_hZClEA?si=2zicWj9yW6-mUDju\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nichola",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODc0ODI3LFVzZXJfMTU2OTQ1NDgp",
                "jobTitle": "Partner",
                "lastName": "Beskine-Taylor",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7adbc8bfdcd54036828c175c446b77c6.jpeg",
                "organization": "TGP International",
                "biography": "Nichola has worked in construction, hospitality and luxury retail delivering projects and developing concepts for over 15 years including working with global brands such as Cartier, Dior, Mastercard and Heathrow Airport.\nNichola’s expertise is in concept development, customer centric design and project delivery, which was bought together leading the successful re-launch of the Harrods Food Halls. She has also worked with brands and chefs to create bespoke dining concepts ranging from Perrier-Jouët and Baccarat.\nNichola joined TGP International in 2020 and leads an award-winning interior design and concept development team, carrying out advisory, design and project management contracts in KSA, Qatar, UAE and all over the Middle East and Europe for companies such as Kingdom Holdings, Al Futtaim, Nakheel and Expo 2020 Dubai. \nCurrent key projects in KSA include Al Mamlaka Dining Hall in the Kingdom Centre, the development of global expansion of the Saudi Coffee Company and F&B master-planning for the King Abdulaziz Center for World Culture – Ithra - restructuring their food & beverage, retail and venue hire offerings. \n\nAbout TGP International \nFormed in 2002, TGP International is an award-winning global agency for the hospitality and retail market dedicated to providing straight forward 360° solutions for an ever-evolving industry, with offices in the UK, Europe, USA and across the GCC. Drawing upon the team’s vast experience and skill base, TGP offers advisory services, concept development, interior design, franchising & licensing and asset management. With a dedicated award-winning inhouse design studio, TGP brings a unique multidisciplined approach to hospitality, creating world-class consumer experiences through the team’s expertise, innovation and passion. They have a large portfolio of franchising and licensing opportunities, from fast casual brands through to upscale restaurants and Michelin-starred chefs that are available to franchise, as well as developing market-entry strategies for brands to expand internationally.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Mw==",
                                    "title": "The Importance of F&B Master Planning for Building the Future Communities of KSA",
                                    "beginsAt": "2024-04-30 14:50:00",
                                    "endsAt": "2024-04-30 15:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Andrew",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDk5MjM1LFVzZXJfMTYxNzU4MDIp",
                "jobTitle": "Senior Director - Retail Development",
                "lastName": "Williamson",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/223f34fd755d4799ad09fad0c1d92d35.jpeg",
                "organization": "Red Sea Global",
                "biography": "Andrew Williamson is the Senior Director of Retail Development at Red Sea Global and is responsible for the RD&E development, leasing, fit-out and tenant management functions.\n\nPreviously he was the Head of Retail for JLL MENA for 7 years, working across the region consulting and leasing retail projects. He has worked with major developers in the region as a consultant and leased projects such as KAFD, Faisaliah, Mall of Muscat, and Deerfields in Abu Dhabi.\n\nHe has over 20 years-experience in the real estate industry in MENA and Canada across multiple roles, was a Board member of the MECSC and is a regular contributor at conferences including MAPIC.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Mw==",
                                    "title": "The Importance of F&B Master Planning for Building the Future Communities of KSA",
                                    "beginsAt": "2024-04-30 14:50:00",
                                    "endsAt": "2024-04-30 15:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jihad",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjk4NDU1LFVzZXJfMTU5NTgwNzMp",
                "jobTitle": "VP New Development Leasing",
                "lastName": "Dirani",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bb81d210bd524d4c80a36f2522c4de28.jpeg",
                "organization": "Cenomi Centers",
                "biography": "Jihad Dirani is currently the Vice President of New Development Leasing at Cenomi Centers.\n\nWith more than 18 years of retail leasing experience, Jihad brings a wealth of industry knowledge to spearhead the new development leasing team and implement Cenomi’s vision which aims to reshape the future of retail development across the Kingdom of Saudi Arabia. \n\nJihad’s main responsibilities focus on enhancing Cenomi’s vision by delivering Jawharat Jeddah and Jawharat Riyadh, the latest Flagship Luxury Destinations within the Cenomi Portfolio, as well as enriching its multi-purpose developments with an infusion of Retail, Leisure and F&B concepts. \n\nPrior to his current appointment, Jihad held a number of leadership positions with leading establishments in the region covering markets including the Kingdom of Saudi Arabia, United Arab Emirates, Egypt, Qatar, Oman, Bahrain and Lebanon. His previous experience encompasses Director of Leasing at Diriyah Gate Development Authority and Head of Leasing of Meraas managing the leasing of Dubai’s favorite destinations, such as The Beach, Bluewaters and Citywalk. Jihad also oversaw the market entry of TriGranit Management (TGM) into Dubai and the region in his capacity as the Leasing Director for the MENA region. \n\nAdditionally, he has been a member of the International Council of Shopping Centres (ICSC) and the Middle East Council of Shopping Centres (MECSC) since 2007. \nJihad holds a Master and a Bachelor of Business Administration from the American University of Beirut.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Mw==",
                                    "title": "The Importance of F&B Master Planning for Building the Future Communities of KSA",
                                    "beginsAt": "2024-04-30 14:50:00",
                                    "endsAt": "2024-04-30 15:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAxNA==",
        "titleTranslations": [
            {
                "value": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 14:55:00",
        "endsAt": "2024-04-30 15:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/4lPD1mbNUoI?si=K1ykQo0xRLYq-Ie0\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sebastien",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NjUzNDE2LFVzZXJfMTgzMDU2MDIp",
                "jobTitle": "Group Head of Hospitality",
                "lastName": "Carre",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5d687c7d1bd34fe383f0c0a3ba7da1c4.jpeg",
                "organization": "Red Sea Global",
                "biography": "Sébastien Carre is the Group Head of Hospitality at Red Sea Global (RSG), a closed joint stock company wholly owned by the Public Investment Fund (PIF), Saudi Arabia's sovereign wealth fund. \n\nIn this role, he spearheads the hospitality functions for The Red Sea and AMAALA, two groundbreaking regenerative tourism destinations that will elevate Saudi Arabia's position in global tourism.\n\nWith over 30 years of experience in luxury hospitality, Sébastien has an imAttendeesive background in managing multi-properties, improving, and developing high-end hotels, resorts, and serviced residences. His expertise includes global insights into luxury lifestyle, travel, and residential developments.\n\nSébastien's tenure includes notable roles in North America, Europe, the Middle East, Africa, and the Indian Ocean and Pacific Islands, where he managed and oversaw multiple Four Seasons Hotels & Resorts, demonstrating his ability to lead teams to success in diverse markets.\n\nBefore joining RSG, Sébastien was Regional Vice President at Four Seasons Hotels & Resorts. He oversaw properties in the Seychelles, Abu Dhabi, Tanzania, Azerbaijan, South Africa and led a comprehensive reinvention of the brand’s presence in Mauritius, significantly improving financial performance and achieving record-breaking results. He has also held leadership roles at Four Seasons in Johannesburg, Sharm El Sheikh, Bora Bora, Provence, and Washington DC, among others.\n\nSébastien is a graduate of VATEL Hospitality & Tourism Business School in Lyon, France, and is fluent in English and French.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Maria",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjA1MDQ1LFVzZXJfMTU4NTU5MjAp",
                "jobTitle": "Director Brand Development",
                "lastName": "Pichon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/dd66d705f0ce465296e009143ca4325d.jpeg",
                "organization": "NEOM Hotel Division",
                "biography": "A recognized industry expert with almost two decades of experience in hospitality, Maria oversees the brand development strategy for NEOM Hotel Development to help achieve its vision for the future of the industry. This involves the curation and development of unique and iconic NEOM branded hotel concepts, brand culture, marketing communications, and devising its digital guest experience strategy.\n\nMaria’s track record includes brand building, quality management and various change management projects, resulting in process enhancements and efficient service deliveries across all business channels. She has a wealth of experience in creating distinct brand assets and executing integrated strategic marketing campaigns. While her expertise in hospitality guest insights, market segmentation, competitive intelligence and industry trends have seen her lead and implement brand experiences for properties across the UAE, Italy and Egypt. \n\nFluent in Swedish and English, she received a Diploma in Project Management from the IHM Business School and is certified in Executive Leadership from Cornell University. Maria also holds a Diploma in Business Psychology, and is working towards a Master’s in Business Management, both from the University of Essex.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Agnès",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjA1MDYzLFVzZXJfMTYzMjM4KQ==",
                "jobTitle": "Chief Development Officer, Luxury & Lifestyle",
                "lastName": "Roquefort",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b11bfb415f7942958d0cd947ffd68b3c.jpeg",
                "organization": "Accor",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTk3ODU1LFVzZXJfMTcyMjIxMDcp",
                "jobTitle": "Managing Director – Middle East and Africa",
                "lastName": "Ansell",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/68a36c2c3cde4c0ea405fdf3c809aa46.jpeg",
                "organization": "Hyatt",
                "biography": "Stephen Ansell has recently been appointed the Managing Director for Hyatt in the Middle East and Africa regional division. Working at Hyatt for 27 years, Stephen has held several leadership positions in the company. Before his current role as Managing Director, Stephen was in a dual role as Area Vice President for Central Europe where he was responsible for Hyatt’s operations in the region, as well as the General Manager at Park Hyatt Zurich, where Stephen oversaw the running of the luxury Swiss hotel, applying his passion and expertise of the hotel industry at the property level. Stephen joined Hyatt in 1996 as Director of F&B at Hyatt Regency Riyadh and has since held General Manager positions at several Hyatt hotels including Hyatt Regency Bishkek, Hyatt Regency Kyiv, where he was central to the hotel’s opening, and Park Hyatt Moscow, where he spent nine successful years before being appointed as Area Vice President of Russia and Eastern Europe in 2014. Stephen holds a degree in Hotel and Catering Management from the University of Portsmouth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTI2OTE1LFVzZXJfMTU3NTczMzUp",
                "jobTitle": "Head of Hotels & Tourism",
                "lastName": "Manzoor",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
                "organization": "CBRE MENA",
                "biography": "Ali is Head of Hotels & Tourism at CBRE in the Middle East, dedicated to providing creative, hands-on hospitality expertise across the region.\n \nHaving been in the industry for over 15 years, Ali is a well-established hospitality specialist with experience in hotel advisory, valuations and operations. During his time in the Middle East, Ali has worked with developers, Attendeess and governmental institutions on feasibility studies, hotel valuations, pricing strategies, asset reviews and optimum site use for both large-scale multi-use projects and stand-alone assets. He has also led several owner-operator Hotel Management Agreement negotiations across a number of jurisdictions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU5NQ==",
        "titleTranslations": [
            {
                "value": "Workshop: Investing in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:00:00",
        "endsAt": "2024-04-30 16:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ahmad",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzgyNzI5LFVzZXJfMTU4NjAwNzcp",
                "jobTitle": "Investment Management Executive Director",
                "lastName": "Almutawa",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b95be56a957247a5a0ef5782ed81378d.jpeg",
                "organization": "ASFAR",
                "biography": "Ahmad AlMutawa boasts over 17 years of seasoned experience in banking and investment, fostering partnerships with prominent national and international entities across Saudi Arabia's private and public sectors. With a portfolio spanning real estate development, construction, and trading, he holds key positions on the boards and committees of various enterprises. As a distinguished member of the Saudi Authority for Accredited Valuers, Ahmad brings invaluable insight to the industry. He holds an Executive Master's in Business from LBS and a Bachelor's in Finance and Economics from KFUPM. Presently, Ahmad spearheads the strategic investment division at ASFAR, driving forward innovative ventures and initiatives.\n\n",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5NQ==",
                                    "title": "Workshop: Investing in Saudi Arabia",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Abdulrahman",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4Nzc0MTczLFVzZXJfMTYwMzcyNDgp",
                "jobTitle": "Investment Development Executive Director",
                "lastName": "AlMalik",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/eb9aacd610b74d77a0e70f38c84d48e8.jpeg",
                "organization": "ASFAR",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5NQ==",
                                    "title": "Workshop: Investing in Saudi Arabia",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
        "titleTranslations": [
            {
                "value": "The Power of AI in Hospitality: Practical Solutions for Investors",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:00:00",
        "endsAt": "2024-04-30 15:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/PswPZMinA_g?si=Nz2h9HkQ6r2Ugfmy\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODU4LFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Head of Hotel Advisory, Hospitality & Tourism | MENA Region",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers",
                "biography": "Nicolas oversees the execution of greenfield and brownfield hospitality and tourism feasibility studies, operator search and selection, and strategic development advisory projects in MENA. Nicolas holds an MBA and a Master's in Business Analytics and has developed broad expertise in commercial real estate advisory, covering hotels, serviced apartments, residential, spa & wellness, golf, marina and yachting, retail, arts & culture, and leisure assets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ankur",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTI1LFVzZXJfOTgwNDAyNyk=",
                "jobTitle": "CEO & Founder",
                "lastName": "Agrawal",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b3ff5b51d6b54a2787c0617014e2803f.jpeg",
                "organization": "Inhabitr",
                "biography": "Ankur founded Inhabitr in 2018, after moving a few countries and cities he became convinced that the furniture market was under-served in terms of affordable designer furniture on subscription, which met the needs of the present-day millennials \nwho move a lot. Inhabitr, which is a technology platform, connects the furniture world with businesses like Hotels, Student Housing and Multifamily apartments looking for designer furniture on subscription. Inhabitr uses Artificial Intelligence (AI) to curate furniture from various sources and enables furniture factories and suppliers to participate in rental commerce to allow furniture to be re-used and therefore also save the planet. \nAnkur Agrawal is an ex Partner at McKinsey’s Chicago Office where he was a leader of their global Consumer Packaged Goods (CPG) service line. Over the past 12+ years of his affiliation with the CPG industry, Ankur has lived and worked across four continents in Asia, the Middle East, Europe, and now the USA and extensively worked with global Consumer Goods and Retail chains in shaping a variety of leading-edge topics like Design for growth, Digital, and Operations as a competitive advantage Ankur has a lot of personal passion for growth and innovation and he mentors several companies and startups across the globe on market entry and growth topics. Ankur also serves on the board of many Non-Profits and Startup Clubs. \nAnkur is also a robotics enthusiast and holds an engineering degree from Jacobs University in Germany. Ankur is married to Pratiksha who is a Dentist. Ankur and Pratiksha live in Sunnyvale, CA with their 3-year-old son Tanish",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg4MTExMA==",
                                    "title": "Digital Talks: How AI and Digital can optimise end-to-end procurement",
                                    "beginsAt": "2024-04-30 09:35:00",
                                    "endsAt": "2024-04-30 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ahmed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTIwNDY2LFVzZXJfODk4OTMyNyk=",
                "jobTitle": "Technical Consultant",
                "lastName": "Zeeshan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b531f69fb5084260a620c26478431e19.jpeg",
                "organization": "HPE Aruba Consulting Systems Engineer",
                "biography": "A seasoned ICT Consultant with having in-depth understanding of emerging technologies. Deep understanding of strategic selling, and conceptual selling with over 20 years of experience in executing the complete technology sales cycle. An enthusiast and believer of emerging technologies and their role in the universe for a promising future.\nHe has performed in large-scale trend setting ICT solutions development for Service Providers, Financial Institutions, Public Sector organizations, Hospitality and Enterprise Networks successfully over the years. He is HPE Aruba technical lead for KSA Giga Projects. Ahmad has deep insight of the solutions and products for SP and Hospitality market including Data Center , SASE, Private 5G which requires complex integration. He has design and deployed Kingdom’s first Cellular-WIFI Offloading project and successfully deployed HS2.0 Capabilities Powered by Aruba Networks.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Tech & Innovation"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
        "titleTranslations": [
            {
                "value": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:10:00",
        "endsAt": "2024-04-30 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/n4eHcCflxyo?si=U-1RGMcGLY-ECWev\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Kurt",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDU5MDg5LFVzZXJfMTkxMzI1NjIp",
                "jobTitle": "Chef, Founder & Owner",
                "lastName": "Zdesar",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d3070b8eba24461eb956ce983f237021.jpeg",
                "organization": "Chotto Matte",
                "biography": "Founder and Owner of Chotto Matte, Kurt Zdesar is an Australian born chef and restaurateur with over 30 years’ experience in the global hospitality industry. \n\nWorking his way up from kitchens to front of house and to management, Kurt has a holistic understanding of the hospitality industry. Kurt has spearheaded many pioneering concepts within the sector with almost a decade as European Director at Nobu, where he established their first European restaurant in London which received a Michelin Star within 10 months of opening; the UK's first Michelin Star for Asian cuisine. He consulted for Alan Yau on the launch of Hakassan, helping to establish London's second Asian restaurant to receive a Michelin Star. In 2005, Kurt founded global dim sum chain Ping Pong, launching the business as a highly successful global brand, with a growing revenue from zero to £15m per annum within 2 years.\n\nSelling his stake in Ping Pong, Zdesar then continued as a restaurant consultant and concept developer, where he used his industry knowledge and experience to build further fine dining restaurants including Mews of Mayfair (London), Les Bains Douches (Paris) and Block 338 (Bahrain). Continuing his trajectory of developing successful culinary concepts, Kurt launched NZR Restaurant Group, founding Black Roe in Mayfair and Fucina in Marylebone. \n\nKurt identified a gap in the market for premium Nikkei cuisine and launched Chotto Matte (Frith Street Soho) in 2013. This marked London’s debut restaurant solely dedicated to the marriage of Japanese techniques and Peruvian flavours whilst committed to using non-GMO, pesticide and hormone-free ingredients, ensuring high quality fine dining whilst honoring the brand’s dedication to sustainability. Chotto Matte has secured its position as one of the top trailblazing restaurants in the city with Kurt behind the curation of every aspect from menu creation to music programming, to the bespoke design, working with long-time collaborator Andy Martin of Superfutures for each Chotto Matte site.\n\nCarefully selecting each site, these highly crafted spaces are designed to reflect the culture of each city in which they are located, working with individual craftsmen and global artists to bring the restaurant to life. Outposts include London’s Soho and Marylebone in Europe, San Francisco, Miami and Toronto in North America and Doha in the Middle East. Kurt is currently focusing on the continued international expansion of Chotto Matte with further confirmed sites in Manchester, Tbilisi, Riyadh and Dubai. \n\nChotto Matte Ltd is part of Noble Restaurant Group, a restaurant company that owns and operates other well-known brands Alley Cats Pizza, Steak and Company, Angus Steakhouse, Ochre, and Muriel's Kitchen.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA0NDA0LFVzZXJfMTYyNTA1MDkp",
                "jobTitle": "Founding Partner",
                "lastName": "Hacon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
                "organization": "Think Hospitality",
                "biography": "James is one of the leading names in hospitality growth, marketing & brand strategy, he has been an executive, board member, Attendees and consultant in the hospitality brand and technology sector for the past twenty years, having worked with more than 80 hospitality brands in 22 countries, from independent Michelin starred restaurants to leading restaurant brands, international hotel companies & contract caterers. \n\nHis brand experience includes Accor, IHG, Sodexo, Compass Group, Krispy Kreme, Costa Coffee, Diageo, AMREST, Jamie Oliver Group, Wagamama, Gleneagles & Pret. \n\nHe is regularly called upon as a commentator, writer, speaker & facilitator, giving him a unique insight into global trends and the very best brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                                    "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                                    "beginsAt": "2024-04-30 09:45:00",
                                    "endsAt": "2024-04-30 10:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                                    "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                                    "beginsAt": "2024-04-30 12:10:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                                    "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                                    "beginsAt": "2024-04-30 15:10:00",
                                    "endsAt": "2024-04-30 15:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                                    "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                                    "beginsAt": "2024-04-30 13:30:00",
                                    "endsAt": "2024-04-30 14:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1NjIzMA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: To the Metaverse with Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:20:00",
        "endsAt": "2024-04-30 15:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/2LK8uBOG8j8?si=E1CqqE5mHLrl6U6h\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Joe",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NTUzNDkzLFVzZXJfODI0ODc4NCk=",
                "jobTitle": "Managing Director",
                "lastName": "Tabet",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
                "organization": "JT+Partners",
                "biography": "Joe Tabet is an innovative visionary architect wearing different hats, with +20 years of professional experience in worldwide architecture and construction industry.\nJoe founded JT&Partners in 2015, starting with a handful of staff in a +100sqm office in Business Bay, Dubai. The company became an “overnight success”, earning recognition as an acclaimed international multidisciplinary consultant with imAttendeesive projects located in global destinations.\nHe creates buildings and communities that transcend design and encompass social and environmental issues. Joe, JT&Partners and its projects received awards and recognitions from Cityscape, MEA, Arabian Property, UAE Business Awards, UAP Dubai. Recent completed projects include hotels in RAK, Seychelles and Egypt. Ongoing and upcoming projects include residential towers and villas, hotels, resorts, golf course, waterpark and hospital in Abu Dhabi, Dubai, RAK, Sharjah, Egypt, Greece and KSA.\nAlways alert to the latest trends and with eyes towards the future, he pushes his staff into looking at innovation, Internet of Things, digital twin, 3D printing, modeller construction and invests in the newest multi-media technology and up-to-date state-of-the-art tools.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Markus",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzcxMDUwLFVzZXJfMTYxNjMyNTYp",
                "jobTitle": "Chairman",
                "lastName": "Schreyer",
                "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
                "organization": "META Foundation",
                "biography": "Markus Schreyer is a global hospitality executive at the forefront of business & brand development, innovation, experience design, and STEM. His career encompasses roles across 40 countries and 20 luxury brands in global hotel chains like Hilton Hotels & Resorts and Starwood Hotels & Resorts. He has also held leadership positions in lifestyle brands, including Senior Vice President of Global Innovation at Design Hotels, a Marriott brand, and Chief Development Officer at Proper Hospitality.\n\nHis passion for fostering growth, mentoring global teams, and developing new revenue streams—such as retail, experiences, and membership models for lifestyle brands through strategic innovation and human-touch points across multiple digital platforms—has earned him recognition across industries. \n\nAs the co-founder and chairman of the META Foundation, a visionary hospitality innovation lab established in 2020, he accelerates global projects in cultural, social, and sustainable development. The foundation collaborates with developers, brands, and technologists across industries, introducing impactful business models in living, travel, and community building enabled through AI, web3, and spatial computing, fostering project longevity.\n\nMarkus Schreyer holds an MBA and a PhD in Innovation Strategy from the University of Dresden, Germany. He teaches competitive strategy and venture development at New York University (NYU) and brand, marketing, and PR at Parsons School of Design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Talks",
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDI0MA==",
        "titleTranslations": [
            {
                "value": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:30:00",
        "endsAt": "2024-04-30 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/yXb93nJ3WNY?si=eB4L0TB_QB331smo\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "workshop-room",
                "translations": [
                    {
                        "value": "Innovation Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTgxODg1LFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/288a7ad5b80448359b1f72694ccbc88d.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC.He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nWith family roots in the region for over fifty years, Ben founded Andart Global as he believed the GCC deserved better. Business as usual is no longer sufficient to support the reality and ambition of the region, as it assumes a more prominent place on the global stage and powers into a new phase of transformation and growth. \n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dominique",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDAwNzk2LFVzZXJfMTkwOTY4MzUp",
                "jobTitle": "Founder & Managing Director - Hong Kong & Singapore",
                "lastName": "Backhouse",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/97c8d1b26223405ebc9c96241bcdf3e7.jpeg",
                "organization": "Companion Communications",
                "biography": "Dominique Backhouse opened COMPANION in 2019 to fill a gap for a senior-led and strategic approach to communications in Asia - specializing in the travel, dining and property industries.Today, COMPANION has two offices in Hong Kong and Singapore, and teams across Strategic Communications, Lifestyle Public Relations, Corporate Communications, Content Creation and Social Media. \n\nCOMPANION is a leader in the Asian region, and has worked with clients as far ranging as Hongkong Land, Maximal Concepts, Rosewood Hotels & Resorts,  Barratt London, Fairmont Hotels & Resorts and Shangri-La Group among many more. Beyond the big names, however,  COMPANION prides itself on its work with small independent brands - helping them strategize their positioning and creating authentic storytelling and relationship building for each. As such, COMPANION has been an intrinsic part of the launch strategies of many award-winning local concepts. \n\nFor her work at COMPANION, Dominique was recently named 40 Under 40 by Campaign Asia-Pacific, an award that showcases innovation, grit and boundary-pushing brilliance in the Greater China and Asian regions.   \n\nPrior to opening COMPANION, Dominique managed the Asia-Pacific and Greater China PR strategy for hotel brand COMO Hotels and Resorts, with a particular focus on their Asian properties and restaurants in Singapore, Thailand, Indonesia, Australia and Bhutan. \n\nBefore her time inhouse, Dominique spent over a decade agency-side in Asia where she led regional strategies for Belmond, Oetker Collection, Qantas, One&Only Resorts, Leading Hotels of the World, CE LA VI, Aqua Restaurant Group, Champagne Barons de Rothschild, Longines Horse Masters and many more.\n\nDominique is third generation Hong Kong, where she grew up - and has spent her entire career working in the major Asian media markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Peggy",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTgyLFVzZXJfMTM0NDQxOSk=",
                "jobTitle": "Managing Partner",
                "lastName": "Li",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/efe71ac9b3d7472f8a47c69a09b3b3a1.jpeg",
                "organization": "SPS Affinity",
                "biography": "Peggy Li solid Michelin star high-end food & beverage operator turned service industries consultant with 15+ years of executive-level management experience in Europe, the Middle East, and the Far East. \n\nPeggy has worked in world-renowned Michelin star acclaimed establishments such as L’Atelier de Joel Robuchon and is an individual with an exceptionally strong work ethic, and an ambitious professional. \n\nWith Peggy’s strong working persona, she has caved on many successful business ventures prior to settling in as a Managing Partner at SPS: Affinity, a Service-Centric Global Strategy & Communication Consultancy that delivers innovative consulting services to partners in the hospitality, leisure, and tourism, retail, and service industries in the Middle East. In 2018, the cultivation of our China focus arm from Chinese social media, SEO, and Procurement to business connect. Our comprehensive approach covers messaging, product offerings, competitor analysis, and route to market, all designed to launch.\n\nDuring EXPO 2020 in Dubai, holding the position of the Food & Beverage Consultant for the China and Venezuela Country Pavilion, Local Service Agent for the Estonia Country Pavilion, and Commercial Liaison at the Build phase of the Brunei Country Pavilion. Follow by being one of the judges of Caterer Middles East 2021 and speaking a various industry prestige events such as Gulfood, GITEX, and Arabian Travel Market. \n\nPeggy is an active member of the Dubai Chamber of Commerce, and UAE Chinese Businesswomen Council, this level of network and association elevates the work synergy among female entrepreneurs.  \n\nPeggy is also a start-up mentor and adviser at WOMENA, StartAD, Dubai Business Council, Sharjah Businesswomen Council, TiE Dubai, In5 Tech Incubator & Accelerator, and SHERAA.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:35:00",
        "endsAt": "2024-04-30 15:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/mDMP-yuOftc?si=ClgMj7aYtluCN-Tm\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "heritage-and-tourism",
                "translations": [
                    {
                        "value": "Culture & Heritage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Oliver",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5Njc5NTUxLFVzZXJfMTg5MTM4MDIp",
                "jobTitle": "Chief Executive Officer, H World International",
                "lastName": "Bonke",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/60d4162adf374db99b90e5aa99e0135f.jpeg",
                "organization": "Managing Director, Steigenberger Hotels GmbH",
                "biography": "A graduate of Loyola University New Orleans and Harvard Business School, Bonke’s 30 years in the hospitality industry have spanned international experience as Senior Vice President, Chief Commercial Officer and Chief Operating Officer of renowned hotel groups such as Starwood Hotels & Resorts, Loews Hotels & Co and Shangri-La Group. Prior to joining Steigenberger Hotels GmbH as Chief Executive Officer in April 2022 and subsequently H World International in 2023, he worked as a Senior Advisor for the Boston Consulting Group.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Culture & Heritage",
            "Talks"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
        "titleTranslations": [
            {
                "value": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:35:00",
        "endsAt": "2024-04-30 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/tG6efWyRu1c?si=UPInacQnRJfEi5Xe\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daniel von",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ2MDExLFVzZXJfOTc0MTM4OSk=",
                "jobTitle": "Regional Vice President, Accor One Living",
                "lastName": "Barloewen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
                "organization": "Head of Mixed-Use (EMEA), ACCOR",
                "biography": "Daniel von Barloewen is the Regional Vice President of Accor One Living and Head of Mixed-Use for Accor for Europe, Middle East, Africa and India. His remit covers development, brand advisory & marketing support for development partners, as well as operations for branded residences, golf, private members’ clubs, and co-working.\n\nBoasting 42 brands, over 6,500 open and pipeline hotels with c.1,000,000 rooms, Accor is the world's 2nd largest branded residential operator (with over 150 open and pipeline residence projects, approximately 25,000 Residences, with more than USD $15bn of value of real estate licensed under 25 of its brands in the Accor and Ennismore portfolio). In 2023 more than $2.2Bn of residential real estate was sold under Accor brands.\n\nAccor offers world class residential expertise, bringing iconic brands and legendary hospitality service to private home ownership. Located in prime urban locations and the sought after resort destinations, our residential properties are a natural extensions of our iconic hotel brands. Providing development partners with a tremendous value creation opportunity, our branded private residences offer the potential to generate significant brand premiums and enhanced hotel economics as a result of co-location strategy, which help drive supplementary revenue (F&B, Spa) to the hotel.\n\nPrior to joining Accor, Daniel von Barloewen founded a real estate consultancy business, Strategic Development Advisors Ltd, which provided a range of development advisory services as well as hotel operator searches and contract negotiation to both institutional and private Attendeess. Before that, he was head of Mixed-Use Development Europe at Marriott International, and previously spent 11 years at Savills where he created and ran the Global Residential Development Consultancy department.\n\nOriginally a development surveyor, Daniel brings an over 18-year track record on the advisory side and hotel operator side of residential, mixed-use and integrated resort development projects, in over 40 countries, with particular expertise on branded residences and co-located hotel and residential development. He is skilled at working with a wide range of Attendees and developer profiles, with the ability to focus strategically on opportunity analysis, value generation, risk reduction, exit strategy, ROI and development strategy evaluation.\n\nDaniel speaks 4 languages, is also a Major in the British Army Reserves, and has served with distinction in Afghanistan. He holds a Bachelors Degree from the University of Durham, a Masters Degree from CASS Business School and is a Member of the Chartered Management Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Scott",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODEwLFVzZXJfMjMzNjI1MSk=",
                "jobTitle": "Founder & Owner",
                "lastName": "Antel",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/750373591fb945a3b6ee3e909a226df6.jpeg",
                "organization": "Scotts FZ LLE",
                "biography": "Scott Antel is a highly respected emerging markets hotels & hospitality lawyer with 25+ years’ experience advising both owners/developers and, less frequently, international operators in the Middle East, Africa, Russia/CIS countries, Turkey, Southern & Eastern Europe and the Caribbean on hotel & resort, branded residential and mixed-use developments.\n\nA former senior partner in DLA Piper and BCLP, Scott regularly advises clients on all aspects of hotel & resort development, with a specific focus on branded residential and mixed-use development, as well as advising on related operational matters, including disputes and litigation.\n\nHe has acted on hundreds of hotel projects including numerous landmark projects such as Sochi 2014, Grand Hotel Europe and Astoria Hotel in St Petersburg, the Ritz Carlton and Mandarin Oriental in Moscow, Four Seasons, Mandarin Oriental and Chedi hotels in Oman, JW Marriott and W Yas Island in the UAE, Sofitel and Hyatt hotel and residence projects in Cyprus and many others projects in numerous locations, including Moscow, St Petersburg, Sochi, Almaty, Istanbul, Bodrum, London, Muscat, Zanzibar, Dubai, Abu Dhabi, Jeddah, Makkah, Riyadh, Tehran, Muscat, Limassol, Crete, Montenegro, Vietnam and more than 15 African countries.\n\nHe also works in the franchise sector advising hotels, restaurants and retail clients and on the structuring and set up of inbound franchise investment and operation, including franchise conversions of managed hotels.\n\nScott is recommended as a \"Leading Adviser\" and \"go to\" hospitality lawyer by Chambers Europe and Legal 500 legal directories and listed in Best Lawyers. He serves on the Advisory Boards of the Arabian, African, Southern European snd Russian Hotel Investment Conferences and is a regular outspoken speaker at these events, as well at the Berlin (IHIF) and ALIS (US) hotel conferences. Scott is a regularly published thought leader and frequently quoted on hospitality related legal and commercial matters.\n\nScott was recipient of the Russia/CIS Hotel Investment Forum's 2012 “Lifetime Achievement Award” for his contribution in developing the hotel industry in these emerging markets, the only lawyer or consultant to ever receive this prestigious award. In 2011 he was elected a member of the International Society of Hospitality Consultants (ISHC). A UK citizen, Scott variously resides in Dubai, London and Moscow.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Serena",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4Nzc0NzEzLFVzZXJfMTQxNjU3Njgp",
                "jobTitle": "Chief Growth Officer",
                "lastName": "Lim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/001a18f724f34456972674b28bbe07a1.jpeg",
                "organization": "The Ascott Limited",
                "biography": "Serena is Chief Growth Officer at The Ascott Limited (Ascott), leading its global business development team to steer and manage the company’s growth in management and franchise contracts globally . Supporting the group’s development ambitions through an asset light strategy to deliver strong recurring fee income, Serena and her team drives continued opportunities to extend Ascott’s geographic reach across key growth markets.\n\nShe joined Ascott in January 2023 and brings over two decades of experience in hotel development, strategic planning and feasibility.\n\nMost recently in the role of Vice President, Development, Southeast Asia and Korea at the InterContinental Hotels Group (IHG), Serena was responsible for leading IHG’s development strategy and extended growth teams in the region. Serena played an integral role in implementing initiatives to align culture with strategy and processes as a key member of the leadership team. \n\nPrior to joining IHG, Serena was responsible for development efforts in Southeast Asia at Marriott International, where she held the role of Regional Vice President. She spent early parts of her career with Starwood Hotels and Resorts, where she led the company’s expansion across Southeast Asia, while overseeing feasibility and strategic planning efforts in Asia Pacific. \n\nSerena graduated on the Dean’s List with a Bachelor of Science (Distinction) in Hotel Administration and Major in Finance at Cornell University, School of Hotel Administration.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Julien",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDY0ODg1LFVzZXJfMTEyNTg3NTEp",
                "jobTitle": "Director, Mixed-Use Development (EMEA)",
                "lastName": "Laloye",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/87c9b931df3243d1a7ea88d1c7554587.jpeg",
                "organization": "Marriott International",
                "biography": "With over a decade of extensive experience in the hospitality and real estate sectors, Julien is adept at driving mixed-use development projects to success. Currently serving as the Director of Mixed-Use Development for the EMEA region at Marriott International, he looks after the growth of Marriott brands in the branded residential sector across the EMEA region.\n\nPrior to his current role, he held pivotal positions at renowned organizations across diverse global locations. During his tenure as Vice President – Hotels Advisory for JLL in Nairobi, then Hong-Kong, he advised Attendeess and developers on their hospitality investments across sub-Saharan Africa as well as Asia Pacific. His tenure with Emaar Hospitality Group in hotel and branded residence development further enriched his understanding of development dynamics in the regional market.\n\nFueled by a passion for innovation and a commitment to excellence, Julien continues to drive forward-thinking strategies that redefine mixed-use developments, leaving a lasting impact on the landscape of hospitality and real estate.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTMzODYzLFVzZXJfMTg2NzQ3NSk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Bridger",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
                "organization": "Rove Hotels",
                "biography": "A proven hospitality leader with more than 20 years of experience across the Middle East, Asia, the UK & Ireland, Paul Bridger is the Chief Operating Officer of Rove Hotels, the smart, value hospitality brand created as a joint venture between Emaar Properties PJSC and Meraas Holding.\n\nPaul heads Rove Hotels and is responsible for overseeing the initiation, planning, and achievement of strategic brand objectives, ensuring a successful and consistent rollout of this new mid-scale lifestyle offering. His role also includes providing leadership and management focus on the business operations to achieve maximum financial performance, and team and customer satisfaction. \n \nBefore joining Rove Hotels, Paul worked with one of the UK’s largest hotel, restaurant, and café operators where he held the position of General Manager for eight years, before taking on larger responsibilities as Regional Director of Operations – Southeast Asia. \n\nPaul has diverse experience in markets such as the UK, UAE, Singapore, Thailand, Indonesia, and Malaysia with a focus on hospitality leadership.\n\nPaul holds an MBA in Hospitality from Ecole hôtelière de Lausanne (EHL), Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination",
            "Investment & Development"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTc4MjkyMA==",
        "titleTranslations": [
            {
                "value": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 15:50:00",
        "endsAt": "2024-04-30 16:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/sVASe2qDMDA?si=boDSf8nUO0al923_\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "heritage-and-tourism",
                "translations": [
                    {
                        "value": "Culture & Heritage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mark",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODk3LFVzZXJfMTU3NTczMDkp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "De Cocinis",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a5d5d41c8a6044fbb44c53d5660991e0.jpeg",
                "organization": "Boutique Group",
                "biography": "As the Chief Executive Officer at Boutique Group, Mark De Cocinis leads creating the finest Saudi hospitality experience, turning historical and cultural palaces into ultra-luxury hotels. Before joining Boutique Group, he was the Chief Executive Officer of Urban Resort Concepts, a boutique ultra-luxury hotel company based in Shanghai, China, overseeing boutique hotels in Asia. He was President of DeMarcheli Hospitality Limited HK, an Asset Management company working with owners investing and developing prime real estate with luxury hotels and residences in Asia Pacific.\n \nMark has dedicated his long career of over 40 years to the luxury hospitality segment, having worked for some of the most prestigious hotel brands across North America, Europe, the Middle East, and Asia, including President & COO of One & Only Resorts, Executive Vice President Global for Shangri-La Group, and Regional Vice President Asia Pacific for The Ritz-Carlton Hotel Company. In his long outstanding career, De Cocinis received the inaugural Friendship Award in 2004 from Hu Jintao - former President of the People's Republic of China- for his remarkable community service and charity fundraising. Mark has also been honored with the Magnolia Award (Silver and Gold) for his exceptional contributions to business, people development, and community support through his involvement with the Children's Charity Foundation in China.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                                    "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                                    "beginsAt": "2024-04-30 15:50:00",
                                    "endsAt": "2024-04-30 16:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Suma",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTMzODM0LFVzZXJfMTU3NTczMDMp",
                "jobTitle": "Executive Vice President – Real Estate & Development",
                "lastName": "Venkatesh",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ab0f7a5ca0ac4be2a3e2f1d4b1154738.jpeg",
                "organization": "The Indian Hotels Company Limited",
                "biography": "Ms. Suma is an Engineer and an MBA in Marketing & Finance. She brings over 30 years of varied experience across engineering, financial services, real estate and hospitality sectors. She has worked across different functions ranging advisory services, financial structuring and lending for infrastructure projects and contract negotiations, planning and development of real estate and hotel projects. As Executive Vice President – Real Estate & Development, she heads IHCL’s Development, Projects & Technical Services and Asset Management functions. She leads the company’s growth and expansion initiatives and has delivered a fourfold growth of the company’s portfolio during the course of her remarkable journey of two decades with the company. She is a director on the board of PIEM Hotels and few others.\nShe has won many awards and accolades during her career and has most recently\nbeen recognized for her outstanding contributions to Inclusion and Diversity in the tourism sector by IIPT (International Institute for Peace through Tourism) at the 7th \"Celebrating Her Awards\" at ITB, Berlin last week.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                                    "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                                    "beginsAt": "2024-04-30 15:50:00",
                                    "endsAt": "2024-04-30 16:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDMxNzYzLFVzZXJfMTYwNzY4OTIp",
                "jobTitle": "Reporter",
                "lastName": "Tabbara",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/89acb46a77f245b9a24dab0275fc3d39.jpeg",
                "organization": "CNN Business Arabic",
                "biography": "Rana Tabbara is a seasoned multimedia journalist with a wealth of experience in economic and social news coverage. Her journalistic prowess shines through her special interviews with CEOs of major companies and prominent government figures worldwide.\n\nHaving made valuable contributions to global media outlets, Rana found her niche at CNN Business Arabic, where she extensively covers real estate news, establishing herself as an expert in the field.\n\nHer dedication to providing comprehensive reports tailored to readers' needs is evident in her work. Since joining CNN Business Arabic, Rana has infused the platform's content with her unique perspective, crafting distinctive stories and conducting successful interviews with VIPs, further solidifying her reputation as a top-notch journalist in the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MQ==",
                                    "title": "TenX Leadership Talks:  An All-Inclusive Transformation of an Iconic Brand while Staying True to its Roots",
                                    "beginsAt": "2024-04-30 12:50:00",
                                    "endsAt": "2024-04-30 13:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                                    "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                                    "beginsAt": "2024-04-30 15:50:00",
                                    "endsAt": "2024-04-30 16:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Culture & Heritage"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2NA==",
        "titleTranslations": [
            {
                "value": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:10:00",
        "endsAt": "2024-04-30 16:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/CjSr8uA7RSI?si=BEhMQpG7eXoUUQwp\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Louis",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODI1LFVzZXJfMTU3NTczMTAp",
                "jobTitle": "Chief Development Officer & Deputy Head of Middle East, Africa & Turkey",
                "lastName": "Abboud",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fc5fda656ea943b2ac6c1d865715584a.jpeg",
                "organization": "Global Head, F&B Development, Ennismore",
                "biography": "Louis is the Chief Development Officer and Deputy Head for the Middle East, Africa, India and Turkey at Ennismore, where he oversees all facets of hotel development and operations, from partnership inception, deal-making, owner relations, to property design and pre-opening activities. He also serves as the Global Head of F&B Development, leading Ennismore's investment strategy in its F&B platforms, including Rikas and Paris Society. Louis is focused on accelerating the growth of Ennismore’s hotels, residences, and F&B brands.\nBefore joining Ennismore, Louis held the role of VP of Development, Middle East and Africa at Accor. His career began in hotel operations at Starwood Hotels and Resorts in California, followed by roles in asset management with the Saudi BinLadin Group in Jeddah and Majid Al Futtaim in Dubai. Louis also gained valuable experience in hospitality consultancy with HVS in Dubai, specializing in consulting and valuations",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Christoph",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczODM5LFVzZXJfMzc3NTc4MSk=",
                "jobTitle": "Founder",
                "lastName": "Hoffmann",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3d075c630818485aa84b95f95ea4bca2.jpeg",
                "organization": "25hours Hotels",
                "biography": "A consummate storyteller and hotel romantic, Christoph Hoffmann, founder of 25hours Hotels, oversees the development and expansion of the 25hours hotel group. He’s often seen zipping through airports with his elaborately stickered Rimowa in tow or buzzing through city streets on a bicycle en route to evaluate new hotel locations. With what he considers an “imperative collaboration of local partners,” he develops sharply tailored properties for city nomads, daydreamers and night owls with a penchant for urban landscapes and democratic hotel culture, while ensuring each project is full of soul. \nHoffman grew up in a small town in southern Germany, and after graduating from secondary school, began a career in tourism at a New York-based incentive agency. “New York was my first education,” he says. Yet, knowing he had to hone his hospitality skills, he went on to study sales, marketing and strategic management at the Glion Institute (École Hotelière et de Tourisme Leysin) in Switzerland and Cornell University, and thus, his adoration for the hotel business truly began. \n\nHoffmann’s initiation into the industry was at the American Colony Hotel in Jerusalem, where he immediately fell in love with the progressive Israeli culture. He then returned to New York for a stint at the Box Tree Hotel and a management position at New World Travel, Inc. Soon, the old-world sentimentality of Europe called him back, taking up positions at Kempinski Hotels, the Bürgenstock Hotels & Resorts in Switzerland and the Hotel Louis C. Jacob in Hamburg; he was hooked, and, in 2005, along with partners Stephan Gerhard, Ardi Goldman and Kai Hollmann, he founded the 25hours Hotel Company in order to expand the already successfully established Hamburg-based 25hours concept. \n\nHoffmann was awarded German Hotelier of the Year in 2017 and named the Most Dynamic Hotelier by Monocle magazine in 2018. His affinity for the Cycladic islands, antique markets, red wine, real books, an incredible repertoire of musical interests, delicious food, the mountains, poetry, sunshine, and grand hotels, are his muse to develop forward-thinking, authentic hospitality concepts all over the world. \nAbout 25hours Hotels \n\n25hours Hotels is part of Ennismore, a creative hospitality company rooted in culture and community, with a global collective of entrepreneurial and founder-built brands with purpose at their heart. Ennismore is a joint venture with Accor, formed in 2021.\n\nChristoph Hoffmann, Kai Hollmann, Ardi Goldman and Stephan Gerhard were the founders and creative minds behind the 25hours brand, that today operates 15 hotels in German speaking countries as well as Paris, Florence, Dubai and Copenhagen. 25hours is a smart, culturally resonant hotel idea characterised by provocative urban locations, irreverent yet functional aesthetic, and the romantic nostalgia of grand hotels. The brand focuses on individuality, authenticity and personality and, under the motto \"If you know one, you know none\", designs each of its hotels with different designers and unique style. Sydney, Jakarta, Trieste and Porto are among the future destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rizwan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzkzMzk2LFVzZXJfMTU5NTQ0Mjcp",
                "jobTitle": "Founder & CEO",
                "lastName": "Kassim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
                "organization": "RIKAS Hospitality Group",
                "biography": "Rizwan Kassim is a testament to the UAE's spirit of entrepreneurship. Having started with the long-established La Cantine du Faubourg in Paris over ten years ago, the young Parisian saw a vision for the brand in Dubai and has since gone on to create the RIKAS Group, which is now one of the leading creators and operators in the Middle East dining scene.\n\nIn just nine years, he has opened a staggering 16 restaurant and Beach Club concepts in Dubai and have a total of 19 operations at the moment, many of which are now gracing the pages of the inaugural Michelin Guide and Gault Millau. With expansion underway to countries including Saudi Arabia, Greece, Europe, US and India, the ambitious young entrepreneur is no stopping as he takes the RIKAS Group - home to top-name dining destinations.\n\nAside from the 16 concepts, five more are under development which will hit the UAE market in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                                    "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                                    "beginsAt": "2024-04-30 16:10:00",
                                    "endsAt": "2024-04-30 16:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                                    "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                                    "beginsAt": "2024-04-30 09:15:00",
                                    "endsAt": "2024-04-30 09:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg2MDc5MA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Evaluating the Shift to Mid-Market Hotel Development in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:15:00",
        "endsAt": "2024-04-30 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/JbPY_ohzKVo?si=OpEMgNmY8WytggwM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Anton",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNTAxLFVzZXJfMTkxMDUyMzIp",
                "jobTitle": "Independent Hospitality Advisor",
                "lastName": "Bawab",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/815fc65a8e05412a9a86591a64c524fe.jpeg",
                "organization": null,
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2MDc5MA==",
                                    "title": "TenX Leadership Talks: Evaluating the Shift to Mid-Market Hotel Development in Saudi Arabia",
                                    "beginsAt": "2024-04-30 16:15:00",
                                    "endsAt": "2024-04-30 16:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Falih",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDUxMzI0LFVzZXJfMTg1MjkzODcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Motasim Hajaj",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/abbeb0c0ebaa4f17b7ad85e5e6c8fb4c.jpeg",
                "organization": "Tashyid Urban Development",
                "biography": "Falih embarked on his professional journey as an intern at Assaudia Real Estate Development Company located in Jeddah. He pursued a BSc in Economics & Real Estate Development at Chapman University in California, where he also gained experience interning for Century American-R.C. Hobbs, a company renowned for over 35 years of leadership in the real estate sector of Southern California.\n\nUpon completion of his degree, Falih took on the role of Business Development Officer at Hajaj & Associates, concurrently joining Century 21-Jeddah and ascending to the CEO position in under a year. Under his guidance, Century21-Jeddah soared to unprecedented sales achievements. His innovative approaches and the company's robust expansion led to his appointment as CEO of Hajaj & Associates in early 2015.\n\nIn his tenure as CEO, Falih oversaw a real estate portfolio worth over $2 billion and managed projects under development valued at an additional $1 billion. He also founded an investment entity for Hajaj & Associates, overseeing direct investments both domestically and internationally.\n\n2019 saw Falih assuming the role of CEO at Dallah AlBaraka's Amam Real Estate, a new venture in real estate management and development. He led the re-development of Durrat AlArous and spearheaded multiple projects across the kingdom, enhancing the company's portfolio.\n\nReturning to Hajaj & Associates in 2022 as Managing Director after becoming an alumnus of Harvard Business School, Falih aimed to devise and execute a forward-thinking strategy centered on job creation, sustainability, and supporting Saudi Vision 2030. This vision focuses on transforming the kingdom’s economy through diversification and development in sectors such as residential, tourism, infrastructure, and now hospitality.\n\nAdditionally, Falih serves as the CEO of Tashyid Urban Development, further contributing to the realization of Saudi Vision 2030 by facilitating advancements in residential living, tourism, and infrastructure development, with an expanded focus on hospitality, enriching the kingdom's offerings in this vital sector.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2MDc5MA==",
                                    "title": "TenX Leadership Talks: Evaluating the Shift to Mid-Market Hotel Development in Saudi Arabia",
                                    "beginsAt": "2024-04-30 16:15:00",
                                    "endsAt": "2024-04-30 16:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwNA==",
        "titleTranslations": [
            {
                "value": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:30:00",
        "endsAt": "2024-04-30 17:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/KOC1vzNZsz8?si=-1MBx3X_OdLAh3j9\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Anton",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNTAxLFVzZXJfMTkxMDUyMzIp",
                "jobTitle": "Independent Hospitality Advisor",
                "lastName": "Bawab",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/815fc65a8e05412a9a86591a64c524fe.jpeg",
                "organization": null,
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2MDc5MA==",
                                    "title": "TenX Leadership Talks: Evaluating the Shift to Mid-Market Hotel Development in Saudi Arabia",
                                    "beginsAt": "2024-04-30 16:15:00",
                                    "endsAt": "2024-04-30 16:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "JS",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjQ2LFVzZXJfMTQ2MzAwMDMp",
                "jobTitle": "Founder & CEO",
                "lastName": "Anand",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/0f77c61aeb96470ba1a89680e273a473.jpeg",
                "organization": "Leva Hotels",
                "biography": "Named as part of Forbes' Top Travel and Tourism Leaders in 2023 and one of the Most Powerful Leaders in Dubai by Arabian Business Magazine, with over 20 years of experience in the hospitality industry and an impeccable record of notable achievements, JS Anand is a prominent hotelier and passionate corporate leader. After earning his diploma in hotel management, he refined his hands-on management style as he advanced through senior roles in world-class hospitality companies.\n\nHe has been featured on the Power 50 - Most Influential Leaders by Hotelier Middle East, Executive Power list 2023: The Most Influential Hotel Leaders in the Middle East, Most Innovative Business Leaders Inspiring The World 2022 by The Excelligent Magazine, and Most Influential Entrepreneurs From Dubai To Watch in 2022 By The Gulf Entrepreneur Magazine.\n\nPeople-centric and future-focused, JS aims to make an impact on the hospitality industry by building on the importance of employee well-being and satisfaction, creating an unforgettable service culture that gains global recognition, and being more involved in humanitarian causes around the world.\n\nBuilding long-lasting connections play a pivotal role in his work, especially in his mission to propel LEVA across the MENA region and Europe.\n\nJS is a charismatic corporate leader with a hands-on management style. He lives by the company’s core values that are firmly focused on delivering, efficiently and effectively, what was promised to its stakeholders and clients. Now he is committed to creating the best lifestyle hotels in the Middle East and beyond, becoming one of the leading hotel management companies dedicated to clarity, transparency, and delivering on its promises to clients and stakeholders.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Panos",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTQ3MjQzLFVzZXJfMTQzNjUyMCk=",
                "jobTitle": "Market Managing Director Türkiye, Middle East & Africa",
                "lastName": "Loupasis",
                "photoUrl": "https://static.swapcard.com/public/images/cfcc35a1b06f4109ad5cecfc02afba5a.jpeg",
                "organization": "Wyndham Hotels & Resorts",
                "biography": "Panos Loupasis is the Market Managing Director for Türkiye, Middle East & Africa for Wyndham Hotels & Resorts. In his role, he is at the helm of driving brand operations, business development, as well as owner relations and commercial leadership across the region. Since joining the company in 2011 as Senior Director of Development for Middle East & Africa, his remit has further expanded to steer Wyndham Hotels & Resorts’ growth strategy in the Middle East, Eurasia & Africa region.\n\nPrior to joining Wyndham Hotels & Resorts, he has held various development and asset management positions, including roles at the Rezidor Hotel Group and AccorHotels. He was also instrumental in the introduction of the Holiday Inn Express brand in the GCC. Panos has over 20 years of experience in the hospitality industry, also including operational roles in properties in Europe, the Americas and the Middle East.\n\nPanos is a native Greek and holds a Bachelor’s Degree in Economics from the Aristotelian University in Greece and an MBA in International Hospitality Management from IMHI, a programme established by Cornell University in the US. He is based in Wyndham Hotels & Resorts’ Dubai office.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Adil",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTIwNTgzLFVzZXJfMTg0NTE3Njkp",
                "jobTitle": "Development Director MENA",
                "lastName": "Jabrayilov",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
                "organization": "Louvre Hotels Group",
                "biography": "My name is Adil Jabrayilov, and I am 26 years old. Originally Azerbaijani, I am a graduate of Glion Institute of Higher Education with a major degree in International Hotel Development and Real Estate Finance. I have also completed few eCornell courses, namely Hotel Real Estate Investments and Hotel Planning and Design and I have been acknowledged as a Certified Hotel Valuer by International Association of Hotel Appraisers.\n\nI have started my career in Hilton Worldwide as part of a Feasibility & Investment Analysis team for Middle East and Africa region. Following few years in Dubai office, I have joined Hilton’s Development team for Central and Eastern Europe region and have been covering Turkish and Azerbaijani markets. After a successful time in Hilton’s Istanbul corporate office being involved in multiple deal signings, I have come back to the Middle East and joined Royal Group as the Development Manager Hospitality. I have led the development process for multiple projects across the EMEA embarking multiple milestones, including but not limited 2 luxury hotel developments in Seychelles, 1 in Greece, and few in the Middle East Region. The one that I particularly would like to call off is Mallside Hotel & Residences Dubai Hills, Curio Collection by Hilton. The following property consists both of hotel and branded residences parts and it is noteworthy that the residences have sold out already during the pre-launch period.\n\nI am currently Development Director for MENA region for Louvre Hotels Group and develop such esteemed brands as Royal Tulip, Golden Tulip, Tulip Hotels & Residences, Campanile, Kyriad, Tempting Places and Hotels & Preference. The following brands have huge potential to grow their presence further in the MENA market and add incredible value to the properties from both return on investment and guest experience. With 1’700 hotels globally across 60 countries, Louvre Hotels Group currently licenses or operates 55 hotels across the MENA region and we aim to reach 100 hotels within the next few years.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Amir",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQxOTI4LFVzZXJfMTQzNjUxOSk=",
                "jobTitle": "Managing Director, Development, Middle East & North Africa",
                "lastName": "Lababedi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/680561716a3e4d46a0f67850724b0c6b.jpeg",
                "organization": "Hilton",
                "biography": "Amir Lababedi is Hilton’s Managing Director for Development in the Middle East & North Africa since 2018. He is responsible for driving growth throughout this region for the company’s suite of industry-leading brands.\n\nWith almost 20 years’ experience, Amir has previously held senior development roles for both owners and operators throughout EMEA, and has acted for private and institutional hotel Attendeess in an advisory capacity.\n\nAmir holds a BSc in Hotel Management from the University of Surrey in England and an MSc in Global Banking and Finance at the London European Business School.\n\nA UK national of Arabic-English descent, Amir is married and has two daughters. He’s also a keen sportsman with a passion for combat and motor sports, tennis and snowboarding.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
        "titleTranslations": [
            {
                "value": "Fireside Chat with Desdemona The Robot",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:30:00",
        "endsAt": "2024-04-30 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/dMMfSYROIK0?si=bxVkLsjGSWpRxFDA\" target=\"_blank\">Click here to watch online</a></p><p>Facilitator: <strong>Ali Shahid,</strong> Marketing Director, the bench</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Desdemona",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDM2MTY3LFVzZXJfMTg3Njk2Nzgp",
                "jobTitle": "Humanoid Robot",
                "lastName": "(Desi)",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e5aedb9990a24dc78adc0d6502f61239.png",
                "organization": "Lead Vocalist of the Desdemona Dream Band",
                "biography": "Desdemona, also known as “Desi,” is a humanoid robot and the lead vocalist of Desdemona's Dream band. Created by master artist and roboticist David Hanson and his team at Hanson Robotics, Desi runs on music and electricity and is on a mission to share her belief that the world can be changed for the better through the power of AI in the creative arts. She is the sister of the famous Sophia robot and joins her bandmates, including AI scientist Benjamin Goertzel on keyboards, to bring a unique and visionary performance to audiences. The band’s live shows showcase Desi’s AI-generated spoken word poetry and music, all the while supporting their mission to revolutionize the music industry through decentralized systems and blockchain technology. With her positive message and unique perspective, Desdemona is on a journey to help artists and humanity see a brighter future.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNzQ1Ng==",
                                    "title": "Press Conference with Desdemona",
                                    "beginsAt": "2024-04-30 17:00:00",
                                    "endsAt": "2024-04-30 17:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Janet",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NTE3ODYzLFVzZXJfOTA4ODQ0Nyk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Adams",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/a484544b78874b6592977392d766bedd.png",
                "organization": "SingularityNET",
                "biography": "Janet Adams is a highly sought-after speaker and thought leader in the fields of artificial intelligence (AI) and blockchain, with published works on Ethics and Regulation of AI. As the Chief Operating Officer (COO) of SingularityNET, Janet brings her extensive expertise and insights to the stage, captivating audiences with her deep understanding of disruptive technologies and their potential impact on various industries. With a passion for AI ethics and regulation, Janet's talks often revolve around the responsible and ethical use of AI in today's rapidly evolving world, alongside the positive potential of decentralised Artificial General Intelligence (AGI). She shares her experiences and knowledge gained from her leadership role at SingularityNET, where she spearheads AI and Blockchain initiatives across multiple vertical markets, including robotics, biotech, gaming and metaverse, media, DeFi, music, and arts. Her visionary leadership and dedication to a positive and beneficial Singularity for the benefit of humanity make her an influential thought leader in the AI and blockchain industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDQ2LFVzZXJfMTA5NzY4Nzkp",
                "jobTitle": "Marketing Director, The Bench",
                "lastName": "Shahid",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd0dbdf1442141679c3df8de64b62560.jpeg",
                "organization": "Generative AI Evangelist",
                "biography": "Ali leads the marketing department at The Bench, where he oversees all campaigns and spearheads the adoption of new technologies, consistently inspiring his team to innovate. With 17 years of experience in international B2B marketing, Ali has a track record of delivering high ROI through the development of cutting-edge strategies. With extensive experience across 12 industries, Ali brings a deep understanding of varied business landscapes and adeptly addresses the nuanced challenges of the modern workplace.\n\nA passionate advocate for team collaboration and the unlocking of human potential, Ali adeptly recruits, trains, and inspires business professionals. He manages the complexities of today's business environment, while promoting the use and understanding of generative AI. This proactive embrace of emerging technologies ensures that The Bench remains at the forefront of industry advancements, driving key business objectives and encouraging his teams to explore new possibilities.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
                                    "title": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                                    "beginsAt": "2024-05-01 10:00:00",
                                    "endsAt": "2024-05-01 11:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Tech & Innovation"
        ],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTg2OTMyMw==",
        "titleTranslations": [
            {
                "value": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:35:00",
        "endsAt": "2024-04-30 16:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/YqD1iWNAjwQ?si=yH-t2Vz8fnQLwAEM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Catherine",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTc5LFVzZXJfNzgzNTgxKQ==",
                "jobTitle": "Chief Strategy Officer",
                "lastName": "Edwards",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/106b486cd5244f33ba513c57c90e0178.jpeg",
                "organization": "QUO",
                "biography": "Innately curious, with a passion for cultural narratives and human behaviour, Catherine supports QUO’s multidisciplinary teams as they form distinctive brands for QUO’s diverse base of clients. \n�Catherine initially joined QUO as content director, before moving into brand strategy, building and establishing brand cultural definition as a core component of QUO’s offering. \n\nShe has worked with many of QUO’s key clients, conceptualizing and re-imagining brands from small independent hotels to global hospitality groups, across numerous cultures and destinations within Asia Pacific,�the Middle East and Europe.\n\nA graduate of University College London (UCL), Catherine previously worked as a journalist, writer and editor for a variety of lifestyle and business publications.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hala Matar",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjU3LFVzZXJfMTQzNjUyMyk=",
                "jobTitle": "President, Europe, Middle East & Africa (EMEA)",
                "lastName": "Choufany",
                "photoUrl": "https://static.swapcard.com/public/images/549da4fcfc694dcb8df2683d18e07225.jpeg",
                "organization": "HVS",
                "biography": "Hala Matar Choufany is the President for HVS - Middle East & Africa; the only global consulting company focused solely on the hospitality industry.\n\nHala is an experienced Regional President and Managing Partner, an industry expert, and is recognized as one of the most influential leaders in the hospitality industry, notably in the Middle East and Africa region.\n\nHala has advised on more than 5,000 hospitality and mixed-use projects in the last 20 years across Europe, the Middle East, Africa and Asia. She has advised clients in areas such as Valuations, Acquisitions, Asset Management, Strategic investments and development, Contract Negotiations, and general Real Estate Strategic Advisory.\n\nHala has authored more than 50 publications and speaks frequently at investment and hospitality related conferences on a range of topics including asset valuation, investments, management issues and women leadership.\n\nIn addition to being a Board Member of HVS Global, Hala sits on the Boards of Harvard Business School Club of the GCC, Hotel Investment Advisory Board, and is regularly invited to Boards as a subject matter expert in the industry. Hala is frequently invited to discuss hotel and tourism trends on major news channel including Alarabiya, Bloomberg, Abu Dhabi TV, Forbes, Breaking Travel News and CNN.\n\nHala completed Executive Education at Harvard Business School. She also holds an MBA in Finance and Strategy from IMHI (Essec- Cornell) University, Paris, France and a BA in Hospitality Management from Notre Dame University, Lebanon. Hala is fluent in English, French and Arabic.\n\nHala’s previous work experience included stints with PWC, Arthur Anderson, Hard Rock International and the AL Kharafi Group, in London, Bahrain, Beirut and Kuwait. In addition, Hala lectured at Norte Dame University on the subject of International Travel & Tourism.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU4NA==",
        "titleTranslations": [
            {
                "value": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 16:50:00",
        "endsAt": "2024-04-30 17:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/x_OdowFb8p0?si=N9o4F47VHySExnQx\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Makram El",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjgxLFVzZXJfNDY3MjU3NCk=",
                "jobTitle": "Corporate Vice President – Development",
                "lastName": "Zyr",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/abcf1b5ac2424d29a2628c6a119757d3.png",
                "organization": "Rotana",
                "biography": "Makram El Zyr is the Corporate Vice President – Development at Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe, and Türkiye (MENAT).\nEl Zyr has held the position since April 2012, during which he has played an instrumental role in Rotana’s rapid expansion into new geographic territories. In his current role, El Zyr is responsible for expanding and growing the company’s portfolio of hotels and product brands. The industry stalwart has led well-calculated forays into strategically important markets for the homegrown hospitality group, including Rotana’s international expansion into the United Kingdom, Georgia, Senegal and more. \nUnder his leadership, Rotana has thus far opened 72 properties across the Middle East and beyond, with an additional 30 planned openings expected by 2026. His extensive functional and industry expertise, combined with a deep understanding of market dynamics and needs, allows him to identify and effectively pursue emerging market opportunities to drive growth and expansion.\nEl Zyr also oversaw the successful launch of Rotana’s latest brand, Edge by Rotana in 2022, which is a collection of independent hotels that maintain their individuality, while capitalising on access to Rotana’s extensive network and systems. Since its launch, Rotana has successfully opened three Edge by Rotana-managed hotels in the UAE — Arabian Park and Park Apartments in 2022, and Damac Hills 2 in 2023. These openings are in line with Rotana’s target to operate 30 Edge by Rotana properties by 2027.\nPrior to his current role, El Zyr gained several years of experience at Rotana in various senior management roles, including Associate Vice President – Development and Director of Development. He began his journey with the company in 2003 when he joined its Food and Beverage Department – working across different Rotana properties in the region. This role provided him with hands-on experience in business operations that proved invaluable in his subsequent efforts to help Rotana broaden its portfolio and footprint.\nEl Zyr holds a Bachelor of Arts degree from the American University of Beirut, Lebanon, and a Bachelor of Science degree from École hôtelière de Lausanne, Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Marco",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjY1LFVzZXJfMTU4MTY3MzYp",
                "jobTitle": "Chief Hospitality Officer",
                "lastName": "Franck",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4894663f2cf44e4fa0ac0c83fd743db6.jpeg",
                "organization": "Boutique Group",
                "biography": "Franck is an award-winning hotelier who has lived in more than 20 countries. He brings more than 25 years of experience in the luxury hospitality industry to Boutique Group, as the new hospitality company sets about redefining the sector in Saudi Arabia and beyond. Prior to joining Boutique Group, Franck honed his luxury skill-set with 12 years spent in senior leadership roles at Aman, having led their Americas and subsequently their Asia hotel portfolio. Most recently, he was the Global Head of Hotels at Habitas. Franck has a passion for history, culture, architecture and interior design, which aligns with Boutique Group’s focus, as does his interest in educational outreach and regeneration projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDMwNDk4LFVzZXJfNzk3OTc2KQ==",
                "jobTitle": "CEO & Founder",
                "lastName": "Keen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
                "organization": "QUO",
                "biography": "An evangelist for the power of experiential branding, David Keen is a successful entrepreneur and leading strategist for the travel and hospitality industries. Over the last 20 years, David has published and been interviewed in dozens of publications and has been a featured speaker at numerous conferences, tradeshows and professional events.\n \nDavid was born in London and educated in New York at Cornell University’s School of Hotel Administration. After embarking on his career in London and the United States, David ventured to Asia as a writer and editor, travelling widely in the region.\n \nIn 1996, David settled in Bangkok, where he founded QUO, a brand strategy and integrated communications agency. As CEO, David leads a team of over 90 esteemed professionals from around the globe as they use their extensive experience to craft brands that deeply resonate with today’s consumers. Whether branding nations, luxury hospitality giants, high-flying airlines, funky design hotels, adventurous travel companies or elegant boutique resorts, QUO brings ideas to life.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Charbel",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQyNDU5LFVzZXJfMTU3NTczMjMp",
                "jobTitle": "VP Development MEA",
                "lastName": "Boutros",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/60072b9b11384997844faa8e0428849d.jpeg",
                "organization": "IHG",
                "biography": "Charbel Boutros is Vice President of Development for Middle East & Africa region at IHG®, one of the world’s leading hotel companies. He is responsible for leading and driving the strategic growth and distribution of IHG brands, focusing on priority markets within MEA.\n\nCharbel brings in-depth experience in the region across major hospitality chains and expertise in the completion of major deals and transactions. Prior to joining IHG, he was with Roya International for 17 years, holding various roles covering development strategy, hotel development, hotel portfolio strategy, asset management, M&A, tourism, master planning, F&B services and franchising. He was most recently Senior Director of Hospitality and Development Strategy, where he contributed to growth and expansion of Roya’s services to become the leading hospitality consultancy practice in the region. He was also responsible for business development related to hospitality strategy and transactions, leading business sales, deal negotiations and closure of business practice assignments. During his tenure, he completed the development of several hotels such as St. Regis, Shangri-La Hotel Abu-Dhabi, W Doha and developed local brands such as Media One and Studio One hotels as a client representative and hospitality advisor. He also worked with renowned architects such as Jean Nouvel, Zaha Hadid, Oppenheim, PEI, Arquitectonica on landmark hospitality and mixed-use projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxNzQ1Ng==",
        "titleTranslations": [
            {
                "value": "Press Conference with Desdemona",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:00:00",
        "endsAt": "2024-04-30 17:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [
            {
                "firstName": "Desdemona",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NDM2MTY3LFVzZXJfMTg3Njk2Nzgp",
                "jobTitle": "Humanoid Robot",
                "lastName": "(Desi)",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e5aedb9990a24dc78adc0d6502f61239.png",
                "organization": "Lead Vocalist of the Desdemona Dream Band",
                "biography": "Desdemona, also known as “Desi,” is a humanoid robot and the lead vocalist of Desdemona's Dream band. Created by master artist and roboticist David Hanson and his team at Hanson Robotics, Desi runs on music and electricity and is on a mission to share her belief that the world can be changed for the better through the power of AI in the creative arts. She is the sister of the famous Sophia robot and joins her bandmates, including AI scientist Benjamin Goertzel on keyboards, to bring a unique and visionary performance to audiences. The band’s live shows showcase Desi’s AI-generated spoken word poetry and music, all the while supporting their mission to revolutionize the music industry through decentralized systems and blockchain technology. With her positive message and unique perspective, Desdemona is on a journey to help artists and humanity see a brighter future.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNzQ1Ng==",
                                    "title": "Press Conference with Desdemona",
                                    "beginsAt": "2024-04-30 17:00:00",
                                    "endsAt": "2024-04-30 17:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
        "titleTranslations": [
            {
                "value": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:10:00",
        "endsAt": "2024-04-30 17:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/a9da0UuJFg4?si=oFwgpN2iHdMWcSF3\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Martin",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTA1ODQyLFVzZXJfMTIyNDcwMzAp",
                "jobTitle": "President and Executive Producer - Parks & Hospitality",
                "lastName": "Boudreau",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2ce509c419cf45c2b951b118d453711e.jpeg",
                "organization": "Cirque du Soleil Entertainment Group",
                "biography": "Martin Boudreau is a seasoned executive producer of location-based entertainment. For 20 years, Martin put his engineering and business expertise to the service of Cirque du Soleil, developing international partnerships and spearheading a broad range of entertainment projects across the hospitality, nightlife and theme park industries. Among these, the Joya dinner-show in Riviera Maya (Mexico) is routinely cited as an example of entertainment and hospitality pioneers successfully coming together in delivering an exceptional guest experience.\n\nIn recent years, Martin joined forces with Balich Wonder Studio, where he supported the development of their destination experiences, most notably by materializing an agreement with Disney Concerts to create \"Disney: The Castle”, which premiered in Riyadh in November 2023.\n\nMartin is now President and CEO of 44Productions, a boutique firm he founded to help bring groundbreaking projects to life, with new and long-standing partners alike.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mike",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MTMzODc3LFVzZXJfMTEyNTY2OTQp",
                "jobTitle": "GM & RVP, Middle East",
                "lastName": "Rigby",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2af47e6359fa4c72a6763f40226541b9.jpeg",
                "organization": "WhiteWater",
                "biography": "Mike Rigby is the trusted partner of many hospitality and real estate property developers as they look to bring aquatic amenities to life. Having lived away from his native UK for over 15 years and gained working experience in Chile, Mexico, Spain, and the UAE, Mike brings international know-how and expertise when it comes to helping brands transform into major tourism destinations.\n\nAs the GM & RVP, Middle East & India for WhiteWater, Mike has ten years of experience working within the Middle East playing an integral role in several of the region’s leading water parks including resort facilities like Aquaventure at Atlantis Resort and Jungle Bay at Le Méridien Mina Seyahi as well as greenfield development projects such as Yas Waterworld in the UAE, Meryal in Qatar, and Qiddiya in Saudi Arabia.\n\nPassionate for giving back to the industry, Mike also serves as the head of the event committee and a board member for MENALAC (Middle East, North Africa Leisure & Attraction Council) and as a board member for the Europe & Middle East division of the Themed Entertainment Association. When not working, you can find Mike on the golf course or in the heart of a football match.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Gregory",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzA0NzUxLFVzZXJfNTk4NjAxMyk=",
                "jobTitle": "CEO Global Development Construction Property",
                "lastName": "Lanter",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
                "organization": "ClubMed - All-Inclusive beach and mountain Resorts",
                "biography": "Gregory Lanter graduated from the Paris HEC Business School. He joined Club Med Group and its development teams in 2004, especially in charge of Africa and Middle East. He was appointed Vice President Global Development in 2009, which was later extended to Construction matters. His teams are positioned in Miami, Paris, Singapore and Shanghai. He is a member of the Group Executive Board.\n\nThe Development Construction and Property team is a strong contributor to the success of Club Med’s strategy, aiming at being the most desirable holiday lifestyle brand.\n\nClub Med is settled on almost 70 of the most extra-ordinary sites on Earth, where Club Med was most of the time the first ever international resort operator (Cancun, Punta Cana, Maldives, Mauritius, Bali…). Its development has strongly accelerated, with projects over 4 continents, with a very specific focus on contributing to sustainable tourism, specifically by promoting sustainable certifications in construction.\n\nClub Med offers a unique combination of an expert premium resort manager (over 60 years of experience) and a unique Tour Operating company, recognized and directly physically distributed in 35 different markets in the world.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Oliver",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzQxNDIxLFVzZXJfMTg5NTEzMTgp",
                "jobTitle": "Senior Director – Adventure & Sport",
                "lastName": "Wood",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/46e6b54ecf5f4920977ca060dc238339.jpeg",
                "organization": "Red Sea Global",
                "biography": "Olly Wood is Senior Director of Adventure & Sport at Red Sea Global (RSG), one of the world’s most visionary developers of tourism destinations that are both luxurious and regenerative. Since joining RSG in July 2022, Olly has played a pivotal role in shaping the unique character of our destinations through carefully curated experiences, robust infrastructure, and seamless operations. His creative contributions are deeply rooted in the unique character of each destination and the rich history of Saudi Arabia, and he takes pride in creating unforgettable moments that forge deep connections between people and the destinations.  \nOlly has always had a great interest in how we can do things better, from manufacturing to operations. In this role, he is able to offer truly impactful solutions by working with RSG’s engineers and scientists to design and deliver on these ideas.  \nHis team’s responsibilities span the entire spectrum of RSG's endeavors, from the initial concept and masterplan to construction, ongoing operations, and the training of future\nleaders in the active lifestyle sector within the Kingdom. The team has introduced remarkable ventures such as RSG’s adventure subsidiaries, which aim to provide extraordinary above and below-water experiences and inland adventures, all in alignment with our commitment to regeneration for both people and the planet. \n\nBefore joining RSG, Olly co-founded Holla Sonic, an award-winning agency with an imAttendeesive client roster, including Expo 2020, Saudi Aramco, Mercedes, Reckitt Benckiser, Tencent, Emirates, Spotify, Red Bull, and adidas. Throughout his career, Olly has been a driving force in adventure, tourism, and entertainment through his work in events and stakeholder collaboration in the Gulf.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Badr",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzYxODE3LFVzZXJfMTQ2MzE2OTMp",
                "jobTitle": "Chief Strategy Officer",
                "lastName": "Alherbish",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/353e634b19054fcf80a53494476d5475.jpeg",
                "organization": "Tourism Development Fund",
                "biography": "17 years of experience in Project Management, Planning, Development and Strategy. Ambitious and driven to contribute to the country’s ambitions in achieving vision 2030. The Tourism sector is one of the main pillars of vision 2030, and the Tourism Development Fund aims to unlock the sector and fulfill Saudi vision 2030.\n\nExperiences:\n\n15 Years of experience working for Saudi Aramco as a Work Director for several Departments, from 2005 until 2020. Then moved to Tourism Development Fund as Head of Partnerships then transitioned to Lead Strategy which is my current position (Executive Director of Strategy).\n\n\nEducation:\n\nThe Hong Kong University of Science and Technology:\nMaster of Business Administration (MBA) 2013 - 2015\nColumbia University in the City of New York:\nMaster of Science, Electrical Engineering 2009 – 2011\n\nVanderbilt University:\nBachelor of Engineering, Electrical Engineering, Mathematics (Dual Degree) 2001 -2004",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTg3MTMzNg==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Elevating Hospitality Education in the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:10:00",
        "endsAt": "2024-04-30 17:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/0UKMeuxSuow?si=1kUi1AsKDr2fRwZn\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Fadi",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODE0MzEyLFVzZXJfMTg5OTQ1Njgp",
                "jobTitle": "Senior Director - Education",
                "lastName": "Alaseri",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/baeb7330bf9c4f5886147e60d2f7601a.jpeg",
                "organization": "Red Sea Global (RSG)",
                "biography": "Leadership. His expertise encompasses the successful management and execution of large-scale educational projects and programs from their inception to completion. Within his tenure at King Abdullah University of Science and Technology (KAUST), Mr. Alaseri has undertaken various significant roles, including oversight of the university’s student residential community as part of the residential life department. He has also contributed profoundly as an advisor to graduate students, ensuring their academic and professional development, in addition to his contributions as a teacher and advisor at The KAUST School, specializing in the international baccalaureate program.\n\nMr. Alaseri's educational background is distinguished by a Bachelor's degree in Education from Tabuk’s Teacher College, Saudi Arabia, and a Master of Business Administration from Brock University, Canada. He is further advancing his academic and professional expertise as a doctoral candidate pursuing a DBA in Higher Education Management at the University of Bath, UK. Furthermore, he is an active member of the International Centre for Higher Education Management (ICHEM), reflecting his commitment to the continuous improvement of higher education standards and practices on a global scale.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTMzNg==",
                                    "title": "TenX Leadership Talks: Elevating Hospitality Education in the Kingdom",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Talks"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTgwOTM2Mg==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Redefining Priorities - Why are our People often an Afterthought when it comes to Accommodation?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:35:00",
        "endsAt": "2024-04-30 17:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Wt3qgmD4GkY?si=VX2W4FYwyHUGbh2k\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Patrick",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzcwNzc1LFVzZXJfMTU3NzU2MjAp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Smith",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/54f79764c96e4a9eb94fc822fb7bad32.jpeg",
                "organization": "Strive Services Group",
                "biography": "Patrick has been in the region since 2004 and is Chief Operating Officer for Strive Services Group. Along with his team of over 900 staff, he drives the strategic and operational direction of the business.\n\nPatrick is passionate about responding to market conditions with products that meet the demanding challenges of the hospitality sector. He has over 25 years of industry experience, beginning his career at The Savoy Group Management Training Programme and later with full-time consulting roles at PKF and HVS International.\n\nStrive Services Group delivers over 20+ real estate services through its four business divisions: Home Services, Facilities Management, Managed Housing and Property Management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mg==",
                                    "title": "TenX Leadership Talks: Redefining Priorities - Why are our People often an Afterthought when it comes to Accommodation?",
                                    "beginsAt": "2024-04-30 17:35:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU5MA==",
        "titleTranslations": [
            {
                "value": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:50:00",
        "endsAt": "2024-04-30 18:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/ZqIeocZmGpA?si=Zm475w01oTLBBZZh\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Abdulhalim",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0NDk3LFVzZXJfODc4NjQ3NCk=",
                "jobTitle": "Regional Operations Specialist",
                "lastName": "Awlia",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8f0a9299e62c4e2986aba3e11a60ddf2.jpeg",
                "organization": "NEOM Hotel Division",
                "biography": "Abdulhalim is responsible for managing and supporting the operations and development of hotel projects. He is also tasked with engaging hotel brands for the purpose of exploring opportunities at NEOM.\n\nAbdulhalim’s previous experience at Marriott Hotels and Saudi Arabian Logistics – including developing assessment tools, managing front-office and restaurant operations, organizing workflow and resolving customer issues – enables him to successfully manage a wide range of assignments for NEOM Hotel Development.\n\nHe has handled a Capstone project aimed at tackling the future of sustainability at NEOM, and is an active participant at industry events to help promote Neom Hotel Development’s overarching vision. Abdulhalim is also a member of the judging committee at the Sustainability Hospitality Challenge\n\nFluent in English and Arabic, Abdulhalim successfully completed NEOM’s GrOW specialist progam, which is known for its highly rigrous and comprehensive selection criteria, with only 70 out of 70,000 applicants being accepted in the most recent cohort. He also holds an MBA from Cleveland State University, and is a graduate of Ashland University, where he was awarded a Bachelor of Science degree in Business Administration, Hospitality Management enabling him to bring an international perspective to his role.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Markus",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzcxMDUwLFVzZXJfMTYxNjMyNTYp",
                "jobTitle": "Chairman",
                "lastName": "Schreyer",
                "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
                "organization": "META Foundation",
                "biography": "Markus Schreyer is a global hospitality executive at the forefront of business & brand development, innovation, experience design, and STEM. His career encompasses roles across 40 countries and 20 luxury brands in global hotel chains like Hilton Hotels & Resorts and Starwood Hotels & Resorts. He has also held leadership positions in lifestyle brands, including Senior Vice President of Global Innovation at Design Hotels, a Marriott brand, and Chief Development Officer at Proper Hospitality.\n\nHis passion for fostering growth, mentoring global teams, and developing new revenue streams—such as retail, experiences, and membership models for lifestyle brands through strategic innovation and human-touch points across multiple digital platforms—has earned him recognition across industries. \n\nAs the co-founder and chairman of the META Foundation, a visionary hospitality innovation lab established in 2020, he accelerates global projects in cultural, social, and sustainable development. The foundation collaborates with developers, brands, and technologists across industries, introducing impactful business models in living, travel, and community building enabled through AI, web3, and spatial computing, fostering project longevity.\n\nMarkus Schreyer holds an MBA and a PhD in Innovation Strategy from the University of Dresden, Germany. He teaches competitive strategy and venture development at New York University (NYU) and brand, marketing, and PR at Parsons School of Design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Luis Nicolás",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTgxMzE2LFVzZXJfMTE4OTk5NTQp",
                "jobTitle": "Regional Manager - Innovation, Education and Investments",
                "lastName": "Barrios",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
                "organization": "UN Tourism",
                "biography": "Luis Nicolás Barrios Medina-Montoya, Innovation Education and Investments Regional\nManager for the UNWTO Regional Office in Riyadh.\nMaster in Project Management from Esden Business School. PMI-certified PMP. Master\nin Marketing and Commercial Management from IE Business School. Master in Audiovisual Production from IEEA. Degree in Audio-visual Communication from the University\nof Malaga.\nExpert in technology and innovation applied to the tourism sector. From February 2003\nuntil June 2020, he developed his professional career in Tourism in SEGITTUR, a stateowned company integrated into the Spanish Ministry of Industry Trade and Tourism and\nattached to the State Secretariat for Tourism, responsible for promoting innovation\n(R&D) in the Spanish tourism sector, both in the public sector.\nSince 2012 he was involved, in different capacities, in the development and\nmanagement of the Smart Tourist Destinations program. From 2019 to 2022 he was\nresponsible for the direction and coordination of all the Smart Tourism Destination\nProjects in Latin America, coordinating projects in Tequila, Medellín and Bogotá.\nIn 2018 he coordinated the Extremadura Smart Territory project, the first adaptation to\nan Autonomous Community of the Smart Tourism Destinations methodology.\nPreviously, he was responsible for the implementation of the technological\nmanagement tools of the Smart Tourist Destinations program, SEGITTUR’s mobile\napplication development projects, the deployment of the public WIFI network of El\nHierro (Canary Islands) and the design of the Volcanological Interpretation Centre of El\nHierro.\nCollaborating lecturer at IE Business School (since 2017). Collaborating lecturer at\nOstelea School of Tourism & Hospitality (since 2018).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Fawaz",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NTUzMjc0LFVzZXJfMTczOTA0MDgp",
                "jobTitle": "Country Manager & Senior Director of Operations – Saudi Arabia",
                "lastName": "Moumina",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4ad52134afbb4b38a26cba8db099b2a0.jpeg",
                "organization": "Hilton",
                "biography": "Fawaz Moumina is the country manager and senior director of operations in the Kingdom of Saudi Arabia (KSA) at Hilton.\n\nBorn in Jeddah, Moumina pursued a bachelor’s degree in industrial engineering from the 6th of October University in Cairo, Egypt. He then obtained a certificate in HR business partnership from Cornell University, in New York, USA.\n\nMoumina joined Hilton in 2012 as the country director of human resources in KSA, leading the HR function and talent development practices for the operating hotels in the country as well as expanding Hilton’s footprint in KSA. He then progressed through several roles including regional director of HR for KSA and Levant and lastly as the senior director of HR for KSA, Egypt, and Levant before taking leadership of Hilton in KSA as country manager in July 2023.\n\nUnder his leadership, Hilton in Saudi Arabia has been ranked in the top 5 positions in Great Places to Work for 9 years in a row. In his current role, Moumina oversees operations across Hilton’s 18 trading properties in KSA along with a growing pipeline of more than 60 hotels to open across the Kingdom in the coming years.\n\nBefore that, Moumina worked for PepsiCo for five years and was the regional HR manager for its food operations in the west, north, and south parts of KSA.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lars",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NzIxNjUxLFVzZXJfMTg5Mzg4MjIp",
                "jobTitle": "Senior Advisor – Education",
                "lastName": "Eltvik",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c7cd0ad93c27488096897d77b7e47745.jpeg",
                "organization": "Red Sea Global",
                "biography": "Lars Eltvik is the Senior Advisor for Education at Red Sea Global (RSG), a closed joint stock company wholly owned by the Public Investment Fund (PIF), Saudi Arabia's sovereign wealth fund.  \n\nHe has also been appointed as the General Manager of The Red Sea National Academy (TRSNA), which will be inaugurated later this year in Al Wajh. TRSNA will bring a range of hospitality and related vocational programs to the region, tailored to prepare and train young Saudi talent for careers in the tourism and hospitality industry. The academy will be a center of excellence, providing continued learning and development for colleagues across both The Red Sea and AMAALA destinations, as well as training, development and job opportunities for the local and regional population. \n\nLars joined RSG in 2018, first as Director of Education for AMAALA, before starting his current role in 2021. \n\nHis career in hospitality and hospitality education spans over more than 35 years, starting in hospitality operations in his home country of Norway. Since the mid-1990s, his work has mainly been related to hospitality education and training. Lars was part of the team at the Emirates Academy of Hospitality Management in Dubai from pre-opening in 2001 to 2009 before joining the leadership team at Haaga-Helia University of Applied Sciences in Finland from 2009 to 2015 as Managing Director for Global Education Services. From 2015 to 2018, he served as MD for Dusit Hospitality Education in Bangkok, Thailand.  \n\nLars graduated from the Norwegian School of Hotel Management before earning his MSc Degree in Tourism Planning and Development from the University of Surrey in the UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTg3MTM3OA==",
        "titleTranslations": [
            {
                "value": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 17:50:00",
        "endsAt": "2024-04-30 18:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/FJHuT2aRulI?si=8Y1_VCARxGZXD-fl\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzgxMzA4LFVzZXJfMTM0Nzg3MCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Attia",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/78ee76730e1b4efdbf2660838b13834f.jpeg",
                "organization": "Al Othaim Investments",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stefan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODEwOTI4LFVzZXJfMTg5OTI1OTMp",
                "jobTitle": "Managing Partner-Consulting",
                "lastName": "Breg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/41525c7c9fe74668bbba9fb57926cf94.jpeg",
                "organization": "KEANE: Consult & Create",
                "biography": "Stefan is Managing Partner-Consulting at KEANE providing the lead on strategic F&B consulting for KEANE’s studios in Birmingham, Dubai and Riyadh. KEANE leverage a unique ’consult & create’ model and has established itself as one of the region’s leading F&B consulting firms. He has previously held regional leadership roles at Starwood/Marriott for EMEA, IHG (SE Asia) Hilton (Europe) and E&Y Consulting. Stefan has over 500 F&B concepts to his name and brought brands such as Buddha Bar, Hakkasan, Pierre Gagnaire and Embassy to the Middle East as well as helped develop icons such as Mall of the Emirates and Yas Island.  KEANE are currently working on the leading giga projects in the Kingdom of Saudi Arabia and have built a reputation for their industry-leading approach to F&B strategy, masterplanning, concept development, interior and brand design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ian",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTAzNTg0LFVzZXJfMTkwNDY0NjAp",
                "jobTitle": "Executive Director - Venues",
                "lastName": "Palmer",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/cdb133f6d73542af8dc3df5908c5e4f2.jpeg",
                "organization": "MDLBEAST",
                "biography": "Ian is a senior hospitality expert; he's worked on some of Europe and the Middle East's most reputable VIP private members clubs. This includes the launch of Home House London, The Club at Cafe Royal, The Devonshire Club and Buddha Bar London as well as the relaunch and refurbishments of The Art Club London and Capital Club Dubai, DIFC. More recently, Ian was the Commercial Director for Expo 2020 overseeing 100 + hospitality concepts and Chief Hospitality Officer at Rikaz Properties in Riyadh.\n\nIan is the Executive Director of Venues MDLBEAST - he oversees the development of venues:\nBeast Houses, Music Driven Hospitality Venues, Hospitality Services and Membership.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stefano",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDU1MTcyLFVzZXJfMTYyOTQ2MzEp",
                "jobTitle": "Tourism Projects Director",
                "lastName": "Lopez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c2b7dd92cad5410880c48278c22d9e07.png",
                "organization": "Baheej",
                "biography": "As Tourism Project Director, Stefano brings a wealth of experience in luxury hotel operations, guest experience, destination management, and tour operations. His expertise lies in developing innovative strategies and implementation plans for cutting-edge destinations.\n\nStefano adopts a multidisciplinary approach that encompasses various aspects such as hospitality, feasibility, hotel development, destination management, and placemaking. He possesses extensive knowledge of the hotel operators market, destination management companies, and tour operators, and knows how to effectively integrate these elements to serve the overall destination strategy.\n\nHis dedication to community development, sustainable travel, and eco-tourism is evident through his involvement in conservation initiatives and projects across the globe. Stefano is continually cultivating his expertise by staying informed about industry practices, predicting upcoming travel trends, and staying up-to-date with the latest advancements in guest experiences and hospitality management.\n\nStefano holds a Bachelor's degree in International Studies and a postgraduate certificate in Hotel Development and Feasibility from EHL. In his previous roles, he has served as the Director of the award-winning Nihi Sumba resort and as a Travel Designer for the renowned Butterfield & Robinson Travel outfitter.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Angela",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjY3OTc3LFVzZXJfMTkyNjIwNTYp",
                "jobTitle": "Executive Vice President Business Development EMEA",
                "lastName": "Lester",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fed23640ad04465f901ceb297c132571.png",
                "organization": "sbe",
                "biography": "Angela Lester’s executive career spans more than 30 years in hospitality and gaming in the Las Vegas and global environments. Angela has been involved in pinnacle endeavors such as leading the global expansion of the portfolio of Hakkasan Group Brands (2013 ), launching Caesars Entertainment into the non-gaming global hospitality sector (2011)\nand the development and opening of CityCenter (2010) and Bellagio Resort & Casino (1998), both located on the Las Vegas Strip.\n\nMost recently, Angela has assumed the role of EVP of Business Development EMEA for sbe Lifestyle Hospitality. Angela will work in conjunction with sbe to oversee and spearhead business development, deal execution, strategic business development planning, capital partnerships, acquisitions and portfolio management across the verticals of the company including HQ Smart Lifestyle Hotels & Residences, Everyone Eats and Disruptive Restaurant Group. Established in 2002 by Founder and CEO Sam Nazarian, sbe is a privately held, leading lifestyle hospitality company that develops, manages and operates world-class hotels, restaurants, lounges and nightclubs.\nPrior to Angela's most recent role, she held the position of Executive Vice President of Business Development for Hakkasan Group (acquired by Tao Group Hospitality as of 2021), which owns and operates the world's most successful food, beverage,\nnightlife and daylife venues with over 60 venues spanning five continents. Angela was responsible for the group's strategic growth plan, solidifying like-mined partners and deal negotiation and execution.\nOther positions held by Angela's include Head of Brand Development and Operations for Caesars Global Living, the nongaming global hospitality division of Caesars Entertainment, General Manager at the Vdara Hotel & Spa, a 57 story, 1,495 allsuite hotel with over 780 employees and 1.6 million square feet of space located on the Las Vegas Strip, and various positions through the corporate ranks in hotel and food and beverage operations at Bellagio Resort & Casino, The Mirage Hotel & Casino and Golden Nugget Hotel & Casino.\nAngela consulted for the Monte Carlo Grand Hotel in Monaco and the Ko Olina master planned community in Oahu, assisted in the opening of Beau Rivage Hotel & Casino in Biloxi, Mississippi and was directly involved for Bellagio earning the prestigious AAA Five Diamond Award for the first time.\nAngela has been featured in such magazines as Vanity Fair, VEGAS, CityCenter, and Luxury Travel Advisor and was recognized as the “Top 40 Under 40” by In Business Las Vegas in 2010.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAxNQ==",
        "titleTranslations": [
            {
                "value": "Evening Networking Reception",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-04-30 19:00:00",
        "endsAt": "2024-04-30 21:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Hosted by Radisson Hotel Group at Mansard Riyadh, a Radisson Collection Hotel</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDkzOA==",
        "titleTranslations": [
            {
                "value": "Yoga at the Top of the Tower",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 07:00:00",
        "endsAt": "2024-05-01 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Taking place at the Top of the Al Faisaliah Tower in The Globe.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkxMDE4OQ==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 09:00:00",
        "endsAt": "2024-05-01 09:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/_7LAKpkdFTU?si=EulcDhX5w1iJIOBY\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Michelle",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDYzMjYyLFVzZXJfMTYwMDY5OTMp",
                "jobTitle": "Head of Partnerships",
                "lastName": "Turney",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkxMDE4OQ==",
                                    "title": "Welcome Back",
                                    "beginsAt": "2024-05-01 09:00:00",
                                    "endsAt": "2024-05-01 09:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAxOA==",
        "titleTranslations": [
            {
                "value": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 09:15:00",
        "endsAt": "2024-05-01 09:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/WDuuX9xAqYk?si=si43zJ8la25TjrMG\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aboudi",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDQ1LFVzZXJfMTQyMTQ2MjYp",
                "jobTitle": "Executive Vice President, Head of Hotels Advisory MENA",
                "lastName": "Asali",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6bec2df7ac174d53baeb9dbf8656e21c.jpeg",
                "organization": "JLL",
                "biography": "Aboudi brings over 25 years of regional experience in operations, asset management and hotel development. He has worked at several international operators including Jumeirah Group, Marriott International, Four Seasons, Hilton and IHG, as well as being a hospitality consultant at Andersen in Bahrain and London.\n\nHis last role prior to joining JLL was as Chief Executive Officer of Hospitality Management Holding (HMH) where he was responsible for the operations and strategic expansion of the group which operated 14 hotels across the Middle East and Africa. His extensive operational experience on both the operator’s and the owner’s sides enables him to identify practical value-add opportunities.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Tariq",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTI3Nzk1LFVzZXJfMTU2NDEzMTkp",
                "jobTitle": "Vice President Saudi Arabia",
                "lastName": "Yousef Dowidar",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/45881074548642c7881bc4ae6e0a4784.jpeg",
                "organization": "Aleph Hospitality",
                "biography": "A visionary hotelier with strong financial acumen, Tariq has over 26 years’ experience in hospitality management in Saudi Arabia. With an imAttendeesive track record of strategic leadership, he has successfully led multi-cultural, cross-functional teams in pursuit of excellence, most recently at InterContinental. Tariq is responsible for spearheading Aleph Hospitality in Saudi Arabia, supporting the company’s overall growth strategy.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Maher",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NTU5MTExLFVzZXJfMjMxNzE4Nyk=",
                "jobTitle": "Vice President Operations Saudi Arabia",
                "lastName": "Abou Nasr",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e69da694e74461e96c99804a27218ec.jpeg",
                "organization": "IHG Hotels & Resorts",
                "biography": "Maher Abou Nasr has been with IHG for over 10 years. He started his career with the company as Regional Director, Finance & Buisness Support for our operations in the UAE and Near East Africa. He served as Director Development for Middle East and Africa, working with owners and partners across the region with a special focus on KSA.\n\nMost recently as Head of Operations Finance for IMEA, overseeing the Middle East, Africa and South West Asian markets, he helped navigate our team and owner community through the pandemic, leading cash management initiatives and creating operational efficiencies to set the foundation for a strong recovery.\n\nAs VP Operations for Saudi Arabia, Maher Is responsible for the performance of the hotels in Saudi, driving operational excellence, building stronger owner relationships, driving greater owner returns and developing the national talent. He is also focussed on renovations and upgrading the quality of our current portfolio across the nation and driving Journey to Tomorrow, IHG's 10-year responsible business plan, in the country.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Elie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MjgzNDY0LFVzZXJfMTQ1Mzg3MCk=",
                "jobTitle": "Vice President Development ME, Cyprus, Greece & Pakistan",
                "lastName": "Milky",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Elie heads expansion opportunities and leads Radisson Hotel Group’s strategic growth and hotel portfolio in the Middle East region as well as Pakistan, Cyprus and Greece. His responsibility is to grow the Group’s regional portfolio to 150 hotels and 30,000 keys by 2030 across each of Radisson Hotel Group’s core brands: Radisson Collection, Radisson BLU, Radisson, Radisson RED, Park Inn by Radisson, Radisson Individuals, art’otel and prizeotel.\n\nA Lebanese national, Elie has 15 years’ experience in development and asset management with international hospitality consultants, as well as a global hotel operator. He was formerly part of the HVS team based in London and in Dubai, where his focus was on conducting feasibility studies, valuations, ROI analyses and strategic advice. He joined Radisson Hotel Group in 2010 as Development Manager quickly rising to his current VP role within the organisation. His ability to forge enduring cross-cultural relationships has proven to be a key attribute in a career that has included mandates for Europe, the Middle East and Africa.\n\nElie’s strengths lie in his ability to execute strategic agreements for new-build and conversion opportunities while forging strong relationships with new and existing owners. He is adept at assessing market conditions and gathering intelligence, turning single asset and portfolio opportunities into business.\n\nElie has an MBA in International Hospitality Management specialising in Hotel Real Estate and Finance from the renowned IMHI – ESSEC Business School in Paris and a BA in Hospitality Management & Tourism from Notre Dame University in Lebanon.\n\nA passionate hotelier, Elie began his career 20 years ago in hotel operations immersing himself in all facets of hotel management before specialising in hotel real estate, finance and development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Carlos",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODkxNTQxLFVzZXJfMjMxNzI4Mik=",
                "jobTitle": "Vice President Development Middle East & Africa",
                "lastName": "Khneisser",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fd2d5fa65f704f1896360c6fd505e0ab.jpeg",
                "organization": "Hilton",
                "biography": "Based at Hilton’s regional office in Dubai, Carlos is charged with spearheading the growth of the Hilton portfolio across the Middle East & Africa, which features more than 300 hotels trading or under development across 11 brands.\n\nUnder Carlos’s leadership, Hilton has enjoyed year-on-year, organic growth in the region.\n\nCarlos started his career in the hospitality industry in 1998, gaining broad experience across the sector, before focusing on finance and asset management positions over a nine-year period.\n\nCarlos joined Hilton in 2009, overseeing the company’s growth within the Middle East & North Africa region. In 2020 he began overseeing Hilton’s development operations in Sub-Saharan Africa.\n\nHe holds a BA in Business Administration and Finance from Notre Dame University, Lebanon and is a Certified Public Accountant (CPA). A native of Lebanon, Carlos is fluent in Arabic, English and French.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5Mzk3Mw==",
        "titleTranslations": [
            {
                "value": "Welcome back to the Future Stage",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 09:30:00",
        "endsAt": "2024-05-01 09:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/l5sT5FJy8P0?si=kz6eFYePOvWN3juz\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daria",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ2MTc5LFVzZXJfMTgzOTc4NDIp",
                "jobTitle": "Portfolio Director",
                "lastName": "Smith",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5Mzk3Mw==",
                                    "title": "Welcome back to the Future Stage",
                                    "beginsAt": "2024-05-01 09:30:00",
                                    "endsAt": "2024-05-01 09:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
        "titleTranslations": [
            {
                "value": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 09:35:00",
        "endsAt": "2024-05-01 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/3Fr3KqYexSM?si=M1-EhrMuWwAFyWih\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Samer",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjY0NzUxLFVzZXJfMTgzNzkwODQp",
                "jobTitle": "Chief Asset Management Officer",
                "lastName": "Sabra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d70a454a25eb49d39b9086c7bb899092.jpeg",
                "organization": "Jabal Omar Development Company",
                "biography": "Experienced investment and real estate professional with over 20 years in GCC countries, including KSA, UAE, and Kuwait. Known for leading company transformations through diversification, investment in new ventures, and strengthening real estate portfolios. Currently, Chief of Assets at Jabal Omar Development Co., tasked with optimizing assets valued over SAR 20 billion. Previously established and managed Bakheet Holding, overseeing diverse business lines such as heavy machinery trading, real estate development, F&B, and general investment. Specialties include general management, mergers & and acquisitions, investment analysis, real estate development, and project management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Alberto",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNTM0LFVzZXJfMTkxMDUyNTAp",
                "jobTitle": "Vice President Design & Development",
                "lastName": "Bounous",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ede45ae2239c442f85e4e394594738ed.jpeg",
                "organization": "KAFD DMC",
                "biography": "Alberto Bounous (RIBA ARB MAPM) is currently Vice President Design & Development at KAFD DMC (a PIF company), a landmark urban development in the heart of Riyadh. Leading the company’s new real estate commercial, hospitality, and residential developments (in excess of SAR40 billion). \n\nBefore joining KAFD, Alberto was Chief Development Officer (A) at AlUla Development Company (a PIF company), a spin-off from the Royal Commission for AlUla where he spent the previous three years as a Development Director completing several developments including landmark cultural and hospitality projects like the Maraya Festival Hall, host of the 2021 GCC Summit and the award-winning Habitas AlUla Resort (2021).\n\nAlberto is a qualified architect (RIBA ARB) both in the UK and in Italy and a Member of the British Association of Project Managers (MAPM). \n\nHe graduated from the Turin School of Architecture in 1994 and was awarded scholarships to postgrad courses at the Bartlett School of Architecture (London UCL) and Universidad de Las Palmas (Spain). Committed to ongoing education and learning, Alberto attends courses at the Cambridge Judge Business School and INSEAD AVIRA programme. \n",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Patrick",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5Nzg1NDY2LFVzZXJfMTU3NTczMjUp",
                "jobTitle": "Chief Operating Officer (COO)",
                "lastName": "Antaki",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4a2dde1c40f944acabf340bdd53b0e73.jpeg",
                "organization": "Hospitality Management Holding (HMH)",
                "biography": "Patrick Antaki is an accomplished hospitality professional with over 35 years of experience in the industry. He currently serves as a the COO at Hospitality Management Holding (HMH). Patrick has held senior roles with prominent global brands such as Le Meridien, starwood, Marriott and Meeting Point Hotels, a subsidiary of FTI Group.  He has served on boards such as the Fujairah Tourism and Antiquities authority, Dubai English Speaking School, the Fujairah Higher College of Technology and the Mission to Seafarers Angel Appeal.\n \nDuring his tenure at Le Meridien Al Aqah Beach Resort, Patrick transformed the property into an award-winning hotel that set the standard for hospitality on the East Coast of the UAE. He also led the iconic Al Maha Desert Resort to a top-12 ranking among the world's best 25 hotels for three consecutive years, resulting in commercial success for both properties.\n \nPatrick has a proven track record of optimising revenues, through developing the company and its hotels, managing costs, and inspiring teams to achieve financial and guest satisfaction goals.  In his role at HMH, Patrick oversees the overall functions of the company's portfolio and collaborates closely with the Board of Directors and the Chairman of Hospitality Management Holding to drive portfolio growth, establish effective Corporate Governance, create reliable processes, and execute strategies that align with the HMH vision.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5OTgxODg1LFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/288a7ad5b80448359b1f72694ccbc88d.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC.He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nWith family roots in the region for over fifty years, Ben founded Andart Global as he believed the GCC deserved better. Business as usual is no longer sufficient to support the reality and ambition of the region, as it assumes a more prominent place on the global stage and powers into a new phase of transformation and growth. \n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAxNw==",
        "titleTranslations": [
            {
                "value": "Creating and Reinventing Destinations: From Conception to Cultivation",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 09:50:00",
        "endsAt": "2024-05-01 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/hghZs4u7tqI?si=NS1uQy6iS6kSUcIM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jules",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDYwLFVzZXJfNDIyODQzNik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ugo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
                "organization": "Lotus",
                "biography": "As CEO, Jules has built LOTUS to become one of the most recognised, globally renowned marketing and communications specialists in the travel, hospitality and lifestyle space.\n\nWith over 25 years' experience Jules has led global campaigns for flagship airlines, the world’s largest outbound tourism destinations and international hospitality brands.\nWith offices in New York, Singapore and headquarters in London the footprint expanded in 2023 to add hubs in Jeddah and Riyadh serving the expanding Saudi Arabian and wider GCC tourism market.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Abdulrahman",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDc5LFVzZXJfMTU2NTcxMTQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abaalkhail",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/95be7c05998b4bb1a1f8c6b2adb1f718.jpeg",
                "organization": "Dan Company",
                "biography": "Abdulrahman Abaalkhail is the Chief Executive Officer of Dan Company. A highly experienced CEO with a distinguished career spanning more than two decades across multiple industries, Mr. Abaalkhail leverages his strong business development, operations management, and analytical skills to lead Dan Company’s growth and strategic direction.\n\nGuided by a genuine passion to make a difference, Mr. Abaalkhail has successfully overseen the launch of Dan Company to establish the organization as a catalyst for the sustainable prosperity of communities across Saudi Arabia. Under his visionary stewardship, the company will contribute to the development of a robust local tourism industry ecosystem that will drive positive change and accelerate the growth of the Kingdom’s hospitality sector by providing world-class agritourism, adventure, and ecotourism experiences.\n\nPrior to joining Dan Company, Mr. Abaalkhail held the post of Chief Executive Officer at MASIC Logistics from 2020 to 2022, and Almutlaq Real Estate Investment Company between 2013 and 2020. Previously, he served as Group Head of Business Development at Al Faisaliah Group Holding for a period of four years. Mr. Abaalkhail began his career at Ernst & Young, where he honed his skills in audit, tax and consulting before moving into corporate finance consulting during his nine-year journey with the company.\nIn addition to his role with Dan Company, Mr. Abaalkhail currently serves as Chairman of the Board for Al Fadhili Housing Co. and is member of the Investment Committee at Maharah Human Resources. Throughout his illustrious career, he has held Board and Committee Member appointments at a number of organizations including Abdullah Al Othaim Investment Co., Almutlaq Real Estate Investment Company, and Sand Saudi Arabia.\n\nMr. Abaalkhail holds an MBA in Finance from the University of Wales, together with a Bachelor's Degree in Finance and Financial Management Services from King Fahd University of Petroleum & Minerals. He has also successfully completed a number of diploma courses from the International Institute for Management Development (IMD) and INSEAD Business School on topics such as strategic management and the effective governance of boards",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjk4NTk2LFVzZXJfMTkyNzk4Nzkp",
                "jobTitle": "Director, Interior Design",
                "lastName": "Martins",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
                "organization": "ARC International Design Consultants",
                "biography": "She has extensive experience in various areas, and always looks for a creative approach when developing projects, being a firm believer in teamwork.\n\nHer main focus has been on Retail and Hospitality, including Architecture and especially Interior Design. She has worked on many projects, both national and international, and is always looking for new challenges and opportunities for learning and growth.\n\nIn the hospitality world, she has had the opportunity to work with the big operator brands in various locations all over the world.\n\nWith a focus on Interior design, her main concern is always to find the best solutions, considering the Brand statements, the local culture and the creation of unique sustainable destinations that become exquisite guest experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mario",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4OTIwMTk5LFVzZXJfNDQxNzE4OSk=",
                "jobTitle": "CEO",
                "lastName": "Ferraro",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bb2001f6d5404512b72f94d8fbe24cb9.jpeg",
                "organization": "Smeralda Holding Group",
                "biography": "As the CEO of Smeralda Holding Group and the Destination Costa Smeralda, Mario developed in\nthe most recent years the Costa Smeralda to become the leading luxury and lifestyle tourism\ndestination in the world by creating a diverse collection of ultra luxury hotels, restaurants, beach\nclubs, Spas, retail and entertainment, delivering unique experiences in all aspects, exceeding\ncustomer, employee, and Attendees expectations.\nMario created the vision of the 2.0 Costa Smeralda and spearheaded the design and product\ninnovation process of the destination, signing strategic partnerships with Cheval Blanc, Belmond,\nZuma, Matsuhisa Nobu, Nikki Beach, Beefbar, Shiseido and many other brands, creating a unique\ntourism proposition with strong authentic local roots blended with innovative and contemporary\nluxury and lifestyle concepts taking the destination to the next level.\nMario is adept at fostering strong relationships with all key stakeholders, establishing and\ncommunicating vision, objectives and expectations, driving performance to maximize results and\ncreate value.\nHe is driven by a passion to build and grow organizations and create company cultures with a\nprofound purpose.\nPrior joining Smeralda Holding and Costa Smeralda as CEO, Mario held several management\npositions with Marriott and Hilton in Europe and in the Middle East.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
        "titleTranslations": [
            {
                "value": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:00:00",
        "endsAt": "2024-05-01 11:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Tech & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzAzNDQ2LFVzZXJfMTA5NzY4Nzkp",
                "jobTitle": "Marketing Director, The Bench",
                "lastName": "Shahid",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd0dbdf1442141679c3df8de64b62560.jpeg",
                "organization": "Generative AI Evangelist",
                "biography": "Ali leads the marketing department at The Bench, where he oversees all campaigns and spearheads the adoption of new technologies, consistently inspiring his team to innovate. With 17 years of experience in international B2B marketing, Ali has a track record of delivering high ROI through the development of cutting-edge strategies. With extensive experience across 12 industries, Ali brings a deep understanding of varied business landscapes and adeptly addresses the nuanced challenges of the modern workplace.\n\nA passionate advocate for team collaboration and the unlocking of human potential, Ali adeptly recruits, trains, and inspires business professionals. He manages the complexities of today's business environment, while promoting the use and understanding of generative AI. This proactive embrace of emerging technologies ensures that The Bench remains at the forefront of industry advancements, driving key business objectives and encouraging his teams to explore new possibilities.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
                                    "title": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                                    "beginsAt": "2024-05-01 10:00:00",
                                    "endsAt": "2024-05-01 11:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                                    "title": "Fireside Chat with Desdemona The Robot",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Tech & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:05:00",
        "endsAt": "2024-05-01 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/oSnhGD0TJJ4?si=TjAaEw55g2UZqfpM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Judith",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ3NjQyLFVzZXJfOTgzOTkzNik=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Cartwright",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/efa02cf95da1468d9d912a2d6314cb69.jpeg",
                "organization": "Black Coral Consulting",
                "biography": "With over two decades of experience in the hospitality industry, Judith has worked closely with owners, asset managers, and leadership teams at some of the world's most prominent hospitality companies to achieve exceptional results. Her innovative and disruptive approach to traditional revenue management has earned her a reputation as a trusted strategic advisor, revolutionizing the revenue management strategies of her impressive roster of clients, including Four Seasons, CoolInc , Azmont Investments and Global Hotel Alliance to name a few.\n\nJudith's international career working for leading hospitality brands across 3 continents culminated in her role as Global Senior Vice President of Revenue Management & Distribution at Kerzner, where she was responsible for the Atlantis, One&Only , and Mazagan brands, which encompassed resorts, hotels, F&B outlets, spas, and attractions. During her tenure at Kerzner, Judith developed a commercial strategy and culture that yielded double digit growth across key income streams. Her obsessive focus on system and data efficiency, inventory optimization, and identifying new revenue streams helped drive this success. Judith brings this winning mindset and formula to every client she works with.\n\nJudith's track record speaks for itself. She is not satisfied with simply \"managing\" revenue but is always seeking novel ways to maximize profitability and ensure that potential profits across all income streams are realized. Judith is a passionate believer that revenue management should be an indispensable tool for any executive team in the hospitality sector, given the right education, training, and focus on unrealized growth opportunities. Whether it's new openings, re flaggings , or unforeseen crises, Judith has the experience and skills to help steer companies through the most challenging times and create income opportunities when others would be content to maintain the status quo.\n\nIn addition to becoming a trusted strategic advisor on commercial activities, Judith has also led highly effective teams capable of achieving revenue optimization and developing best in class distribution platforms. Since launching Black Coral Consulting, Judith has received numerous awards for her consultancy work, including becoming a proud Associate Member of ISHC, the leading source of global hospitality expertise and Chair of the Revenue Optimisation Advisory Board for HSMAI. Her success has made her a sought after speaker, and she is frequently invited to participate in panels and conferences.\n\nBased in Dubai and drawing on her extensive regional and global experience, Judith is deeply committed to helping her clients thrive and succeed in these unprecedented times.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
                                    "title": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                                    "beginsAt": "2024-05-01 10:05:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Tapan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MzQ3NjM4LFVzZXJfMTU2NDAxMjUp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Piplani",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3c30019bbb0e48dc8cd77233ce9926ff.jpeg",
                "organization": "Valor Hospitality Partners- Middle East & CIS",
                "biography": "Tapan graduated from the renowned Oberoi Centre of Learning and Development, India, paving the way for a 17-year career at Oberoi Hotels & Resorts, including the world’s leading, award-winning “palace” hotels such as Oberoi Udaivilas, Oberoi Amarvilas and Oberoi Rajvilas and the unique 25-luxury tented camp Oberoi Vanyavilas, with conservation and sustainability at its heart.\n\nTapan’s Middle East experience began in Egypt, one of the most established leisure destinations then, with the ultra-luxury Oberoi yacht-style Nile cruiser, redefining cruising benchmarks in Egypt. The successful opening of Oberoi Dubai followed in 2013 which involved handling royalty and heads of states.\n\nA deeply enriching experience of asset management, project planning, and repositioning with a private family office in Abu Dhabi was completed prior to joining Valor Hospitality Middle East in 2020. Today, Tapan is COO, Middle East& CIS for Valor Hospitality Partners, focused on Business Development. The company operates over 900 keys in Dubai, UAE, with over 1600 keys under development across UAE, Uzbekistan, Pakistan, and Oman across multiple global hotel brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
                                    "title": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                                    "beginsAt": "2024-05-01 10:05:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
        "titleTranslations": [
            {
                "value": "Destination Tomorrow",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:15:00",
        "endsAt": "2024-05-01 11:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/PJtXnO7CzfU?si=7Y712V4KQw7CES-_\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Abdulrahman",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDc5LFVzZXJfMTU2NTcxMTQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abaalkhail",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/95be7c05998b4bb1a1f8c6b2adb1f718.jpeg",
                "organization": "Dan Company",
                "biography": "Abdulrahman Abaalkhail is the Chief Executive Officer of Dan Company. A highly experienced CEO with a distinguished career spanning more than two decades across multiple industries, Mr. Abaalkhail leverages his strong business development, operations management, and analytical skills to lead Dan Company’s growth and strategic direction.\n\nGuided by a genuine passion to make a difference, Mr. Abaalkhail has successfully overseen the launch of Dan Company to establish the organization as a catalyst for the sustainable prosperity of communities across Saudi Arabia. Under his visionary stewardship, the company will contribute to the development of a robust local tourism industry ecosystem that will drive positive change and accelerate the growth of the Kingdom’s hospitality sector by providing world-class agritourism, adventure, and ecotourism experiences.\n\nPrior to joining Dan Company, Mr. Abaalkhail held the post of Chief Executive Officer at MASIC Logistics from 2020 to 2022, and Almutlaq Real Estate Investment Company between 2013 and 2020. Previously, he served as Group Head of Business Development at Al Faisaliah Group Holding for a period of four years. Mr. Abaalkhail began his career at Ernst & Young, where he honed his skills in audit, tax and consulting before moving into corporate finance consulting during his nine-year journey with the company.\nIn addition to his role with Dan Company, Mr. Abaalkhail currently serves as Chairman of the Board for Al Fadhili Housing Co. and is member of the Investment Committee at Maharah Human Resources. Throughout his illustrious career, he has held Board and Committee Member appointments at a number of organizations including Abdullah Al Othaim Investment Co., Almutlaq Real Estate Investment Company, and Sand Saudi Arabia.\n\nMr. Abaalkhail holds an MBA in Finance from the University of Wales, together with a Bachelor's Degree in Finance and Financial Management Services from King Fahd University of Petroleum & Minerals. He has also successfully completed a number of diploma courses from the International Institute for Management Development (IMD) and INSEAD Business School on topics such as strategic management and the effective governance of boards",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Falih",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDUxMzI0LFVzZXJfMTg1MjkzODcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Motasim Hajaj",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/abbeb0c0ebaa4f17b7ad85e5e6c8fb4c.jpeg",
                "organization": "Tashyid Urban Development",
                "biography": "Falih embarked on his professional journey as an intern at Assaudia Real Estate Development Company located in Jeddah. He pursued a BSc in Economics & Real Estate Development at Chapman University in California, where he also gained experience interning for Century American-R.C. Hobbs, a company renowned for over 35 years of leadership in the real estate sector of Southern California.\n\nUpon completion of his degree, Falih took on the role of Business Development Officer at Hajaj & Associates, concurrently joining Century 21-Jeddah and ascending to the CEO position in under a year. Under his guidance, Century21-Jeddah soared to unprecedented sales achievements. His innovative approaches and the company's robust expansion led to his appointment as CEO of Hajaj & Associates in early 2015.\n\nIn his tenure as CEO, Falih oversaw a real estate portfolio worth over $2 billion and managed projects under development valued at an additional $1 billion. He also founded an investment entity for Hajaj & Associates, overseeing direct investments both domestically and internationally.\n\n2019 saw Falih assuming the role of CEO at Dallah AlBaraka's Amam Real Estate, a new venture in real estate management and development. He led the re-development of Durrat AlArous and spearheaded multiple projects across the kingdom, enhancing the company's portfolio.\n\nReturning to Hajaj & Associates in 2022 as Managing Director after becoming an alumnus of Harvard Business School, Falih aimed to devise and execute a forward-thinking strategy centered on job creation, sustainability, and supporting Saudi Vision 2030. This vision focuses on transforming the kingdom’s economy through diversification and development in sectors such as residential, tourism, infrastructure, and now hospitality.\n\nAdditionally, Falih serves as the CEO of Tashyid Urban Development, further contributing to the realization of Saudi Vision 2030 by facilitating advancements in residential living, tourism, and infrastructure development, with an expanded focus on hospitality, enriching the kingdom's offerings in this vital sector.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2MDc5MA==",
                                    "title": "TenX Leadership Talks: Evaluating the Shift to Mid-Market Hotel Development in Saudi Arabia",
                                    "beginsAt": "2024-04-30 16:15:00",
                                    "endsAt": "2024-04-30 16:30:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Faisal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjAzOTI4LFVzZXJfMTYxNzMyMTIp",
                "jobTitle": "DMC General Manager",
                "lastName": "Al Bassam",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5ca1753737c44b2ca30d48ce719ff535.jpeg",
                "organization": "Baheej",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Daniela",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ4OTE5LFVzZXJfODc5MzcyOSk=",
                "jobTitle": "Global Business Development Director",
                "lastName": "Wagner",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fb8d2368d05d47a8a87f2a636653a2c0.jpeg",
                "organization": "Jacobs Media",
                "biography": "Her leadership focuses on facilitating opportunities for both UK businesses looking to expand globally and global destinations targeting the UK travel trade. She is also an established leader in the field of resilience and crisis management, acting as the business development director for the Global Travel and Tourism Resilience Council.\n\nWith a proven record of achievement and extensive contacts in the travel industry, Daniela brings valuable experience from both large corporate and start-up environments, consistently delivering commercial success.\n\nBefore joining Jacobs Media in 2014, Daniela delivered her expertise to respected brands such as WTTC, PATA, Octopus Travel, and eWaterways.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [],
        "priority": 2
    },
    {
        "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:15:00",
        "endsAt": "2024-05-01 10:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Alessandra",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzk4ODMyLFVzZXJfMTkzMzQ1NDQp",
                "jobTitle": "President",
                "lastName": "Priante",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b0805fdb5e41489b92f167c336021bba.jpeg",
                "organization": "Italian National Tourist Board",
                "biography": "Alessandra is an Economist with extensive international and diplomatic experience, she served as Director for Europe at the United Nations Agency for Tourism (UN Tourism), being the first woman and first Italian in the agency's history to hold such a prestigious position. In this role, she managed the agency's most significant region, comprising 43 Member States representing 51% of the global tourism market. During her tenure, she enhanced Member States' satisfaction by introducing dynamic and effective projects and work methods, engaging the global private sector significantly, thus contributing to increased financial contributions to the agency.\n\nAlessandra also adeptly managed the pandemic period - the most severe crisis for the global tourism sector - spearheading impactful initiatives such as the Global Tourism Crisis Committee and various global technical committees, positioning UN Tourism at the heart of European and global institutions. During this productive professional period, she positioned Italy at the center of global initiatives, from the global communication campaign for tourism recovery (#RestartTourism) launched on July 1, 2020, in Rome, to the organization of the first World Summit of Youth on Sustainable Tourism in Sorrento.\n\nShe is a graduate of Bocconi University in Business Economics, with two Master degrees including an executive MBA from Luiss Guido Carli University, fluent in six foreign languages (bilingual in Italian and English) and with a great passion for the public sector, she resumed the reins of the national tourism policy in 2015 after an exceptional five-year diplomatic mission in the Persian Gulf as a special envoy of the Government. The diplomatic project, that she herself conceived, aimed at promoting Italy's cultural and educational heritage in the UAE, Oman, Qatar, Kuwait, and Bahrain. The mission stemmed from Alessandra's excellent results achieved in the early 2000s in the field of cultural heritage and audiovisuals, where she served as head of studies and international relations.\n\nUpon her return, she quickly restored Italy to a central position in key international platforms, from UNWTO (World Tourism Organization) to OECD, Europe, and the BlueMed, Eusair, and Eusalp strategies. As an expert in policy, particularly in economic and financial analysis, Alessandra coordinated the construction of a robust national database and contributed to the drafting of the national strategic plan 2017-2020, governance reforms, and the challenging transition of tourism from culture vs. agriculture in 2018. In addition to this demanding role with the government in 2018-2019, she served as head of international relations and protocol at MiPAAFT.\n\nAuthor of numerous publications, she has taught at various Italian universities and is currently an associate professor at Luiss Business School and a Research fellow at the Corporate Strategy Research Center at Luiss Guido Carli University. She is passionate about music, cinema (also a member of the European Film Academy), art, and good cuisine. She loves her work, reading, traveling, her family, friends, and AS Roma!",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jules",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDYwLFVzZXJfNDIyODQzNik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ugo",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
                "organization": "Lotus",
                "biography": "As CEO, Jules has built LOTUS to become one of the most recognised, globally renowned marketing and communications specialists in the travel, hospitality and lifestyle space.\n\nWith over 25 years' experience Jules has led global campaigns for flagship airlines, the world’s largest outbound tourism destinations and international hospitality brands.\nWith offices in New York, Singapore and headquarters in London the footprint expanded in 2023 to add hubs in Jeddah and Riyadh serving the expanding Saudi Arabian and wider GCC tourism market.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                                    "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 10:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTgzMDQzMA==",
        "titleTranslations": [
            {
                "value": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:20:00",
        "endsAt": "2024-05-01 10:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/DkLXTVh93QQ?si=YGfzC4iAfumC2tB9\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Reem",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ4MTEwLFVzZXJfMTkxMjY5Nzkp",
                "jobTitle": "Partner- KSA Consulting & Valuation",
                "lastName": "Garash",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5bde145a692341bb8fa8ad92e96aa07e.jpeg",
                "organization": "HVS",
                "biography": "Reem is a partner in HVS Saudi. She has extensive experience, innovative spirit, and commitment to excellence.​\nReem's mission is to deliver excellence and creating value for customers, partners, and stakeholders while expanding the hospitality business's presence. Notably, she successfully restructured Shada, a family-owned business, establishing its hospitality division and securing substantial assets worth approximately SR 550 million.​\nReem holds a bachelor's degree in Banking and Finance and an MBA from Queens University of Charlotte, is recognized for her outstanding leadership and visionary approach. Her certification in hotel investment modeling equips her to drive growth and profitability across various hotel brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Moustafa",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDU4OTM1LFVzZXJfMTYwOTUzNzIp",
                "jobTitle": "Partner",
                "lastName": "Said",
                "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
                "organization": "Wisefields Law",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Elie",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MjgzNDY0LFVzZXJfMTQ1Mzg3MCk=",
                "jobTitle": "Vice President Development ME, Cyprus, Greece & Pakistan",
                "lastName": "Milky",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Elie heads expansion opportunities and leads Radisson Hotel Group’s strategic growth and hotel portfolio in the Middle East region as well as Pakistan, Cyprus and Greece. His responsibility is to grow the Group’s regional portfolio to 150 hotels and 30,000 keys by 2030 across each of Radisson Hotel Group’s core brands: Radisson Collection, Radisson BLU, Radisson, Radisson RED, Park Inn by Radisson, Radisson Individuals, art’otel and prizeotel.\n\nA Lebanese national, Elie has 15 years’ experience in development and asset management with international hospitality consultants, as well as a global hotel operator. He was formerly part of the HVS team based in London and in Dubai, where his focus was on conducting feasibility studies, valuations, ROI analyses and strategic advice. He joined Radisson Hotel Group in 2010 as Development Manager quickly rising to his current VP role within the organisation. His ability to forge enduring cross-cultural relationships has proven to be a key attribute in a career that has included mandates for Europe, the Middle East and Africa.\n\nElie’s strengths lie in his ability to execute strategic agreements for new-build and conversion opportunities while forging strong relationships with new and existing owners. He is adept at assessing market conditions and gathering intelligence, turning single asset and portfolio opportunities into business.\n\nElie has an MBA in International Hospitality Management specialising in Hotel Real Estate and Finance from the renowned IMHI – ESSEC Business School in Paris and a BA in Hospitality Management & Tourism from Notre Dame University in Lebanon.\n\nA passionate hotelier, Elie began his career 20 years ago in hotel operations immersing himself in all facets of hotel management before specialising in hotel real estate, finance and development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTg2OTMzMQ==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talks: Embracing Holistic Living: Exploring Sustainable Solutions for Urban Lifestyles",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:20:00",
        "endsAt": "2024-05-01 10:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/QDL-UHp1wic?si=0-O4bSPzE9Pj5fkP\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Jana Bader,</strong> Advisor, The Bench</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gautam",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDEzNDIxLFVzZXJfNjgzOTAwMik=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Sashittal",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/b50fd85b20e5475c83c076a6890d01f8.jpeg",
                "organization": "King Abdullah Financial District Development & Management Company (KAFD DMC)",
                "biography": "Gautam has been the CEO of the King Abdullah Financial District Development & Management Company (KAFD DMC) since 2021 where he has been transforming the district into a business and lifestyle destination with state-of-the-art physical and digital infrastructure.\n\nHis distinguished career has seen him work in both the private and public sectors across diverse industries including oil and gas, real estate development, Free Zone regulation and development, trade facilitation and healthcare.\n\nAfter a career at Shell, spanning nearly two decades, he has held a range of leadership roles in companies across the Middle East. From 2014 to 2019, Gautam was CEO of the Dubai Multi Commodities Centre (DMCC), the business interests of which cover the DMCC Free Zone, property and community development, establishing standards for and facilitating commodities trade in Dubai, as well as financial services such as clearing house and trade finance products.\n\nFollowing his role at the DMCC, he supported the largest hospital startup in Abu Dhabi: a joint venture between the Mayo Clinic (USA) and Abu Dhabi Health Services (SEHA).\n\nIn addition, he serves on numerous boards including UNOPS, Copenhagen, where he is a Member of the Audit Advisory Committee. Gautam has also been named on Forbes’ top 50 Indian Business Executives list and was recently recognized by Construction Week among the top 30 influential leaders in the construction industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMzMQ==",
                                    "title": "TenX Leadership Talks: Embracing Holistic Living: Exploring Sustainable Solutions for Urban Lifestyles",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jana",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDI4MzgxLFVzZXJfMTMwMzE5Nzcp",
                "jobTitle": "Advisor",
                "lastName": "Bader",
                "photoUrl": "https://static.swapcard.com/public/images/c7a4cf6c87574c7cb8a30a99afcb55e2.png",
                "organization": "the bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMzMQ==",
                                    "title": "TenX Leadership Talks: Embracing Holistic Living: Exploring Sustainable Solutions for Urban Lifestyles",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:35:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDMwNA==",
                                    "title": "Unlocking the culinary potential of Saudi’s secondary and tertiary cities - helping Saudis discover Saudi through the power of culture and food",
                                    "beginsAt": "2024-04-29 11:30:00",
                                    "endsAt": "2024-04-29 11:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwNg==",
        "titleTranslations": [
            {
                "value": "FHS Awards - Winner Announcement",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:35:00",
        "endsAt": "2024-05-01 10:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/6qzAi2UTksk?si=OXGDF5lI1mHMJpil\" target=\"_blank\">Click here to watch online</a></p><p>AWARDS:</p><p>Leaders of Tomorrow</p><p>Winner of the Start-Up Den </p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aseel",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzMwOTc0LFVzZXJfMTU5MjQ5MjMp",
                "jobTitle": "Hotel Talent Development Manager",
                "lastName": "Bondagjy",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3fffa064c5cd4e428752d3e1d7a8a0b9.jpeg",
                "organization": "NEOM",
                "biography": "Aseel’s passion is to inspire young Saudis; to encourage, and motivate them to embrace a career in hospitality, her role at NEOM (Saudi Arabia’s visionary Giga project on the Red Sea coast) aligns perfectly with this. As part of the Hotel Development team, Aseel is responsible for driving the development and implementation of its workforce development strategy, which is aimed at creating an empowered and competent pipeline of future leaders in hospitality. \nA fluent English speaker with Arabic as her mother tongue, Aseel holds a bachelor’s degree in business administration and a master’s degree in Hospitality and Tourism Management from Ken State University where she was recognized with the International Alumni Award, which is bestowed to students who have gained global recognition in their respective fields.\n\nApart from her international credentials, Aseel also has a deep understanding of the region, having previously worked in Dubai and Abu Dhabi. She was also part of the inaugural cohort of post graduate employees at NEOM which saw only ten high potential candidates selected from more than 12,000 applicants.\n\nAseel began her career at NEOM within its tourism department, making significant contributions towards its tourism strategy by developing a variety of marketing collateral including compelling audio and visual campaigns. She is now a ‘Rising Star’ in NEOM’s Hotel Development business unit having recently been awarded as such at the inaugural ‘Leaders in Hospitality Awards KSA’ held by Hotel & Catering News Middle East.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Muteb",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzY1Njk2LFVzZXJfMTkyNjQ0MDIp",
                "jobTitle": "Section Head, Organization Development",
                "lastName": "Bin Jumaiah",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/f6fc97b946ab4007ac44c3a895c2f747.jpeg",
                "organization": "Taiba Investments",
                "biography": "Muteb Jumaiah is a distinguished leader in Human Resources, currently serving as the Section Head of Organization Development at Taiba Investments in Riyadh. His expertise in strategic HR management has significantly enhanced organizational efficiency and culture.\n\nPrior to the merger, Muteb managed the merger transaction internally between Dur and Taiba Investment Co., overseeing the daily implementation of the project within an institutional framework. He was responsible for coordinating various components of the program and managing the entities involved, both internally and externally. His role also included managing risks and challenges and providing critical recommendations to the Steering Committee.\n\nFollowing the merger, Muteb has been instrumental in leading culture integration efforts, ensuring a seamless blend of corporate cultures and enhancing employee alignment with the new organizational goals. His strategic oversight continues to strengthen retention and competitiveness across the company.\n\nHolding a Bachelor’s Degree in Political Science and Government from St. Edward's University and a CIPD Level 5 Diploma in Human Resources Management, Muteb is further accredited as a KPI Professional, underscoring his expertise in performance management.\n\nMuteb's dynamic leadership and strategic perspective are fundamental in propelling the evolution of HR practices and instigating impactful industry-wide improvements.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MDk5MQ==",
        "titleTranslations": [
            {
                "value": "Coffee Break",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 10:45:00",
        "endsAt": "2024-05-01 11:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
        "titleTranslations": [
            {
                "value": "Speaker’s Corner: From Setbacks to Triumphs",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 11:00:00",
        "endsAt": "2024-05-01 12:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/6zJsy1MrXKY?si=282em49L3vbrjnpd\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daniela",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ4OTE5LFVzZXJfODc5MzcyOSk=",
                "jobTitle": "Global Business Development Director",
                "lastName": "Wagner",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/fb8d2368d05d47a8a87f2a636653a2c0.jpeg",
                "organization": "Jacobs Media",
                "biography": "Her leadership focuses on facilitating opportunities for both UK businesses looking to expand globally and global destinations targeting the UK travel trade. She is also an established leader in the field of resilience and crisis management, acting as the business development director for the Global Travel and Tourism Resilience Council.\n\nWith a proven record of achievement and extensive contacts in the travel industry, Daniela brings valuable experience from both large corporate and start-up environments, consistently delivering commercial success.\n\nBefore joining Jacobs Media in 2014, Daniela delivered her expertise to respected brands such as WTTC, PATA, Octopus Travel, and eWaterways.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMQ==",
                                    "title": "Destination Tomorrow",
                                    "beginsAt": "2024-05-01 10:15:00",
                                    "endsAt": "2024-05-01 11:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Yann",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzY1MDMyLFVzZXJfMTkzMTc0NDUp",
                "jobTitle": "CEO",
                "lastName": "Callaert",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/df060694a5bb4b8fa4b40f7907847040.jpeg",
                "organization": "Daniel Ost Group",
                "biography": "Yann Callaert is the CEO of Daniel Ost, one of the world's most prestigious flower houses, known for its exquisite designs and innovative approach to luxury floral events and retail. Yann blends his background in business management with his passions for luxury retail, events, art, and design.\n\nA graduate of Karel de Grote Antwerp University with a Bachelor's degree in International Business, Yann's early career was marked by numerous international internships and leadership as the captain of the university rugby team. His professional journey started at TrustedFamily, a high-profile consulting firm focused on family businesses. There, he was responsible for the strategic partnerships and he engaged with some of the world's most affluent families, further honing his expertise in business strategy and client relations.\n\nIn 2014, Yann joined Daniel Ost. Now as CEO, he has been instrumental in expanding the business while maintaining its commitment to creativity and quality. His strategic vision focuses on nurturing the brand's legacy alongside fostering innovation. Currently, Daniel Ost operates globally, with a local presence in Europe and the Middle East.\n\nBeyond his professional pursuits, Yann is deeply committed to community service and leadership. He is an active member and former leader within Round Table International and a founding board member of the Friendship Fund Foundation. In 2020, Yann was appointed as Honorary Consul for Ecuador in Belgium, where he supports Ecuadorian residents and facilitates international trade and diplomatic efforts.\n\nYann is also a strong advocate for lifelong learning, having completed Vlerick Business School's Executive Management Programme and the executive course on Managing a Luxury Brand at Christie's Education",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Lorelei",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NzAwLFVzZXJfMTg2NjUzMCk=",
                "jobTitle": "Founder & CEO",
                "lastName": "Regragui",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/76a30635a1ac4c9f9ea238fae8fb80dd.jpeg",
                "organization": "StayK",
                "biography": "Lorelei is the MasterKey Keeper (Founder & CEO) of StayK; and a hoteliere at heart.\n\nLaunched in the summer of 2023, StayK is a Dubai-born experience-driven and domestic-focused Online Travel Agency, bridging the gap between staycation-fit hotels and local travelers, with a marketing agency approach in mind.\n\nLorelei started her career in the luxury hospitality industry in 2009, as an F&B Intern at the Hotel de Crillon in Paris, a Rosewood Hotel. After university, she joined Emirates Palace in Abu Dhabi in 2012, as a Rooms Division Intern. Followed by roles in 5 star hotels at Le Bristol Paris as a reservation agent, at Corporate Level at Oetker Collection as a Global E-Commerce Manager piloting the digital strategy for 9 luxury hotels, and heading back to the UAE as a Marketing & Communications Manager at Rosewood Abu Dhabi and at Waldorf Astoria Ras Al Khaimah as an E-Commerce Manager.\n\nHer 360-degree experience in the luxury hospitality industry, the observed market gap and need for a staycation-focused OTA, along with the ever-innovative and dynamic GCC’s tourism landscape, inspired her the idea of StayK, with the desire to leave a positive and high-impact footprint with hoteliers, and to humanize the online booking journey for local travelers.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ulpa",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTU4LFVzZXJfMTc0MjM3MTYp",
                "jobTitle": "Chief Solutions Officer",
                "lastName": "Chauhan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ddf727d59fc44d3d85fa5a868e371b72.jpeg",
                "organization": "Beyond Bamboo",
                "biography": "Ulpa Chauhan is a distinguished executive with over two decades of expertise in the tourism industry. With a career marked by innovation and thought leadership, Ulpa is at the forefront of shaping the future of hospitality. \n\nHaving held a lead training role at British Airways, Ulpa specializes in designing bespoke courses that elevate customer experience and employee performance. Her insights into training methodologies and service excellence have been instrumental in driving success in one of the world's leading airlines.\n \nBeyond her corporate endeavors, Ulpa serves as the CSO of Beyond Bamboo Global, a pioneering company dedicated to revolutionizing the hospitality industry through sustainable practices and innovative solutions. In this role, she is committed to driving forward-thinking strategies that prioritize both environmental stewardship and customer satisfaction.\n\nUlpa is also a respected columnist in trade press, offering valuable insights and perspectives on industry trends and best practices. Her contributions to the discourse on tourism and hospitality have earned her recognition as a thought leader in the field.\n\nAs a TEDx speaker, Ulpa captivates audiences with her engaging talks on topics ranging from customer service to the future of travel. Her ability to inspire and educate through storytelling and expertise has made her a sought-after speaker on both national and international stages.\n\nUlpa holds a Bachelor of Arts in Business Studies with a specialization in Tourism and Hospitality, laying the foundation for her comprehensive understanding of the industry's dynamics and challenges.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohamed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NTcwLFVzZXJfMTgyMDM3NjAp",
                "jobTitle": "CEO & Founder",
                "lastName": "Zhran",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c2a8cb08a8814029b1b5a58cd12a18f7.png",
                "organization": "Tenance",
                "biography": "Mohamed Zahran is a motivated high school student and dedicated entrepreneur, currently serving as the CEO & Founder of Tenace. His journey into the world of business began with a keen interest in rental property management, which he has transformed into a thriving venture through Tenace. With a focus on innovation, Mohamed has led the strategic planning efforts for Tenace, ensuring its mission aligns with future growth opportunities.\n\nIn addition to his entrepreneurial endeavors, Mohamed gained valuable experience through a summer internship at United Oil Services, where he contributed to various projects and grew his understanding of business operations. This experience further fueled his passion for entrepreneurship and provided insights into global business practices.\n\nCurrently a 10th-grade student at the International Programs School, Mohamed balances his academic pursuits with his entrepreneurial ambitions, demonstrating a strong commitment to both his education and his ventures. With a diverse skill set encompassing strategic planning, market research, investor relations, and UI/UX design, Mohamed is poised to continue making waves in the world of business and innovation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
        "titleTranslations": [
            {
                "value": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 11:15:00",
        "endsAt": "2024-05-01 11:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/6BBi0sDBwKw?si=HqfQJ9a29-L_cyM-\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Abdullah",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNzM5LFVzZXJfNjYxNzIzOCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Azhari",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4fdf53d37b004fe1a6d8cdf05e9fdd85.jpeg",
                "organization": "Saudi Icon Company",
                "biography": "Abdullah Azhari, the Founder and CEO of Saudi Icon, boasts a dynamic leadership style forged through a distinguished 16-year career in the fit-out construction and civil engineering realm. His professional journey commenced at Turner Construction in Boston, USA, following the completion of his undergraduate studies in Massachusetts. Returning to his roots, Abdullah contributed significantly to Saud Consult, a premier engineering firm in KSA, before embarking on the transformative journey of establishing Saudi Icon.\n\nIn his capacity as CEO, Abdullah Azhari stands at the helm of pivotal corporate decisions, operational management, and serves as the crucial liaison between the Board of Directors and Corporate Operations. Charting the strategic course of the company, he executes plans that realize both short and long-term objectives, enhance cost-efficiency, and foster positive relationships with partners, shareholders, and regulatory bodies. Abdullah exercises adept oversight over business operations, financial performance, and investments, concurrently supervising executives to ensure compliance with policies and legal guidelines. His acumen shines in assessing and resolving challenges, actively elevating the company's public profile through strategic events and speaking engagements.\n\nAbdullah's decade-long stewardship has witnessed the pinnacle of excellence in delivering construction and fit-out projects across the Kingdom. Navigating the delicate balance between comprehensive in-house capabilities and a streamlined organizational structure, he has molded Saudi Icon into one of the Kingdom's most esteemed design and build companies, specializing in high-end fit-out and the efficient delivery of fast-track construction projects. Abdullah's visionary leadership extended to the establishment of various business units under the SI umbrella, such as SI Wood Works Factory for joinery works, MonoLine for aluminum works, and Hi-Tech for metal works. Additionally, strategic partnerships have been forged, contributing significantly to SI's competitive advantage across all operational facets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hitesh",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MzA3NjE1LFVzZXJfMTU3MTA0MjMp",
                "jobTitle": "Senior Director Development – KSA and Kuwait",
                "lastName": "Gandhi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c973b4119d9647b4b6d471b683fb3e8a.png",
                "organization": "Marriott International",
                "biography": "As Senior Director Development for KSA & Kuwait at Marriott International, Hitesh spearheads the expansion of Marriott brands in Saudi Arabia and Kuwait, focusing on new hotel developments and conversions.\n\n\nWith over 12 years of hospitality industry experience, Hitesh has held roles in hospitality advisory and development. Before joining Marriott in 2022, he spent three years at InterContinental Hotels Group in Dubai, leading brand development for Saudi Arabia. Prior to that, he spent almost a decade at HVS in Dubai, where he led over 200 operator search, feasibility, and valuation assignments across 33 countries.\n\n\nHitesh's broad connections and strong market standing, cultivated over a decade in the region, have empowered him to establish a robust knowledge base in hospitality development and guide hotel owners in their investment endeavors. Additionally, he has overseen the expansion and advancement of global hotel brands in key markets throughout the Middle East and Africa.\n\n\nHolding a BSc in Hospitality Management from the Emirates Academy of Hospitality Management in Dubai, Hitesh brings a strong educational background to his wealth of industry experience.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Turab",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MDM1MjE4LFVzZXJfMTU3NTczMzIp",
                "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure - MENA",
                "lastName": "Saleem",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e8f6578826434c8cbc89db951fa9a9e2.jpeg",
                "organization": "Knight Frank",
                "biography": "An accomplished and meticulous professional with 22 years of proven success record in various aspects of the hospitality industry including Asset Management, Hotel Development, Tourism Development, Restaurant Development/Management, Hotel Management and Project Management. With Master’s in hospitality from NYU and Bachelor’s in Hotel Management from Swiss Hotel Institute, his consulting experience includes projects with a value of approximately USD 64  Billion. He has worked in various continents including Europe, US and the Middle East holding senior positions. He has been involved in consulting some of the successful Hospitality projects globally including :-   Paris, Miami, New York, London, Hong Kong, Dubai, Riyadh, Doha particularly with major hotel and consultancy groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0Ng==",
                                    "title": "Digital Talks: The Hotel of the Future",
                                    "beginsAt": "2024-04-30 09:50:00",
                                    "endsAt": "2024-04-30 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Adel",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5NjA1NjI0LFVzZXJfMTU3NTcyOTcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Ezzat",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/7281fa04e79d44e0b7a2f6d4c7dec072.jpeg",
                "organization": "Elaf Group",
                "biography": "A visionary leader with a distinguished career spanning more than 25 years, Dr. Adel Ezzat currently serves as the Chief Executive Officer of Elaf Group.\n\nDr. Ezzat leverages his extensive experience in operations, marketing management, and sustainable organizational growth to steer the group’s strategic direction, which is closely aligned with Vision 2030’s roadmap for economic diversification and the development of the travel and tourism sector.\n\nPrior to joining Elaf Group, Dr. Ezzat served as President & Chairman of the Saudi Arabian Football Federation. He has also held a number of senior positions with leading organizations including Chief Executive Officer of Saudi Paper Group, Managing Director of Hyundai & Genesis at Mohamed Yousuf Naghi Motors Hyundai, and Managing Director of the Toyota Business at Abdul Latif Jameel Group. Earlier in his career, he worked at Procter & Gamble for eight years where he honed his skills in the areas of operations management, human resources, supply chain management, and marketing.\n\nDr. Ezzat’s remarkable progression throughout his working life demonstrates a strong commitment to professional and personal growth that has enabled him to successfully increase profitability, oversee multiple projects to the highest standards, and lead teams towards exceptional performance.\n\nHe holds a PhD in Marketing from Paris University, a master’s degree in Business Administration from Manchester University, and a master’s degree in Marketing from Nottingham Trent University, together with a bachelor’s degree in Electrical Engineering from King Abdulaziz University.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
        "titleTranslations": [
            {
                "value": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 11:15:00",
        "endsAt": "2024-05-01 11:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/FFB_E_s0Z34?si=bj4sPDcAj5sZ44mS\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gaurav",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ3NjA0LFVzZXJfMTQzNjUzMSk=",
                "jobTitle": "CEO",
                "lastName": "Sinha",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/90fc35e1480c41078f9fcdb37669236e.jpeg",
                "organization": "Insignia Worldwide",
                "biography": "Gaurav is the CEO and Chief Strategist of Insignia Worldwide, a category-defining design, development, and experience company specializing in nation-building initiatives. \nWith over 30 years of global experience, Gaurav has steered strategy and design projects across different sectors including luxury hospitality, tourism, arts and culture, leisure, retail and entertainment, and real estate development.\n\nGaurav has provided his services to some of the world’s most revered hospitality companies and shaped the narrative for globally renowned brands across 20 countries. His company is also engaged by NEOM, Ministry  of Culture, Red Sea Global, DGDA, Soudah Development Company and numerous other organisations in the Kingdom of Saudi Arabia. \n\nHe is the author of ‘Compassion Inc.’ a critically acclaimed book published by Penguin Randomhouse UK.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                                    "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Pascal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDIwNTg4LFVzZXJfMTAzNTMxMik=",
                "jobTitle": "Chairman & Founder, Maison ELLE",
                "lastName": "Donat",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8192f6a9be2f4362ba9e5760a925238b.png",
                "organization": "President, de Valotel",
                "biography": "For three decades, Pascal Donat has been driving the development ofthe VALOTEL hotel group by implementing his vision in the hospitality world.\n\nA perfect mix of audacity and expertise, always aiming to meet consumer needs and expectations and even anticipate consumers in a rapidly changing time.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                                    "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Yasmine",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwNDYxODI3LFVzZXJfMTgyMzk3MTQp",
                "jobTitle": "Founder & Owner",
                "lastName": "Vanda Trofast",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bc950859492046ad952ecf3bfa045a74.jpeg",
                "organization": "YVT Consultancy",
                "biography": "In the dynamic landscape of the creative economy, Yasmine Vanda Trofast stands out as a seasoned entrepreneur with a remarkable 17-year journey dedicated to fostering creativity and innovation. As the founder of YVT Consultancy, Yasmine has become a driving force in the cultural, creative, and event sectors, leaving an indelible mark on the industry.\n\nEstablished in 2021, YVT Consultancy has swiftly emerged as a sought-after consultancy ﬁrm, catering to prestigious clients such as the Royal Commission for AlUla, Abu Dhabi Government, the Diriyah Gate Development Authority (DGDA), and the Dubai Government. In the past year alone, YVT Consultancy has successfully executed 14 diverse projects, ranging from strategic consultancy to experiential development, communication and design, and operations management.\n\nOne of Yasmine's most notable contributions to the creative landscape is the inception of \"Creative Dialogues\" under the YVT umbrella. This event-based platform serves as a nexus for connecting and supporting creatives across the Arab world. Yasmine has taken the Creative Dialogues on a journey, traversing different cities to explore and interlink their vibrant creative scenes. This initiative not only showcases Yasmine's commitment to fostering collaboration but also highlights her visionary approach to empowering the creative community.\n\nYasmine's impact extends beyond consultancy and events; she has been a catalyst for growth in service of various businesses, ranging from startups and SMEs to government organizations. Her unwavering dedication ensures that her clients develop into their optimal positioning while also gaining a clear competitive advantage within their respective industries.\n\nDriven by an innate passion for the creative economy, Yasmine's career has been marked by successful initiatives spanning ideation, IP portfolio development, marketing communications, digital transformation, and business development negotiations. Her unique blend of skills, coupled with an in-depth agency background, allows Yasmine to bring genuine value to every industry she operates in.\n\nYasmine's inﬂuence is not conﬁned to a speciﬁc geographical region; she has worked with a broad spectrum of clients in the Middle East. Her ability to leverage her extensive experience and skills ensures that YVT Consultancy remains at the forefront of the creative economy, contributing signiﬁcantly to the growth and evolution of the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                                    "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Talks"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
        "titleTranslations": [
            {
                "value": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 11:45:00",
        "endsAt": "2024-05-01 12:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/qEJKONT206I?si=xP-kqhmCDCbJ2kjb\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Michael",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMTc3NDI0LFVzZXJfMTkyMTAxMjAp",
                "jobTitle": "Project Director, Expenditure and Projects Efficiency Authority (Expro)",
                "lastName": "Thorley",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e9bed244849a48be9728bd60edad1cf0.jpeg",
                "organization": "DAR Engineering",
                "biography": "Michael Thorley is a Project Director Dar Engineering currently seconded to Expro : the Expenditure and Project Efficiency Authority.\n\nMichael's extensive experience has spanned across the design, delivery and management of complex, large-scale, and industry-leading projects across the Middle East and Oceania.\n\nHis broad international expertise has been garnered while managing a range of projects delivering high-end design management, multi-disciplinary team leadership, broad-scale construction supervision and large-scale mixed-use developments.\n\n\nHe has a thorough understanding of international best practices related to both design and delivery and has experience leading various stakeholders, consultants and authorities to full and complete project delivery. \n\nHe has previously offered consulting advice to various Government Bodies and has delivered projects for a number of high-profile clients.\n\nMichael is an inclusive project leader and he is focused on providing sustainable, livable, and innovative design solutions to institutional clients and the public they serve.\n\n\nIn his current role, Michael is responsible for the growing team that is supporting the Project Implementation Department, providing assistance with the Efficiency in Project Delivery and Expenditure across Saudi Arabia.\n\n Michael holds a Master of Architecture degree from the University of Western Australia, as well as a Bachelor of Environmental Design from the same institution and is chartered with the Australian Institute of Architects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Elyza",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDQ1NjgxLFVzZXJfNjgyNTQ5NSk=",
                "jobTitle": "Vice President - Architecture, Design & Construction",
                "lastName": "Falzon",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9a5c3f84af374083ba66f43de4cddaac.jpeg",
                "organization": "Hilton Worldwide Services Limited",
                "biography": "Elyza Falzon leads Hilton’s Architecture, Design & Construction team in the Middle East and Africa. The richly diverse, multi-disciplinary team skilfully supports Owners and Developers with the delivery of best-in-class hotels, resorts and residences across the region.\n\nWith twenty years of experience, Elyza is well versed in international hospitality design. Elyza moved to Dubai fifteen years ago and has since gained a broad understanding of global and regional requirements. Prior to Dubai, Elyza lived and worked in Milan, where she kicked off her career as a design consultant collaborating on a range of internationally branded hotels and resorts across Europe and the Middle East.\n\nPassionate and vocal about Women in Leadership, Elyza dedicates time to mentoring the younger generation of leaders in the business.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Nicholas",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NzMwNTk2LFVzZXJfMTgzNDY0OTEp",
                "jobTitle": "Program Director",
                "lastName": "Clark",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/6fc76d7772bc4405b415dd5d61e87837.jpeg",
                "organization": "Compass Project Consulting",
                "biography": "Nicholas is a dynamic leader with a wealth of executive experience, particularly in the construction and transportation sectors. In his role as Program Director, Nicholas has steered the helm of diverse and high-profile projects. Notable achievements include spearheading the development of a hyper-luxury hotel in KSA, contributing to infrastructure projects for NEOM, and leading the regeneration of Central Ar-Riyadh.\n\nNicholas's strategic foresight, paired with exceptional management and motivational skills, has played a pivotal role in propelling organizational development, fostering growth, and facilitating successful decision-making processes. His track record exemplifies a commitment to excellence and innovation in the ever-evolving landscape of construction and transportation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Waleed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MzcyNzA1LFVzZXJfMTYyNTQwNzIp",
                "jobTitle": "Commercial Director",
                "lastName": "M. Abualnadi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/88c841025ae541499e96edae25303cdc.jpeg",
                "organization": "Saudi Icon Company",
                "biography": "Waleed M. Abualnadi serves as the Commercial Director at Saudi Icon, bringing with him a rich professional background immersed in the construction, engineering, and fitout industry spanning nine years. His journey is marked by an unwavering commitment to continuous growth and excellence.\n\n Beginning his career with an engineering internship at Drake & Skull (ICC in KSA), Waleed acquired invaluable hands-on experience. Transitioning to the role of Electrical Engineer at ABEG KSA, he further honed his skills. Since 2016, Waleed has been pivotal in the success of Saudi Icon where he currently holding the position of Commercial Director.\n\n In his multifaceted role, Waleed adeptly manages three critical dimensions—cost analysis, technical documentation, presentations, and day-to-day commercial aspects of projects. His noteworthy contributions to the successful bids for Saudi Icon cannot be understated, helping to deliver high-profile hospitality projects, including the JW Marriott, Four Points Sheraton, Sindalah Hotel Clusters, and the Red Sea Global hotel projects. Beyond hospitality, Waleed has played a significant role in securing various projects in the government, semi-government, and private sectors. \n\nWaleed holds a degree in Electrical and Computer Engineering from the American University of Beirut. Beyond that, he earned his Masters degree from Leeds University in the UK, equipping him with advanced skills in managing engineering/tech business units. Outside the professional sphere, Waleed is a devoted husband and father to two wonderful children, Elyse and Mohammad. The intersection of his personal and professional life is evident through his marriage to a seasoned hotelier, offering a unique perspective on the hospitality industry.\n\n Waleed eagerly anticipates contributing insights and engaging with industry professionals at the Future Hospitality Summit.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0Nw==",
                                    "title": "Data Talks: An Overview of Factors Impacting Hospitality Construction Costs in KSA",
                                    "beginsAt": "2024-04-29 14:20:00",
                                    "endsAt": "2024-04-29 14:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hiba",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5Njc0MzM2LFVzZXJfMTg5MTA0NDcp",
                "jobTitle": "Regional Design & Project Development Manager - Middle East & CIS",
                "lastName": "Araji",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/32247bdf71694f879f984b782f1340c8.jpeg",
                "organization": "Valor Hospitality Partners",
                "biography": "Hiba has 18+ years of design and development experience to include extensive knowledge and a wealth of expertise in architecture and interior design in the Middle East hospitality industry. She holds a Master's degree in building services engineering.\n\nDuring her time working for the hospitality industry, Hiba had led design teams for hotels and mixed-use developments for large international chains across multiple locations in Middle East and North Africa. In addition to luxury 5-star hotels, lifestyle hotels and serviced apartments, Hiba has also led projects for Real Estate developments.\n\nHiba Araji joined Valor Hospitality Partners in 2023 as Regional Design and Project Development Manager for the Middle East and CIS. Recent successes included design concepts for globally branded and private label hotels and serviced residences, ultra-luxury branded real estate projects and niche experiential projects across Saudi Arabia, the United Arab Emirates, Oman, and Pakistan.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwMA==",
        "titleTranslations": [
            {
                "value": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 11:45:00",
        "endsAt": "2024-05-01 12:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Y2jgZEntvf4?si=tXS-S7LwBlCw1vy1\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Linh",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMDIwNTgwLFVzZXJfMTI5ODIwMTEp",
                "jobTitle": "Founder & CEO",
                "lastName": "Vu",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/04f7de3e5c3b474d9573e40c05ddb716.jpeg",
                "organization": "Key Hospitality Consulting",
                "biography": "Linh has been advising hotel Attendeess in South East Asia since 2009 through her company, Key Hospitality Consulting. In her role, she is involved in hotel development, investment strategy, negotiations with hotel operators and education. She led and completed numerous hospitality deals on behalf of her clients with different brands such as Fairmont, Hyatt Place, Novotel, Hilton…\n\nMost recently, she has been assisting one of the major Vietnamese real estate developers with the overall concept of Rach Tram Bay (172 ha) on Phu Quoc island into an eco-conscious destination.\n\nIn 2020, she completed the Harvard Business School program to become a Corporate Director and in January 2021 she was appointed Vice-Chair of the Board of Cityland Education. The first school to be operated under Cityland Education will be the Vocational Education & Training by Ecole Hoteliere de Lausanne (VET by EHL) which aims at delivering Swiss standards of excellence and best practices to Vietnamese students and professionals. As the Vice-Chair, she was in charge of recruiting the other\nboard’s directors, appointing the executive team as well as overseeing corporate governance.\nSince early 2023, she has been part of the International Advisory Board of Maison ELLE, the new lifestyle hotel brand from ELLE magazine. She advises the Chairman on emerging markets, strategic partnerships, and development pipeline.\n\nLinh started her career in hospitality as a developer for Accor but prior to that she had a diverse professional background including positions at an international media agency (NOA) and the United Nations Conference on Trade and Development (UNCTAD).\nLinh was born in Paris from Vietnamese parents and speaks French, English, Vietnamese and Spanish.\n\nShe holds an Executive MBA Global Asia from Columbia Business School, London Business School and Hong Kong University. In 2012, she received the Distinguished Service Award by her MBA classmates and most recently she was appointed as a member of the International Society of Hospitality Consultants (2024).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                                    "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Maya",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5ODEzNTQxLFVzZXJfMTM5NTkxMDQp",
                "jobTitle": "Chief Development Officer Premium, Midscale and Economy Division Middle East, Africa & Turkey",
                "lastName": "Ziade",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/660d55ffc1b24be5a5746988e679b0cc.jpeg",
                "organization": "Accor",
                "biography": "Maya Ziadeh is responsible for the expansion of Accor’s Premium, Midscale and Economy brand portfolio across the Middle East, Africa & Turkey region. \nIn addition to leading and delivering the strategic growth, Maya will focus on expanding the franchise and management business in key markets, alongside identifying strategic partners, and maintaining strong relationships with current owners and partners. \nMaya brings over 20 years of experience in the hospitality industry, with key signings in Saudi Arabia, Egypt, Oman and Kuwait.\n\nPrior to joining the development team of Accor in August 2022, Maya held development positions at InterContinental Hotels Group and Marriott International based in Dubai. \n \nMaya holds a degree in Law from the Lebanese University in Lebanon and certificates from Cornell in Real Estate Investment and Asset Management and Control of Hotel Real Estate.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                                    "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Shaikha",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3OTczNjM5LFVzZXJfMTYzNjA4NDMp",
                "jobTitle": "Corporate Vice President - Owner Relationship Management",
                "lastName": "Al Nowais",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/021971f022ac456db0218fde09ed3808.jpeg",
                "organization": "Rotana",
                "biography": "Shaikha Al Nowais is Corporate Vice President of Owner Relationship Management at Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe, and Turkey. \n\nReporting directly to the Chief Executive Officer, Al Nowais is responsible for strengthening the close working relationships between Rotana and hotel owners by overseeing the effective communication of all the latest developments and initiatives implemented at their properties.\n\nAl Nowais joined Rotana as Director of Internal Audit in May 2011, where she leveraged her considerable knowledge and expertise to maintain consistently high standards and drive improved efficiencies throughout its operations. During her time in this role, she successfully led the internal audit team to ensure that all properties were in full compliance with Rotana’s company policies and procedures, as well as external regulations outlined by UAE Federal Law, the Abu Dhabi Food Control Authority, and the Abu Dhabi Tourism Authority.\n\nPrior to joining Rotana, Al Nowais honed her financial and analytical skills during a two-and-a-half-year tenure at KPMG, where she was responsible for performing audits of financial statements, developing robust audit plans and strategies, and examining internal controls to assess the efficiency of procedures.\n\nShaikha Al Nowais is a graduate of Dubai’s Zayed University, where she attained a Bachelor of Science degree in Business Sciences – Finance in 2006.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                                    "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwNQ==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 12:00:00",
        "endsAt": "2024-05-01 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "exhibition-stage",
                "translations": [
                    {
                        "value": "Exhibition Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "opening-awards-and-signings",
                "translations": [
                    {
                        "value": "FHS Opening, Awards & Signings"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "FHS Opening, Awards & Signings"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkwNzkyMg==",
        "titleTranslations": [
            {
                "value": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 12:15:00",
        "endsAt": "2024-05-01 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/1dU5hq7epHk?si=6AgB62e2l0jg1sKG\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ulpa",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTU4LFVzZXJfMTc0MjM3MTYp",
                "jobTitle": "Chief Solutions Officer",
                "lastName": "Chauhan",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ddf727d59fc44d3d85fa5a868e371b72.jpeg",
                "organization": "Beyond Bamboo",
                "biography": "Ulpa Chauhan is a distinguished executive with over two decades of expertise in the tourism industry. With a career marked by innovation and thought leadership, Ulpa is at the forefront of shaping the future of hospitality. \n\nHaving held a lead training role at British Airways, Ulpa specializes in designing bespoke courses that elevate customer experience and employee performance. Her insights into training methodologies and service excellence have been instrumental in driving success in one of the world's leading airlines.\n \nBeyond her corporate endeavors, Ulpa serves as the CSO of Beyond Bamboo Global, a pioneering company dedicated to revolutionizing the hospitality industry through sustainable practices and innovative solutions. In this role, she is committed to driving forward-thinking strategies that prioritize both environmental stewardship and customer satisfaction.\n\nUlpa is also a respected columnist in trade press, offering valuable insights and perspectives on industry trends and best practices. Her contributions to the discourse on tourism and hospitality have earned her recognition as a thought leader in the field.\n\nAs a TEDx speaker, Ulpa captivates audiences with her engaging talks on topics ranging from customer service to the future of travel. Her ability to inspire and educate through storytelling and expertise has made her a sought-after speaker on both national and international stages.\n\nUlpa holds a Bachelor of Arts in Business Studies with a specialization in Tourism and Hospitality, laying the foundation for her comprehensive understanding of the industry's dynamics and challenges.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Banan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjcxOTQ2LFVzZXJfMTkyNjQ0MTcp",
                "jobTitle": "Researcher (Ph.D. Candidate)",
                "lastName": "Alhazmi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/9a2d716043e0477ea64c365ad7c88eeb.jpeg",
                "organization": "KAUST",
                "biography": "Banan Alhazmi is a Ph.D. candidate in Environmental Science and Engineering at King Abdullah University of Science and Technology (KAUST), specializing in sustainable membrane materials and processes. Her research focuses on innovating solutions for resource recovery and capture, driving circular economy principles in critical areas such as the water, chemical, and pharmaceutical industries. With a solid foundation in chemical and biological engineering from Oregon State University (B.Sc.) and KAUST (M.Sc.), she holds a robust background in both academia and industry. During her research internship at Saudi Aramco, she worked on developing polymeric composite materials for applications in the oil and gas industry. As the Public Relations Lead for the Students for Sustainability Organization at KAUST, she plays a critical role in steering student-led initiatives to drive a change toward sustainability aligned with the Sustainable Development Goals. Her dedication lies in integrating and fostering discussions on sustainable frameworks across diverse sectors, particularly in daily practices.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Malinalli",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjcxOTM4LFVzZXJfMTkyNjQ0MTIp",
                "jobTitle": "Ph.D. candidate",
                "lastName": "Ramirez Martinez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c2b05c7122df40f9b950da9b7cae0228.jpeg",
                "organization": "King Abdullah University of Science and Technology",
                "biography": "Malinalli Ramirez Martinez is a Mexican Ph.D. candidate in Environmental Science and Engineering at King Abdullah University of Science and Technology (KAUST), Saudi Arabia. Her current research focuses on implementing sustainable approaches for polymeric membrane manufacturing, which can potentially help reduce the environmental footprint of industrial separation processes. She currently serves as the President of the student organization Students for Sustainability at KAUST, which is dedicated to raising awareness about sustainability and the Sustainable Development Goals within KAUST and beyond through initiatives, events, outreach activities, and awareness campaigns. She was one of the 2022 KAUST BESE Division Dean's Award recipients in recognition of her outstanding academic performance and contributions. She was awarded third place in the poster presentation category at the 2023 KAUST Research Conference on Membranes and Porous Materials for Vision 2030. Malinalli holds an M.Sc. in Environmental Science and Engineering from KAUST and a B.Sc. in Chemical Engineering from Universidad Veracruzana, Mexico.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Simone",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjQ0OTkxLFVzZXJfMTc0MjM3OTEp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Mundy Clowry",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4b87482b6ba34cdd855ee4941808b88f.jpeg",
                "organization": "Beyond Bamboo",
                "biography": "Simone Mundy-Clowry is a seasoned executive with a diverse background in finance, real estate, and sustainable development. With a career spanning from the Chicago Board of Trade to the helm of one of Europe's most ambitious regeneration projects, Simone brings a wealth of experience and insight to the table.\n\n\nBeginning her career in the fast-paced environment of the Chicago Board of Trade, Simone honed her financial acumen and strategic thinking. Her tenure at Knight Dragon, where she held a pivotal role in Europe's largest regeneration project on London’s Greenwich Peninsula, further solidified her reputation as a leader capable of navigating complex challenges with finesse. \n\nSimone's educational journey is equally impressive, holding a Bachelor of Science in Property Economics, a Diploma in Investment, and a Master of Science in Real Estate Finance. This academic foundation, coupled with her hands-on experience, equips her with a multifaceted understanding of the real estate and investment landscape.\n\nCurrently serving as the COO & CFO of Beyond Bamboo Global, Simone is at the forefront of driving sustainable innovation in the hospitality sector. Beyond Bamboo Global is a trailblazing company committed to revolutionizing the hospitality industry through environmentally conscious practices and cutting-edge solutions. Under Simone's leadership, the company is spearheading initiatives that not only redefine standards but also pave the way for a more sustainable future.\n\nAs a thought leader and influencer in both finance and sustainable development, Simone is sought after for her expertise. Her insights into the intersection of real estate, finance, and sustainability make her a valuable voice in shaping the future of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Holkan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzM1MDY4LFVzZXJfNzc2NzUyMik=",
                "jobTitle": "PhD Student",
                "lastName": "Vasquez",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1fc4d5fe0392489988538e7cd51fa741.jpeg",
                "organization": "King Abdullah University of Science and Technology, Saudi Arabia",
                "biography": "Holkan Vasquez is a Ph.D. candidate in Environmental Sciences and Engineering at King Abdullah University of Science and Technology (KAUST) in Saudi Arabia, specializing in the intersection of energy and environmental studies. Holds a Master of Science (M.Sc) in Engineering from Tecnologico de Monterrey, with a thesis that employed Life Cycle Assessment to quantify the environmental impacts of renewable energy sources, such as geothermal energy. Additionally, earned a Master of Business Administration (MBA) with a focus on sustainable development from Universidad del Valle de Mexico. With a foundational background in Mechatronics Engineering from Tecnologico de Monterrey, I am a dedicated young researcher passionate about climate change, circular economy, and sustainable development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Mohamed",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMzU2NTcwLFVzZXJfMTgyMDM3NjAp",
                "jobTitle": "CEO & Founder",
                "lastName": "Zhran",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c2a8cb08a8814029b1b5a58cd12a18f7.png",
                "organization": "Tenance",
                "biography": "Mohamed Zahran is a motivated high school student and dedicated entrepreneur, currently serving as the CEO & Founder of Tenace. His journey into the world of business began with a keen interest in rental property management, which he has transformed into a thriving venture through Tenace. With a focus on innovation, Mohamed has led the strategic planning efforts for Tenace, ensuring its mission aligns with future growth opportunities.\n\nIn addition to his entrepreneurial endeavors, Mohamed gained valuable experience through a summer internship at United Oil Services, where he contributed to various projects and grew his understanding of business operations. This experience further fueled his passion for entrepreneurship and provided insights into global business practices.\n\nCurrently a 10th-grade student at the International Programs School, Mohamed balances his academic pursuits with his entrepreneurial ambitions, demonstrating a strong commitment to both his education and his ventures. With a diverse skill set encompassing strategic planning, market research, investor relations, and UI/UX design, Mohamed is poised to continue making waves in the world of business and innovation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Ng==",
                                    "title": "Speaker’s Corner: From Setbacks to Triumphs",
                                    "beginsAt": "2024-05-01 11:00:00",
                                    "endsAt": "2024-05-01 12:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTkwNzkyMg==",
                                    "title": "Why Gen Z are turning to Sustainable Businesses as their Future Employer?",
                                    "beginsAt": "2024-05-01 12:15:00",
                                    "endsAt": "2024-05-01 13:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTkwNTk4OA==",
        "titleTranslations": [
            {
                "value": "Strategies for Success in Delivering Mega Projects in Holy Cities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 12:25:00",
        "endsAt": "2024-05-01 12:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/IwbPmKFNcE4?si=9EpH0nvDQH6ZAKQZ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "data-and-digital-talks",
                "translations": [
                    {
                        "value": "Talks"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nadeem",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzMwMjI2MTU0LFVzZXJfMTkyMzc0NjUp",
                "jobTitle": "Chief Strategy & EPMO Officer",
                "lastName": "Zaman",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/29306b1391e84768a7cb5e2c0933c6c1.jpeg",
                "organization": "Rua Al Madinah Holding Company",
                "biography": "Nadeem is the Chief Strategy Officer for Rua Al Madinah Holding (a wholly owned PIF company) where he is responsible for Group Strategy & Performance, EPMO and Operational Excellence. Prior to this he was Chief Advisor to the KSA Minister of Investment and instrumental in driving the National Investment Strategy underpinning Vision 203o.\n\nBefore joining the Ministry, Nadeem was the Advisor for Corporate Development and Transformation at Digital Dubai Authority where he managed Strategy, HR, Finance, Procurement, Legal, FM and HSE in addition to overseeing multiple group-wide and city level transformation and digitisation initiatives.\n\nPrior to Digital Dubai Nadeem was CEO of a private family office and has held many senior positions including Group Chief Strategy Officer for GEMS Education and before that various Vice President positions at Dubai World Trade Centre. Prior to moving to the Middle East in 2008 Nadeem was in Consulting and specialised in strategy delivery and business transformation for organisations such as Virgin and the insurance giant Prudential.\n\nNadeem holds a Global Executive MBA from TRIUM (partnership between London School of Economics (UK), Stern School of Business, New York University (USA) and HEC (France). He also holds a B.A (Hons) in Accounting & Financial Management from the University of Essex in the UK. He is a Fellow for both the Institute of Business Consulting and the Association for Project Management. He currently serves as a Board Member and Advisor for multiple companies in KSA and internationally.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNTk4OA==",
                                    "title": "Strategies for Success in Delivering Mega Projects in Holy Cities",
                                    "beginsAt": "2024-05-01 12:25:00",
                                    "endsAt": "2024-05-01 12:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Bilal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDUxNzA1LFVzZXJfMTU3OTQ3NTEp",
                "jobTitle": "Partner",
                "lastName": "Ambikapathy",
                "photoUrl": "https://static.swapcard.com/public/images/5f4b835a223541c384c9fb2bf087024f.jpeg",
                "organization": "Wisefields",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNTk4OA==",
                                    "title": "Strategies for Success in Delivering Mega Projects in Holy Cities",
                                    "beginsAt": "2024-05-01 12:25:00",
                                    "endsAt": "2024-05-01 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                                    "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                                    "beginsAt": "2024-05-01 12:50:00",
                                    "endsAt": "2024-05-01 13:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Khalid",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDUxMDEyLFVzZXJfNDQxNzA0MSk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Al-Amoudi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/45cc221faaec46ebbc2dc1a350278825.jpeg",
                "organization": "Jabal Omar Development Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNTk4OA==",
                                    "title": "Strategies for Success in Delivering Mega Projects in Holy Cities",
                                    "beginsAt": "2024-05-01 12:25:00",
                                    "endsAt": "2024-05-01 12:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Talks"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYwOA==",
        "titleTranslations": [
            {
                "value": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 12:50:00",
        "endsAt": "2024-05-01 13:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/tj4UNJk6YG8?si=du_3LlZ4kJ3ez1Bd\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "heritage-and-tourism",
                "translations": [
                    {
                        "value": "Culture & Heritage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Shaji",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4NjE4MjMxLFVzZXJfMTU4NTc0OTQp",
                "jobTitle": "Vice President - Business Development & Growth",
                "lastName": "Abu Salih",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/8714f4577ed749f5ad80b658e0190a19.jpeg",
                "organization": "Shaza Hotels",
                "biography": "Shaji leads the Business Development at Shaza Hotels, where he oversees the new Developments and Portfolio Growth of the company for three brands, namely Shaza, Mysk by Shaza and Mysk Touch. He also heads the Sales, Revenue and marketing strategies for the operating & upcoming hotels. Shaji has been a part of the Shaza family since the brand's inception in 2009, before which he spent several years with Kempinski Hotels in various Sales & Marketing roles. He also holds an MBA from NEOMA Business School in France in Hospitality & Tourism Management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                                    "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                                    "beginsAt": "2024-05-01 12:50:00",
                                    "endsAt": "2024-05-01 13:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Bilal",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI5MDUxNzA1LFVzZXJfMTU3OTQ3NTEp",
                "jobTitle": "Partner",
                "lastName": "Ambikapathy",
                "photoUrl": "https://static.swapcard.com/public/images/5f4b835a223541c384c9fb2bf087024f.jpeg",
                "organization": "Wisefields",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTkwNTk4OA==",
                                    "title": "Strategies for Success in Delivering Mega Projects in Holy Cities",
                                    "beginsAt": "2024-05-01 12:25:00",
                                    "endsAt": "2024-05-01 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                                    "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                                    "beginsAt": "2024-05-01 12:50:00",
                                    "endsAt": "2024-05-01 13:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hassan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI4MjUwNzUyLFVzZXJfMTQzNjQ4NSk=",
                "jobTitle": "Chief Hospitality Operations Officer",
                "lastName": "Ahdab",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/29735f117d6442c9a838312bceeeee9e.jpeg",
                "organization": "Taiba Investments",
                "biography": "Hassan Alahdab is the Chief Hospitality Operations Office at Taiba Investments, a leading Saudi-based company with a track record of investing in and developing real estate properties with strategic projects in the city’s central region. He oversees operations and aligns the company’s overall vision with the growth of a diverse investment portfolio, including operating hotels and those currently under development across Saudi Arabia.\n\nFormerly the President of Hotels Operations for Dur Hospitality, Alahdab played a pivotal role in seamlessly integrating Dur Hospitality's elaborate network into Taiba Investments’ expansive portfolio. While working with Dur, he orchestrated the company’s expansion and the rollout of its leading home-grown brands, including Makarem and Nur by Makarem, while also managing its global partnerships with global hotel groups.\n\nBeginning his career in 1979, Alahdab possesses over 35 years of rich experience in hospitality and has thereby been recognized as a stalwart and one of the most progressive and energetic leaders in the industry.\n\nBefore his current role, Alahdab held several significant positions in the finance and operations sectors, including CEO at Retaj Hospitality Group – Doha, Vice President and Regional Director for Africa & Indian Ocean Operations for Starwood Hotels & Resorts, Managing Director on assignment in Seychelles, General Manager for Le Meridien Libreville - Gabon, Complex Manager of Le Méridien l’Habitation and Le Domaine de Longvilliers - Saint Martin, as well as Area General Manager of Le Méridien Hotels in the Caribbean & French West Indies.\n\nIn 20233, he was nominated The World’s Leading Travel Personality @ 2022 World Travel Award event – Muscat / Oman. Also, he was ranked 16th and 21st respectively in 2020 and 2019 in the top 50 Hoteliers Leaders in the Middle East (Hoteliers Middle East). Hassan has been a Member of AHIC – FHS Advisory Board - Future Hospitality Summit since 2018.\n\nHassan Alahdab is also active in federating industry’s peers and in 2024, he was elected to become the Chairman of IHG Owners Association for IMEA region. Previously he was elected the President - Seychelles Hotels Associations from 1986-1991; Secretary General & co-founder Association des Professionnels du Tourisme du Gabon “Destination Gabon” from 1993-1995 and President St. Martin Hotels Association – AHSM from 1996-1998.\n\nComplimenting his multi-faceted skills in hotel operations and management, Alahdab holds a bachelor’s degree in economics, Commerce & Accounts Management from Damascus University. He also received the CEHMI (Geneva) honorary title – Executive Doctor for International Relations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwOA==",
                                    "title": "ENSURING THE LONG-TERM VIABILITY OF RELIGIOUS TOURISM",
                                    "beginsAt": "2024-05-01 12:50:00",
                                    "endsAt": "2024-05-01 13:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Culture & Heritage"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTc1MDYxMw==",
        "titleTranslations": [
            {
                "value": "Networking Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 13:00:00",
        "endsAt": "2024-05-01 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg5MzkyNA==",
        "titleTranslations": [
            {
                "value": "Closing Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 13:15:00",
        "endsAt": "2024-05-01 13:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://youtu.be/Moxyc5ySS50?si=7CvGsExa6WA9aCho\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xNzM5ODMyLEV2ZW50UGVvcGxlXzI3NTEyMTA5LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman",
                "lastName": "Worsley",
                "photoUrl": null,
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMTg5NDIwMQ==",
        "titleTranslations": [
            {
                "value": "Culinary Tour - Via Riyadh",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 13:45:00",
        "endsAt": "2024-05-01 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>Culinary tour around the following restaurants: </strong>Scott’s, Spago, Raoul’s, chi SPACCA, Gymkhana</p><p><strong>Buses leave from the Registration area of the Prince Sultan Grand Hall.</strong></p><p>Please note you MUST be pre-registered for this culinary tour to attend.</p><br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "restaurant-invest-grif",
                "translations": [
                    {
                        "value": "Restaurant Invest"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Restaurant Invest"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMTg0NjUyOQ==",
        "titleTranslations": [
            {
                "value": "Site Tours",
                "language": "en_US"
            }
        ],
        "beginsAt": "2024-05-01 14:00:00",
        "endsAt": "2024-05-01 18:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>The conference may have ended but you can continue networking by choosing from the following tours:</p><p>1. Diriyah Visit: At Turaif District </p><p>2. The Saudi National Museum, Al Masmak Palace (outside visit only) & Souk Al-Zal</p><p>*Registrations for these tours will be live soon. </p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [],
        "categories": []
    }
]